import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.reduce.js";
import _values from 'lodash/values';
import { defaultBaseCcy, defaultQuoteCcy, isDevelopmentMode, applyTimeZoneOffset, formatNumber, pad2, requiredPositiveNumber, PLATFORM_SETTINGS, formatPrice, formatVolumePercentChange, formatVolume, getMappingForKey, getValue, getMappedKey, getMappedColumns, groupPrices, getVisibleColumns, book as book$1, validateLength, validateDecimals, requiredDate, validateExpiryDate, precision, formatTotal, convertHexToRGBA, copyToClipboard, getDecimalsForSymbol } from '@ufx-ui/utils';
import PropTypes from 'prop-types';
import _isFinite from 'lodash/isFinite';
import i18next from 'i18next';
import _extends$d from '@babel/runtime/helpers/extends';
import _get from 'lodash/get';
import _isFunction from 'lodash/isFunction';
import React__default, { useRef, useEffect, forwardRef, useContext, createContext, useMemo, useState, useCallback, memo, createElement, useReducer, Fragment } from 'react';
import { withContentRect } from 'react-measure';
import { I18nextProvider, useTranslation, Trans } from 'react-i18next';
import cx from 'classnames';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _orderBy from 'lodash/orderBy';
import _debounce from 'lodash/debounce';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { faCircleNotch, faSearch, faAngleUp, faAngleDown, faInfo, faBan, faExclamationCircle, faCheckCircle, faInfoCircle, faExclamationTriangle, faStar, faAngleRight, faCaretDown, faCaretUp, faTimes, faChartLine, faUser, faChevronUp, faChevronDown, faCircle, faSearchMinus, faSearchPlus, faMinus, faPlus, faArrowDown, faArrowUp, faCopy, faSync, faQrcode } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import OutsideClickHandler from 'react-outside-click-handler';
import _includes from 'lodash/includes';
import _keys from 'lodash/keys';
import _pickBy from 'lodash/pickBy';
import _toLower from 'lodash/toLower';
import _isEmpty from 'lodash/isEmpty';
import TooltipTrigger from 'react-popper-tooltip';
import _size from 'lodash/size';
import { AutoSizer, Table as Table$1, Column as Column$1 } from 'react-virtualized';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { isValid, isSameMinute, isSameDay, endOfDay, startOfDay, parse, addDays, add, sub } from 'date-fns';
import _uniqueId from 'lodash/uniqueId';
import DatePicker from 'react-datepicker';
import NumberFormat from 'react-number-format';
import QRCodeUI from 'qrcode.react';
import FocusTrap from 'focus-trap-react';
import { Transition } from 'react-transition-group';
import { createPortal } from 'react-dom';
import { useFormikContext, Field, Form, Formik } from 'formik';
import { object, string, ref, bool, mixed } from 'yup';
import Big from 'bignumber.js';
import _isNaN from 'lodash/isNaN';
import compose from 'lodash/fp/compose';
import _isUndefined from 'lodash/isUndefined';
import { faStar as faStar$1 } from '@fortawesome/free-regular-svg-icons';
import _isEqual from 'lodash/isEqual';
import _filter from 'lodash/filter';
import _reverse from 'lodash/reverse';
import _join from 'lodash/join';
import _indexOf from 'lodash/indexOf';
import _isDate from 'lodash/isDate';
import _isString from 'lodash/isString';
import _slice from 'lodash/slice';
import _groupBy from 'lodash/groupBy';
import _min from 'lodash/min';
import _isBoolean from 'lodash/isBoolean';
import _partition from 'lodash/partition';
import _take from 'lodash/take';
import memoizeOne from 'memoize-one';
import _last from 'lodash/last';
import _map from 'lodash/map';
import _max from 'lodash/max';
import 'lodash/forEach';
import _isNumber from 'lodash/isNumber';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _sortBy from 'lodash/sortBy';
import _toString from 'lodash/toString';
import _capitalize from 'lodash/capitalize';
import _startCase from 'lodash/startCase';
var Intent = {
  NONE: 'none',
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};

var INTENT_TYPES_ARR = _values(Intent);
/* eslint-disable import/prefer-default-export */


var TEXT_ALIGNMENT = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
var DATA_MAPPING = {
  selector: PropTypes.string,
  format: PropTypes.func,
  renderer: PropTypes.func
};
var TRADE_TYPES = {
  MARKET: 'market',
  USER: 'user'
};

var TRADE_TYPES_ARR = _values(TRADE_TYPES);

var TRADE_PAGE_SIZE = 24;
var PROP_GRID_ITEM = {
  component: PropTypes.elementType.isRequired,
  defaults: PropTypes.object,
  // grid default values
  id: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
};
var PROP_GRID_CONFIG = {
  visible: PropTypes.arrayOf(PropTypes.string),
  notVisible: PropTypes.arrayOf(PropTypes.string),
  items: PropTypes.objectOf(PropTypes.shape(PROP_GRID_ITEM))
};
var PROP_LAYOUT_CONFIG = {
  available: PropTypes.arrayOf(PropTypes.shape(PROP_GRID_ITEM)),
  defaultColumns: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.number)),
  defaultLayout: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape(PROP_GRID_ITEM), PropTypes.func]))))
};
var GRID_PADDING_X = 12;
var GRID_PADDING_Y = 8;
var PROP_DEFAULT_CCYS = {
  props: {
    baseCcy: PropTypes.string,
    quoteCcy: PropTypes.string
  },
  defaults: {
    baseCcy: defaultBaseCcy,
    quoteCcy: defaultQuoteCcy
  }
};
var NS = 'ufx'; // modifiers
// alignment

var ALIGN_LEFT = '--align-left';
var ALIGN_RIGHT = '--align-right';
var ALIGN_CENTER = '--align-center'; // size

var SIZE_SMALL = '--small';
/* ui components - start */
// Heading

var HEADING = "".concat(NS, "-heading"); // Label

var LABEL = "".concat(NS, "-label"); // Menu

var MENU = "".concat(NS, "-menu"); // Button

var BUTTON = "".concat(NS, "-button"); // Input

var INPUT = "".concat(NS, "-input"); // Checkbox

var CHECKBOX = "".concat(NS, "-checkbox"); // Dropdown

var DROPDOWN = "".concat(NS, "-dropdown"); // Tabs

var TABS = "".concat(NS, "-tabs"); // Table

var TABLE = "".concat(NS, "-table");
var TABLE_INTERACTIVE = "".concat(NS, "-table--interactive");
var TABLE_STRIPED = "".concat(NS, "-table--striped");
var TABLE_CONDENSED = "".concat(NS, "-table--condensed"); // VirtualTable

var VIRTUAL_TABLE_CONTAINER = "".concat(NS, "-virtual-table--container");
var VIRTUAL_TABLE = "".concat(NS, "-virtual-table"); // Truncate

var TRUNCATE = "".concat(NS, "-truncate"); // Tooltip

var TOOLTIP = "".concat(NS, "-tooltip"); // Sortable Button

var SORT_BUTTON = "".concat(NS, "-sort-button"); // Notifications

var NOTIFICATIONS = "".concat(NS, "-notifications"); // Notice

var NOTICE = "".concat(NS, "-notice"); // Table Wrapper

var TABLE_WRAPPER = "".concat(NS, "-table-wrapper");
/* ui components - end */

/* format components - start */

var FADE_TRAILING_ZEROS = "".concat(NS, "-fade-trailing-zeros");
/* format components - end */

/* other components - start */
// Responsive

var RESPONSIVE = "".concat(NS, "-responsive"); // Spinner

var SPINNER = "".concat(NS, "-spinner"); // QuickSwap

var QUICKSWAP = "".concat(NS, "-quickswap"); // MarketList

var MARKET_LIST = "".concat(NS, "-marketlist"); // Ticker

var TICKER = "".concat(NS, "-ticker"); // TickerList

var TICKER_LIST = "".concat(NS, "-tickerlist"); // Trades

var TRADES = "".concat(NS, "-trades"); // Order History

var ORDER_HISTORY = "".concat(NS, "-order-history"); // Orders

var ORDERS = "".concat(NS, "-orders"); // Book

var BOOK = "".concat(NS, "-book"); // Depth chart

var DEPTH_CHART = "".concat(NS, "-depth-chart"); // Order Form

var ORDER_FORM = "".concat(NS, "-order-form"); // Balances

var BALANCES = "".concat(NS, "-balances"); // Dialog

var DIALOG = "".concat(NS, "-dialog");
var DIALOG_SCROLL_LOCK = "".concat(NS, "-dialog-scroll-lock"); // Grid

var GRID = "".concat(NS, "-grid"); // Deposits

var DEPOSIT_WALLETS = "".concat(NS, "-deposit-wallets");
var MOVEMENT_LIST = "".concat(NS, "-movementlist");
/* other components - end */

/* page/containers - start */

var TRADING = "".concat(NS, "-trading");
var PAGE_HEADER = "".concat(NS, "-page-header");
var PAGE_FOOTER = "".concat(NS, "-page-footer");
var PAGE_LOWER_FOOTER = "".concat(NS, "-page-lower-footer");
var LAYOUT = "".concat(NS, "-layout");
var MOVEMENTS = "".concat(NS, "-movements");
var HELP_BUTTON = "".concat(NS, "-help-button");
var TETHER_TRANSPORT = "".concat(NS, "-tether-transport"); // Deposits

var NEW_CRYPTO_DEPOSIT = "".concat(NS, "-new-crypto-deposit");
var NEW_TETHER_DEPOSIT = "".concat(NS, "-new-tether-deposit");
var NEW_INVOICE = "".concat(NS, "-new-invoice"); // Withdrawal

var WITHDRAWAL_TERMS = "".concat(NS, "-withdrawal-terms");
var WITHDRAWAL_FEES_EXPLAIN = "".concat(NS, "-withdrawal-fees-explain");
var AVAILABLE_BALANCE_BOX = "".concat(NS, "-available-balance-box");
var NEW_WITHDRAWAL = "".concat(NS, "-new-withdrawal");
/* page/containers - end */
// class helper functions

var intentSuffix = function intentSuffix(intent) {
  if (intent == null || intent === Intent.NONE) {
    return undefined;
  }

  return "--".concat(intent.toLowerCase());
};

var alignmentModifier = function alignmentModifier(alignment) {
  switch (alignment) {
    case TEXT_ALIGNMENT.LEFT:
      return ALIGN_LEFT;

    case TEXT_ALIGNMENT.RIGHT:
      return ALIGN_RIGHT;

    case TEXT_ALIGNMENT.CENTER:
      return ALIGN_CENTER;

    default:
      return ALIGN_CENTER;
  }
};

var BREAKPOINTS = {
  XXS: 320,
  XS: 380,
  S: 420,
  SM: 576,
  MD: 768,
  ML: 880,
  LG: 992,
  XL: 1200,
  HG: 1440
}; // $screen - xxs: 320px;
// $screen - xs: 380px;
// $screen - s: 420px;
// $screen - sm: 576px;
// $screen - md: 768px;
// $screen - ml: 880px;
// $screen - lg: 992px;
// $screen - xl: 1200px;
// $screen - hg: 1440px;

var getResponsiveClass = function getResponsiveClass(width) {
  var size;

  if (width <= BREAKPOINTS.XXS) {
    size = 'xxs';
  } else if (width <= BREAKPOINTS.XS) {
    size = 'xs';
  } else if (width <= BREAKPOINTS.S) {
    size = 's';
  } else if (width <= BREAKPOINTS.SM) {
    size = 'sm';
  } else if (width <= BREAKPOINTS.MD) {
    size = 'md';
  } else if (width <= BREAKPOINTS.ML) {
    size = 'ml';
  } else if (width <= BREAKPOINTS.LG) {
    size = 'lg';
  } else if (width <= BREAKPOINTS.XL) {
    size = 'xl';
  } else if (width <= BREAKPOINTS.HG) {
    size = 'hg';
  }

  return size && "".concat(RESPONSIVE, "--").concat(size);
}; // _common.scss classes - start


var SUCCESS_TEXT = "".concat(NS, "-green-text");
var ERROR_TEXT = "".concat(NS, "-red-text");

var getColors = function getColors(value) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _opts$strike = opts.strike,
      strike = _opts$strike === void 0 ? null : _opts$strike,
      _opts$includeStrike = opts.includeStrike,
      includeStrike = _opts$includeStrike === void 0 ? false : _opts$includeStrike;

  if (!_isFinite(value) || !_isFinite(strike)) {
    return '';
  }

  if (value === strike && includeStrike) {
    return SUCCESS_TEXT;
  }

  return value > strike ? SUCCESS_TEXT : ERROR_TEXT;
};

var CENTER = "".concat(NS, "-center");
var RIGHT_TO_LEFT = "".concat(NS, "-rtl");
var DIVIDER = "".concat(NS, "-divider");
var TEXT_MUTED = "".concat(NS, "-text-muted"); // _common.scss classes - end

var classes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ALIGN_LEFT: ALIGN_LEFT,
  ALIGN_RIGHT: ALIGN_RIGHT,
  ALIGN_CENTER: ALIGN_CENTER,
  SIZE_SMALL: SIZE_SMALL,
  HEADING: HEADING,
  LABEL: LABEL,
  MENU: MENU,
  BUTTON: BUTTON,
  INPUT: INPUT,
  CHECKBOX: CHECKBOX,
  DROPDOWN: DROPDOWN,
  TABS: TABS,
  TABLE: TABLE,
  TABLE_INTERACTIVE: TABLE_INTERACTIVE,
  TABLE_STRIPED: TABLE_STRIPED,
  TABLE_CONDENSED: TABLE_CONDENSED,
  VIRTUAL_TABLE_CONTAINER: VIRTUAL_TABLE_CONTAINER,
  VIRTUAL_TABLE: VIRTUAL_TABLE,
  TRUNCATE: TRUNCATE,
  TOOLTIP: TOOLTIP,
  SORT_BUTTON: SORT_BUTTON,
  NOTIFICATIONS: NOTIFICATIONS,
  NOTICE: NOTICE,
  TABLE_WRAPPER: TABLE_WRAPPER,
  FADE_TRAILING_ZEROS: FADE_TRAILING_ZEROS,
  RESPONSIVE: RESPONSIVE,
  SPINNER: SPINNER,
  QUICKSWAP: QUICKSWAP,
  MARKET_LIST: MARKET_LIST,
  TICKER: TICKER,
  TICKER_LIST: TICKER_LIST,
  TRADES: TRADES,
  ORDER_HISTORY: ORDER_HISTORY,
  ORDERS: ORDERS,
  BOOK: BOOK,
  DEPTH_CHART: DEPTH_CHART,
  ORDER_FORM: ORDER_FORM,
  BALANCES: BALANCES,
  DIALOG: DIALOG,
  DIALOG_SCROLL_LOCK: DIALOG_SCROLL_LOCK,
  GRID: GRID,
  DEPOSIT_WALLETS: DEPOSIT_WALLETS,
  MOVEMENT_LIST: MOVEMENT_LIST,
  TRADING: TRADING,
  PAGE_HEADER: PAGE_HEADER,
  PAGE_FOOTER: PAGE_FOOTER,
  PAGE_LOWER_FOOTER: PAGE_LOWER_FOOTER,
  LAYOUT: LAYOUT,
  MOVEMENTS: MOVEMENTS,
  HELP_BUTTON: HELP_BUTTON,
  TETHER_TRANSPORT: TETHER_TRANSPORT,
  NEW_CRYPTO_DEPOSIT: NEW_CRYPTO_DEPOSIT,
  NEW_TETHER_DEPOSIT: NEW_TETHER_DEPOSIT,
  NEW_INVOICE: NEW_INVOICE,
  WITHDRAWAL_TERMS: WITHDRAWAL_TERMS,
  WITHDRAWAL_FEES_EXPLAIN: WITHDRAWAL_FEES_EXPLAIN,
  AVAILABLE_BALANCE_BOX: AVAILABLE_BALANCE_BOX,
  NEW_WITHDRAWAL: NEW_WITHDRAWAL,
  intentSuffix: intentSuffix,
  alignmentModifier: alignmentModifier,
  BREAKPOINTS: BREAKPOINTS,
  getResponsiveClass: getResponsiveClass,
  SUCCESS_TEXT: SUCCESS_TEXT,
  ERROR_TEXT: ERROR_TEXT,
  getColors: getColors,
  CENTER: CENTER,
  RIGHT_TO_LEFT: RIGHT_TO_LEFT,
  DIVIDER: DIVIDER,
  TEXT_MUTED: TEXT_MUTED
});
var DEFAULT_LANG = 'en';
var i18n = i18next.createInstance();

var changeLanguage = function changeLanguage(lang) {
  i18n.changeLanguage(lang);
};

var initialiseI18n = function initialiseI18n(lang, resources) {
  var debug = isDevelopmentMode;
  var i18nConfig = {
    interpolation: {
      escapeValue: false
    },
    // React already does escaping
    lng: lang || DEFAULT_LANG,
    // language to use
    resources: resources,
    debug: debug,
    keySeparator: '.',
    react: {
      useSuspense: false
    }
  };
  i18n.init(i18nConfig);
};

var handleKeyboardEvent = function handleKeyboardEvent(targetKeys, handler) {
  return function (event) {
    var key = event.key;

    if (targetKeys.includes(key)) {
      handler(event);
    }
  };
};

var walletLocaleMap = {
  trading: 'wallets:name.trading_wallet_name',
  deposit: 'wallets:name.deposit_wallet_name',
  exchange: 'wallets:name.exchange_wallet_name',
  contribution: 'wallets:name.contribution_wallet_name',
  creditline: 'wallets:name.credit_wallet_name',
  conversion: 'wallets:name.conversion_wallet_name',
  derivative: 'wallets:name.derivatives_wallet_name'
};

var getNiceWalletName = function getNiceWalletName(name) {
  return i18n.t(walletLocaleMap[name]);
};

var usePrevious = function usePrevious(value) {
  var ref = useRef(); // Store current value in ref

  useEffect(function () {
    ref.current = value;
  }, [value]); // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)

  return ref.current;
};

var withHeightUpdate = function withHeightUpdate(Component) {
  return withContentRect('client')(function (props) {
    var onUpdateLayout = props.onUpdateLayout,
        ref = props.measureRef,
        contentRect = props.contentRect;

    var height = _get(contentRect, 'client.height');

    var prevHeight = usePrevious(height);
    useEffect(function () {
      if (height && prevHeight !== height && _isFunction(onUpdateLayout)) {
        onUpdateLayout(height);
      }
    }, [height, onUpdateLayout, prevHeight]);
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Component, _extends$d({
      ref: ref,
      compRef: ref
    }, props)));
  });
}; // eslint-disable-next-line prefer-arrow-callback


var withI18nProvider = function withI18nProvider(Component) {
  return /*#__PURE__*/forwardRef(function withI18nProviderComp(props, ref) {
    return /*#__PURE__*/React__default.createElement(I18nextProvider, {
      i18n: i18n
    }, /*#__PURE__*/React__default.createElement(Component, _extends$d({
      ref: ref
    }, props)));
  });
};

withI18nProvider.displayName = 'withI18nProvider';
var initialState = {
  isMobile: false
};
var ResponsiveContext = /*#__PURE__*/createContext(initialState);

var ResponsiveState = function ResponsiveState() {
  return useContext(ResponsiveContext);
};

var Responsive = function Responsive(props) {
  var children = props.children,
      measureRef = props.measureRef,
      contentRect = props.contentRect;

  var width = _get(contentRect, 'client.width');

  var height = _get(contentRect, 'client.height');

  var classes$1 = cx(RESPONSIVE, getResponsiveClass(width));
  var isMobile = width < BREAKPOINTS.MD;
  var value = useMemo(function () {
    return {
      isMobile: isMobile,
      width: width,
      height: height
    };
  }, [isMobile, width, height]);
  return /*#__PURE__*/React__default.createElement(ResponsiveContext.Provider, {
    value: value
  }, /*#__PURE__*/React__default.createElement("div", {
    ref: measureRef,
    className: classes$1
  }, children));
};

Responsive.propTypes = {
  children: PropTypes.node.isRequired,
  measureRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(PropTypes.element)
  })]).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  contentRect: PropTypes.object.isRequired
};
var Responsive$1 = withContentRect('client')(Responsive); // eslint-disable-next-line prefer-arrow-callback

var ResponsiveWrapper = function ResponsiveWrapper(Component) {
  return /*#__PURE__*/forwardRef(function ResponsiveWrapperComp(props, ref) {
    return /*#__PURE__*/React__default.createElement(Responsive$1, null, /*#__PURE__*/React__default.createElement(Component, _extends$d({
      ref: ref
    }, props)));
  });
};

var getDefaultSortedData = function getDefaultSortedData(data, sortBy, sortAscending) {
  return _orderBy(data, [sortBy], [sortAscending ? 'asc' : 'desc']);
};

var useSortableData = function useSortableData(data) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var sortData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getDefaultSortedData;

  var _useState = useState(config),
      _useState2 = _slicedToArray(_useState, 2),
      sortConfig = _useState2[0],
      setSortConfig = _useState2[1];

  var sortedData = useMemo(function () {
    if (sortConfig !== null) {
      return sortData(data, sortConfig.key, sortConfig.sortAscending);
    }

    return data;
  }, [data, sortConfig, sortData]);

  var requestSort = function requestSort(key) {
    var defaultSortAscending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var sortAscending = defaultSortAscending;

    if (sortConfig && sortConfig.key === key && sortConfig.sortAscending === sortAscending) {
      sortAscending = !sortAscending;
    }

    setSortConfig({
      key: key,
      sortAscending: sortAscending
    });
  };

  return {
    data: sortedData,
    requestSort: requestSort,
    sortConfig: sortConfig
  };
};

var SORT_CONFIG_PROPS = {
  key: PropTypes.string,
  sortAscending: PropTypes.bool
};

var useInterval = function useInterval(callback, delay) {
  var savedCallback = useRef(); // Remember the latest function

  useEffect(function () {
    savedCallback.current = callback;
  }, [callback]); // Set up the interval

  useEffect(function () {
    savedCallback.current();

    var tick = function tick() {
      savedCallback.current();
    };

    if (delay !== null) {
      var id = setInterval(tick, delay);
      return function () {
        return clearInterval(id);
      };
    }

    return function () {};
  }, [delay]);
};

var useDebouncedCallback = function useDebouncedCallback(callback, delay, options) {
  return (// eslint-disable-next-line react-hooks/exhaustive-deps
    useCallback(_debounce(callback, delay, options), [callback, delay, options])
  );
};

var useDebounce = function useDebounce(value) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var previousValue = useRef(value);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var debouncedCallback = useDebouncedCallback(setCurrent, delay, options);
  useEffect(function () {
    debouncedCallback(value);
    previousValue.current = value;
    return debouncedCallback.cancel;
  }, [debouncedCallback, value]);
  return current;
};

var TEXT_ALIGNMENT$1 = TEXT_ALIGNMENT;
var HEADING_TAGS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6'
}; // eslint-disable-next-line prefer-arrow-callback

var Heading = /*#__PURE__*/forwardRef(function Heading(props, ref) {
  var children = props.children,
      Tag = props.tag,
      className = props.className,
      intent = props.intent,
      alignText = props.alignText,
      rest = _objectWithoutProperties(props, ["children", "tag", "className", "intent", "alignText"]);

  var intentModifier = intentSuffix(intent);
  var classes$1 = cx(HEADING, className, HEADING + alignmentModifier(alignText), _defineProperty({}, HEADING + intentModifier, !!intentModifier));
  return /*#__PURE__*/React__default.createElement(Tag, _extends$d({
    ref: ref,
    className: classes$1 // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), children);
});
Heading.propTypes = {
  /**
   * The children of the Heading.
   */
  children: PropTypes.node.isRequired,

  /**
   * The tag of the Heading.
   */
  // do not use lodash methods/_values to show correct prop-types in storybook props table
  tag: PropTypes.oneOf(Object.values(HEADING_TAGS)),

  /**
   * The className of the Heading.
   */
  className: PropTypes.string,

  /**
   * The intent of the Heading.
   */
  intent: PropTypes.oneOf(INTENT_TYPES_ARR),

  /**
   * The alignment of the text of the Heading.
   */
  alignText: PropTypes.oneOf(Object.values(TEXT_ALIGNMENT$1))
};
Heading.defaultProps = {
  tag: HEADING_TAGS.H2,
  className: null,
  intent: Intent.NONE,
  alignText: TEXT_ALIGNMENT$1.LEFT
};
var LABEL_TAGS = {
  SPAN: 'span',
  DIV: 'div'
}; // eslint-disable-next-line prefer-arrow-callback

var Label = /*#__PURE__*/forwardRef(function Label(props, ref) {
  var label = props.label,
      Tag = props.tag,
      className = props.className,
      uppercase = props.uppercase,
      small = props.small,
      rest = _objectWithoutProperties(props, ["label", "tag", "className", "uppercase", "small"]);

  var classes$1 = cx(LABEL, className, _defineProperty({
    uppercase: uppercase
  }, LABEL + SIZE_SMALL, small));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line no-undef, react/jsx-props-no-spreading
    React__default.createElement(Tag, _extends$d({
      ref: ref,
      className: classes$1
    }, rest), label)
  );
});
Label.propTypes = {
  /**
   * The label of the Label.
   */
  label: PropTypes.node.isRequired,

  /**
   * The tag of the Label.
   */
  // do not use lodash methods/_values to show correct prop-types in storybook props table
  tag: PropTypes.oneOf(Object.values(LABEL_TAGS)),

  /**
   * The className of the Label.
   */
  className: PropTypes.string,

  /**
   * If true, shows the text of the Label in uppercase.
   */
  uppercase: PropTypes.bool,

  /**
   * If true, shows the Label in a small style.
   */
  small: PropTypes.bool
};
Label.defaultProps = {
  tag: LABEL_TAGS.SPAN,
  className: null,
  uppercase: false,
  small: false
};

function Menu(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React__default.createElement("ul", _extends$d({
    className: cx(MENU, className)
  }, props), children);
}

var propTypes = {
  /** Item text, required for usability. */
  text: PropTypes.node.isRequired,

  /**
   * Children of this component will be rendered in a __submenu__ that appears when hovering or
   * clicking on this menu item.
   *
   * Use `text` prop for the content of the menu item itself.
   */
  children: PropTypes.node,

  /**
   * Name of the HTML tag that wraps the MenuItem.
   * @default "a"
   */
  as: PropTypes.string,

  /**
   * A space-delimited list of class names to pass along to the text wrapper element.
   */
  className: PropTypes.string
};
var defaultProps = {
  as: 'a',
  children: null,
  className: null
};

function MenuItem(props) {
  var text = props.text,
      className = props.className,
      Component = props.as,
      children = props.children,
      rest = _objectWithoutProperties(props, ["text", "className", "as", "children"]);

  return /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement(Component, _extends$d({
    className: cx("".concat(MENU, "__item"), className)
  }, rest), text || children));
}

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

function MenuDivider(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return /*#__PURE__*/React__default.createElement("div", _extends$d({
    className: cx("".concat(MENU, "__divider"), className)
  }, props));
}
/* disable 'prefer-arrow-callback' to show component display name when using with forwardRef */
// eslint-disable-next-line prefer-arrow-callback


var Button = /*#__PURE__*/forwardRef(function Button(props, ref) {
  var _cx;

  var id = props.id,
      Component = props.as,
      children = props.children,
      className = props.className,
      style = props.style,
      loading = props.loading,
      disabled = props.disabled,
      _onClick = props.onClick,
      intent = props.intent,
      type = props.type,
      minimal = props.minimal,
      title = props.title,
      small = props.small,
      outline = props.outline,
      rest = _objectWithoutProperties(props, ["id", "as", "children", "className", "style", "loading", "disabled", "onClick", "intent", "type", "minimal", "title", "small", "outline"]);

  var intentModifier = intentSuffix(intent);
  var classes$1 = cx(BUTTON, className, (_cx = {}, _defineProperty(_cx, BUTTON + intentModifier, intentModifier), _defineProperty(_cx, "".concat(BUTTON + intentModifier, "--outline"), outline), _defineProperty(_cx, "".concat(BUTTON, "--minimal"), minimal), _defineProperty(_cx, BUTTON + SIZE_SMALL, small), _cx));
  return /*#__PURE__*/React__default.createElement(Component, _extends$d({
    ref: ref,
    id: id // eslint-disable-next-line react/button-has-type
    ,
    type: type,
    onClick: function onClick(e) {
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      _onClick(e);
    },
    disabled: disabled || loading,
    className: classes$1,
    title: title // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), children, loading && /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleNotch,
    spin: true,
    size: "lg"
  }));
});
var BUTTON_TYPES = {
  BUTTON: 'button',
  SUBMIT: 'submit'
}; // do not use lodash methods/_values to show correct prop-types in storybook props table

var BUTTON_TYPES_ARR = Object.values(BUTTON_TYPES);
Button.propTypes = {
  /**
   * The ID of the Button.
   */
  id: PropTypes.string,

  /**
   * The tag of the Button.
   */
  as: PropTypes.node,

  /**
   * The content of the Button.
   */
  children: PropTypes.node.isRequired,

  /**
   * The className of the Button.
   */
  className: PropTypes.string,

  /**
   * If true, show the loading icon.
   */
  loading: PropTypes.bool,

  /**
   * If true, set the Button to the disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * The function called when the Button is clicked.
   */
  onClick: PropTypes.func,

  /**
   * The intent of the Button.
   */
  intent: PropTypes.oneOf(INTENT_TYPES_ARR),

  /**
   * The type attribute of the Button.
   */
  type: PropTypes.oneOf(BUTTON_TYPES_ARR),

  /**
   * The title attribute of the Button.
   */
  title: PropTypes.string,

  /**
   * If true, shows the Button in a minimal style.
   */
  minimal: PropTypes.bool,

  /**
   * If true, shows the Button in a small style.
   */
  small: PropTypes.bool,

  /**
   * If true, shows the Button in an outline style.
   */
  outline: PropTypes.bool
};
Button.defaultProps = {
  id: null,
  as: 'button',
  className: null,
  loading: false,
  disabled: false,
  onClick: function onClick() {},
  intent: Intent.NONE,
  type: BUTTON_TYPES.BUTTON,
  minimal: false,
  title: null,
  small: false,
  outline: false
}; // eslint-disable-next-line react/jsx-props-no-spreading

var DefaultComp = /*#__PURE__*/memo(Button);
DefaultComp.displayName = 'Button';
var TEXT_ALIGNMENT$2 = TEXT_ALIGNMENT; // eslint-disable-next-line prefer-arrow-callback

var Input = /*#__PURE__*/forwardRef(function Input(props, ref) {
  var type = props.type,
      id = props.id,
      name = props.name,
      value = props.value,
      placeholder = props.placeholder,
      label = props.label,
      className = props.className,
      readOnly = props.readOnly,
      disabled = props.disabled,
      _onChange = props.onChange,
      onBlur = props.onBlur,
      leftElement = props.leftElement,
      rightElement = props.rightElement,
      error = props.error,
      alignText = props.alignText,
      small = props.small,
      rest = _objectWithoutProperties(props, ["type", "id", "name", "value", "placeholder", "label", "className", "readOnly", "disabled", "onChange", "onBlur", "leftElement", "rightElement", "error", "alignText", "small"]);

  var inputValue = value === 0 || value ? value : '';
  var inputProps = {
    type: type,
    placeholder: placeholder,
    readOnly: readOnly,
    disabled: disabled,
    onChange: function onChange(e) {
      return _onChange(e.target.value, e);
    },
    className: cx('input-field', "input-field".concat(alignmentModifier(alignText)), _defineProperty({}, "input-field".concat(SIZE_SMALL), small)),
    autoComplete: 'off',
    value: inputValue,
    name: name,
    id: id,
    onBlur: onBlur
  };
  var isError = !!error;
  return /*#__PURE__*/React__default.createElement("div", _extends$d({
    ref: ref,
    className: cx(INPUT, className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), label && /*#__PURE__*/React__default.createElement(Label, {
    label: label,
    small: small,
    tag: "div"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cx('input-field-container', {
      disabled: disabled,
      'has-error': isError
    }),
    disabled: disabled
  }, leftElement, /*#__PURE__*/React__default.createElement("input", inputProps), rightElement), /*#__PURE__*/React__default.createElement("div", {
    className: cx('error-msg', {
      visible: isError
    })
  }, error));
});
Input.propTypes = {
  /**
   * The type of the Input.
   */
  type: PropTypes.string,

  /**
   * The ID of the Input.
   */
  id: PropTypes.string,

  /**
   * The name of the Input.
   */
  name: PropTypes.string,

  /**
   * The value of the Input.
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * The placeholder of the Input.
   */
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * The label of the Input.
   */
  label: PropTypes.node,

  /**
   * The className of the Input.
   */
  className: PropTypes.string,

  /**
   * The readOnly of the Input.
   */
  readOnly: PropTypes.bool,

  /**
   * If true, set the Input to the disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * The function called when the Input changes.
   */
  onChange: PropTypes.func,

  /**
   * The function called when the Input blurs.
   */
  onBlur: PropTypes.func,

  /**
   * The leftElement of the Input.
   */
  leftElement: PropTypes.node,

  /**
   * The rightElement of the Input.
   */
  rightElement: PropTypes.node,

  /**
   * The error text of the Input.
   */
  error: PropTypes.string,

  /**
   * The alignment of the text of the Input.
   */
  alignText: PropTypes.oneOf(Object.values(TEXT_ALIGNMENT$2)),

  /**
   * If true, shows the Input in a small style.
   */
  small: PropTypes.bool
};
Input.defaultProps = {
  type: 'text',
  id: null,
  name: null,
  value: '',
  placeholder: '',
  label: '',
  className: null,
  readOnly: false,
  disabled: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  leftElement: '',
  rightElement: '',
  error: null,
  alignText: TEXT_ALIGNMENT$2.LEFT,
  small: false
};

var DropdownList = function DropdownList(props) {
  var value = props.value,
      options = props.options,
      optionRenderer = props.optionRenderer,
      searchable = props.searchable,
      searchModifier = props.searchModifier,
      onChange = props.onChange;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchTerm = _useState2[0],
      setSearchTerm = _useState2[1];

  var filtered = _pickBy(options, function (optionValue, optionKey) {
    var val = _isFunction(searchModifier) ? searchModifier(optionValue) : optionValue;
    var key = _isFunction(searchModifier) ? searchModifier(optionKey) : optionKey;
    var search = _isFunction(searchModifier) ? searchModifier(searchTerm) : searchTerm;
    return !searchTerm || _includes(_toLower(key), _toLower(search)) || _includes(_toLower(val), _toLower(search));
  });

  var keys = _keys(filtered);

  var handleSearchTermClick = function handleSearchTermClick(e) {
    e.stopPropagation();
    setSearchTerm(e.target.value);
  };

  return /*#__PURE__*/React__default.createElement("ul", {
    className: "list"
  }, searchable && /*#__PURE__*/React__default.createElement("li", null, /*#__PURE__*/React__default.createElement("div", {
    className: "list-search"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    autoComplete: "off",
    value: searchTerm,
    onChange: handleSearchTermClick
  }), /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    className: "search-icon",
    icon: faSearch
  }))), keys.map(function (key) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: key
    }, /*#__PURE__*/React__default.createElement("div", {
      className: cx('list-item', {
        'list-item--active': value === key
      }),
      onClick: function onClick() {
        return onChange(key);
      },
      onKeyPress: handleKeyboardEvent('Enter', function () {
        return onChange(key);
      }),
      tabIndex: 0,
      role: "button",
      value: key
    }, !optionRenderer ? options[key] : optionRenderer(key, options[key])));
  }));
};

DropdownList.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.object.isRequired,
  optionRenderer: PropTypes.func,
  searchable: PropTypes.bool,
  onChange: PropTypes.func
};
DropdownList.defaultProps = {
  value: null,
  optionRenderer: null,
  searchable: false,
  onChange: function onChange() {}
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Dropdown = /*#__PURE__*/forwardRef(function Dropdown(props, ref) {
  var _cx;

  var value = props.value,
      valueRenderer = props.valueRenderer,
      options = props.options,
      optionRenderer = props.optionRenderer,
      id = props.id,
      name = props.name,
      searchable = props.searchable,
      searchModifier = props.searchModifier,
      className = props.className,
      onChange = props.onChange,
      small = props.small,
      placeholder = props.placeholder,
      closeOnMouseLeave = props.closeOnMouseLeave,
      isOpenProp = props.isOpen,
      rest = _objectWithoutProperties(props, ["value", "valueRenderer", "options", "optionRenderer", "id", "name", "searchable", "searchModifier", "className", "onChange", "small", "placeholder", "closeOnMouseLeave", "isOpen"]);

  var _useState = useState(isOpenProp),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var content = valueRenderer && valueRenderer(value, options[value]);
  var classes$1 = cx(DROPDOWN, className, (_cx = {}, _defineProperty(_cx, DROPDOWN + SIZE_SMALL, small), _defineProperty(_cx, 'is-open', isOpen), _cx));
  useEffect(function () {
    setIsOpen(isOpenProp);
  }, [isOpenProp]);

  var toggle = function toggle() {
    setIsOpen(!isOpen);
  };

  var buttonElement = /*#__PURE__*/React__default.createElement("div", {
    className: "dropdown-field",
    onClick: toggle,
    onKeyPress: handleKeyboardEvent('Enter', toggle),
    role: "button",
    id: id,
    name: name,
    "data-qa": options[value] || placeholder,
    tabIndex: 0
  }, content || /*#__PURE__*/React__default.createElement("div", {
    className: cx('selected-text')
  }, options[value] || placeholder), /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: isOpen ? faAngleUp : faAngleDown
  }));

  var handleOnChange = function handleOnChange(e) {
    setIsOpen(false);
    onChange(e);
  };

  return /*#__PURE__*/React__default.createElement(OutsideClickHandler, {
    onOutsideClick: function onOutsideClick() {
      return setIsOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement("div", _extends$d({
    ref: ref,
    className: classes$1,
    onMouseLeave: closeOnMouseLeave ? function () {
      return setIsOpen(false);
    } : undefined // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), buttonElement, isOpen && /*#__PURE__*/React__default.createElement(DropdownList, {
    options: options,
    value: value,
    searchable: searchable,
    searchModifier: searchModifier,
    optionRenderer: optionRenderer,
    onChange: handleOnChange
  })));
});
Dropdown.propTypes = _objectSpread({
  /**
   * The value renderer function of the Dropdown.
   */
  valueRenderer: PropTypes.func,

  /**
   * The ID of the Dropdown.
   */
  id: PropTypes.string,

  /**
   * The name of the Dropdown.
   */
  name: PropTypes.string,

  /**
   * The className of the Dropdown.
   */
  className: PropTypes.string,

  /**
   * If true, shows the Button in a small style.
   */
  small: PropTypes.bool,

  /**
   * The placeholder of the Dropdown.
   */
  placeholder: PropTypes.string,

  /**
   * If true, closes the dropdown on mouse leave.
   */
  closeOnMouseLeave: PropTypes.bool,

  /**
   * If true, renders the dropdown in an open initial state.
   */
  isOpen: PropTypes.bool,

  /**
   * If true, renders the dropdown with a search input.
   */
  searchable: PropTypes.bool,

  /**
   * The search input modifier function
   */
  searchModifier: PropTypes.func
}, DropdownList.propTypes);
Dropdown.defaultProps = _objectSpread({
  valueRenderer: null,
  id: null,
  name: null,
  className: null,
  small: false,
  placeholder: null,
  closeOnMouseLeave: false,
  isOpen: false,
  searchable: false,
  searchModifier: null
}, DropdownList.defaultProps);
var PERSISTENT_HIDE_DELAY = 500;

var TooltipComp = function TooltipComp(children, className) {
  return function (_ref) {
    var arrowRef = _ref.arrowRef,
        tooltipRef = _ref.tooltipRef,
        getArrowProps = _ref.getArrowProps,
        getTooltipProps = _ref.getTooltipProps,
        placement = _ref.placement;
    return /*#__PURE__*/React__default.createElement("div", getTooltipProps({
      ref: tooltipRef,
      className: cx('tooltip-container', TOOLTIP, className)
    }), /*#__PURE__*/React__default.createElement("div", getArrowProps({
      ref: arrowRef,
      className: 'tooltip-arrow',
      'data-placement': placement
    })), children);
  };
};

var TriggerComp = function TriggerComp(_ref2) {
  var children = _ref2.children;
  return function (_ref3) {
    var getTriggerProps = _ref3.getTriggerProps,
        triggerRef = _ref3.triggerRef;
    return /*#__PURE__*/React__default.createElement("span", getTriggerProps({
      ref: triggerRef,
      className: 'trigger'
    }), children);
  };
}; // eslint-disable-next-line prefer-arrow-callback


var Tooltip = /*#__PURE__*/forwardRef(function Tooltip(props, ref) {
  var placement = props.placement,
      trigger = props.trigger,
      usePortal = props.usePortal,
      children = props.children,
      content = props.content,
      className = props.className,
      persistent = props.persistent;
  var tooltipClasses = cx(className, _defineProperty({}, "".concat(TOOLTIP, "--persistent"), persistent));
  return /*#__PURE__*/React__default.createElement(TooltipTrigger, {
    ref: ref,
    placement: placement,
    usePortal: usePortal,
    trigger: trigger,
    tooltip: TooltipComp(content, tooltipClasses),
    delayHide: persistent ? PERSISTENT_HIDE_DELAY : undefined
  }, TriggerComp({
    children: children
  }));
});
var TOOLTIP_PLACEMENT_TYPES = {
  AUTO: 'auto',
  LEFT: 'left',
  RIGHT: 'right',
  TOP: 'top',
  BOTTOM: 'bottom'
}; // do not use lodash methods/_values to show correct prop-types in storybook props table

var TOOLTIP_PLACEMENT_TYPES_ARR = Object.values(TOOLTIP_PLACEMENT_TYPES);
var TOOLTIP_TRIGGER_TYPES = {
  HOVER: 'hover',
  CLICK: 'click'
}; // do not use lodash methods/_values to show correct prop-types in storybook props table

var TOOLTIP_TRIGGER_TYPES_ARR = Object.values(TOOLTIP_TRIGGER_TYPES);
Tooltip.propTypes = {
  /**
   * The placement of the Tooltip.
   */
  placement: PropTypes.oneOf(TOOLTIP_PLACEMENT_TYPES_ARR),

  /**
   * The trigger type of the Tooltip.
   */
  trigger: PropTypes.oneOf(TOOLTIP_TRIGGER_TYPES_ARR),

  /**
   * If true, use a portal to render the tooltip.
   */
  usePortal: PropTypes.bool,

  /**
   * The children of the Tooltip.
   */
  children: PropTypes.node.isRequired,

  /**
   * The content of the Tooltip.
   */
  content: PropTypes.node.isRequired,

  /**
   * The className of the Tooltip.
   */
  className: PropTypes.string,

  /**
   * If true, shows the Tooltip in a persistent manner where it delays the hiding event.
   */
  persistent: PropTypes.bool
};
Tooltip.defaultProps = {
  placement: TOOLTIP_PLACEMENT_TYPES.AUTO,
  trigger: TOOLTIP_TRIGGER_TYPES.HOVER,
  usePortal: true,
  className: null,
  persistent: false
};

var stopPropagationOnClick = function stopPropagationOnClick(e) {
  return e.stopPropagation();
}; // eslint-disable-next-line prefer-arrow-callback


var Checkbox = /*#__PURE__*/forwardRef(function Checkbox(props, ref) {
  var label = props.label,
      checked = props.checked,
      disabled = props.disabled,
      className = props.className,
      id = props.id,
      name = props.name,
      onChange = props.onChange,
      error = props.error,
      small = props.small,
      helpMessage = props.helpMessage,
      rest = _objectWithoutProperties(props, ["label", "checked", "disabled", "className", "id", "name", "onChange", "error", "small", "helpMessage"]);

  var checkboxRef = useRef(null);
  var classes$1 = cx(CHECKBOX, className, _defineProperty({
    disabled: disabled,
    checked: checked
  }, CHECKBOX + SIZE_SMALL, small));

  var handleCheckboxChange = function handleCheckboxChange(e) {
    onChange(e.target.checked, e);
  };

  var handleLabelClick = function handleLabelClick(e) {
    // use DOM input click to trigger checkbox change event, so it triggers an actual Input Change event, rather than label onClick
    e.stopPropagation();
    checkboxRef.current.click();
  };

  var inputProps = {
    id: id,
    name: name,
    checked: checked,
    value: checked,
    type: 'checkbox',
    disabled: disabled,
    className: cx('input-field', {
      checked: checked
    }),
    onClick: stopPropagationOnClick,
    onChange: handleCheckboxChange,
    ref: checkboxRef
  };
  var component = /*#__PURE__*/React__default.createElement("div", _extends$d({
    ref: ref,
    className: classes$1,
    htmlFor: id,
    tabIndex: disabled ? -1 : 0,
    role: "checkbox",
    "aria-checked": checked,
    onClick: handleLabelClick,
    onKeyPress: handleKeyboardEvent(' ', handleLabelClick) // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), /*#__PURE__*/React__default.createElement("input", inputProps), /*#__PURE__*/React__default.createElement(Label, {
    label: label || '',
    className: cx({
      disabled: disabled
    }),
    tag: "div",
    small: small
  }), error && /*#__PURE__*/React__default.createElement("div", {
    className: "error"
  }, error));

  if (!_isEmpty(helpMessage)) {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      content: helpMessage
    }, component);
  }

  return component;
});
Checkbox.propTypes = {
  /**
   * The label text of the Checkbox.
   */
  label: PropTypes.node,

  /**
   * If true, set the Checkbox to the checked state.
   */
  checked: PropTypes.bool.isRequired,

  /**
   * If true, set the Checkbox to the disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * The className of the Button.
   */
  className: PropTypes.string,

  /**
   * The ID of the Button.
   */
  id: PropTypes.string,

  /**
   * The name attribute of the Button.
   */
  name: PropTypes.string,

  /**
   * The function called when the Checkbox state changes.
   */
  onChange: PropTypes.func,

  /**
   * The error text of the Checkbox.
   */
  error: PropTypes.string,

  /**
   * If true, shows the Button in a small style.
   */
  small: PropTypes.bool,

  /**
   * A help message to be shown in the tooltip.
   */
  helpMessage: PropTypes.string
};
Checkbox.defaultProps = {
  label: '',
  disabled: false,
  className: null,
  id: null,
  name: null,
  onChange: function onChange() {},
  error: '',
  small: false,
  helpMessage: ''
}; // eslint-disable-next-line prefer-arrow-callback

var Table = /*#__PURE__*/forwardRef(function Table(props, ref) {
  var _cx;

  var children = props.children,
      className = props.className,
      interactive = props.interactive,
      striped = props.striped,
      condensed = props.condensed,
      rest = _objectWithoutProperties(props, ["children", "className", "interactive", "striped", "condensed"]);

  var classes$1 = cx(TABLE, className, (_cx = {}, _defineProperty(_cx, TABLE_INTERACTIVE, interactive), _defineProperty(_cx, TABLE_STRIPED, striped), _defineProperty(_cx, TABLE_CONDENSED, condensed), _cx));
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React__default.createElement("table", _extends$d({
      ref: ref,
      className: classes$1
    }, rest), children)
  );
});
Table.propTypes = {
  /**
   * The content of the Table.
   */
  children: PropTypes.node.isRequired,

  /**
   * The className of the Table.
   */
  className: PropTypes.string,

  /**
   * If true, the rows of the Table will have hover/focus and active interactions.
   */
  interactive: PropTypes.bool,

  /**
   * If true, the rows of the Table will display in a striped style.
   */
  striped: PropTypes.bool,

  /**
   * If true, the rows of the Table will display in a condensed style.
   */
  condensed: PropTypes.bool
};
Table.defaultProps = {
  className: null,
  interactive: false,
  striped: false,
  condensed: false
};

var getTransformers = function getTransformers() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var transformers = {};
  columns.forEach(function (col) {
    if (col.dataKey && col.transformData) {
      transformers[col.dataKey] = col.transformData;
    }
  });
  return transformers;
};

var getSortKeys = function getSortKeys() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortKeys = {};
  columns.forEach(function (col) {
    if (col.sortKey) {
      sortKeys[col.dataKey] = col.sortKey;
    }
  });
  return sortKeys;
};

var getSortFunctions = function getSortFunctions() {
  var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortFunctions = {};
  columns.forEach(function (col) {
    if (col.sortKey) {
      sortFunctions[col.dataKey] = col.sortKey;
    }
  });
  return sortFunctions;
};
/**
 * Returns a sorted copy of the provided dataset; values are cast to strings
 * before comparison via localeCompare(). The transformers map is optional,
 * and can be used to process field values before casting/comparison.
 *
 * @param {Object} params
 * @param {string} params.sortBy - used as key into transformers map
 * @param {string} params.sortDirection
 * @param {Array} params.data
 * @param {Object} params.transfomers - data transform functions, key'ed by col
 * @return {Array} sortedData
 */


var getSortedData = function getSortedData() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var data = args.data,
      sortBy = args.sortBy,
      sortDirection = args.sortDirection,
      columns = args.columns;
  var transformers = getTransformers(columns);
  var sortKeys = getSortKeys(columns);
  var sortFunctions = getSortFunctions(columns);

  var transform = transformers[sortBy] || function (v) {
    return v;
  };

  var sortedData = _toConsumableArray(data);

  var asc = sortDirection === 'ASC';
  var key = sortKeys[sortBy] || sortBy;
  sortedData.sort(function () {
    var aRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var bRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var a = transform(_get(aRow, key), aRow);
    var b = transform(_get(bRow, key), bRow);

    if (_isFunction(sortFunctions[key])) {
      return sortFunctions[key](a, b);
    }

    if (!Number.isNaN(+a) && !Number.isNaN(+b)) {
      return asc ? +a - +b : +b - +a;
    }

    return asc ? "".concat(a).localeCompare(b) : "".concat(b).localeCompare(a);
  });
  return sortedData;
};

function sortData() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var getData = props.getSortedData,
      sortedDataPostProcessor = props.sortedDataPostProcessor;
  var sortedData = getData(args);
  sortedDataPostProcessor(sortedData);
  return sortedData;
}

var VirtualTable = function VirtualTable(_ref) {
  var data = _ref.data,
      columns = _ref.columns,
      onRowClick = _ref.onRowClick,
      rowHeight = _ref.rowHeight,
      headerHeight = _ref.headerHeight,
      defaultSortBy = _ref.defaultSortBy,
      defaultSortDirection = _ref.defaultSortDirection,
      getSortedData = _ref.getSortedData,
      sortedDataPostProcessor = _ref.sortedDataPostProcessor,
      className = _ref.className,
      interactive = _ref.interactive;

  var _useState = useState(defaultSortBy),
      _useState2 = _slicedToArray(_useState, 2),
      sortBy = _useState2[0],
      setSortBy = _useState2[1];

  var _useState3 = useState(defaultSortDirection),
      _useState4 = _slicedToArray(_useState3, 2),
      sortDirection = _useState4[0],
      setSortDirection = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      processedData = _useState6[0],
      setProcessedData = _useState6[1];

  var classes$1 = cx(VIRTUAL_TABLE_CONTAINER, className);
  useEffect(function () {
    setProcessedData(sortData({
      data: data,
      sortBy: sortBy,
      sortDirection: sortDirection,
      columns: columns
    }, {
      getSortedData: getSortedData,
      sortedDataPostProcessor: sortedDataPostProcessor
    }));
  }, [data, columns, getSortedData, sortBy, sortDirection, sortedDataPostProcessor]);

  var onSort = function onSort(_ref2) {
    var postSortDirection = _ref2.sortDirection,
        propDefaultSortDirection = _ref2.defaultSortDirection,
        postSortBy = _ref2.sortBy;
    var direction = sortDirection || propDefaultSortDirection;

    if (postSortBy === sortBy && postSortDirection === direction) {
      return;
    }

    setSortBy(postSortBy);
    setSortDirection(postSortDirection);
    setProcessedData(sortData({
      data: data,
      columns: columns,
      sortBy: postSortBy,
      sortDirection: postSortDirection
    }, {
      getSortedData: getSortedData,
      sortedDataPostProcessor: sortedDataPostProcessor
    }));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: VIRTUAL_TABLE
  }, /*#__PURE__*/React__default.createElement(AutoSizer, null, function (_ref3) {
    var width = _ref3.width,
        height = _ref3.height;
    return /*#__PURE__*/React__default.createElement(Table$1, {
      height: height,
      width: width,
      rowHeight: rowHeight,
      rowGetter: function rowGetter(_ref4) {
        var index = _ref4.index;
        return _get(processedData, index);
      },
      rowCount: _size(processedData),
      rowClassName: interactive ? 'hover' : undefined,
      onRowClick: onRowClick,
      headerHeight: headerHeight,
      disableHeader: false,
      sort: onSort,
      sortBy: sortBy,
      sortDirection: sortDirection
    }, columns.map(function () {
      var c = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return /*#__PURE__*/React__default.createElement(Column$1, _extends$d({
        key: c.dataKey,
        dataKey: c.dataKey
      }, c));
    }));
  })));
};

VirtualTable.propTypes = {
  data: PropTypes.array,
  // eslint-disable-line
  columns: PropTypes.array,
  // eslint-disable-line
  rowHeight: PropTypes.number,
  headerHeight: PropTypes.number,
  onRowClick: PropTypes.func,
  sortedDataPostProcessor: PropTypes.func,
  getSortedData: PropTypes.func,
  defaultSortBy: PropTypes.string,
  defaultSortDirection: PropTypes.oneOf(['ASC', 'DESC']),
  className: PropTypes.string,
  interactive: PropTypes.bool
};
VirtualTable.defaultProps = {
  data: [],
  columns: [],
  rowHeight: 22,
  headerHeight: 32,
  defaultSortBy: 'id',
  defaultSortDirection: 'ASC',
  onRowClick: function onRowClick() {},
  sortedDataPostProcessor: function sortedDataPostProcessor() {},
  getSortedData: getSortedData,
  className: null,
  interactive: false
};
var VirtualTable$1 = /*#__PURE__*/React__default.memo(VirtualTable);

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Tab = function Tab(props) {
  var id = props.id,
      title = props.title,
      active = props.active,
      className = props.className,
      onChange = props.onChange,
      rest = _objectWithoutProperties(props, ["id", "title", "active", "className", "onChange"]);

  var tabClasses = cx('tab', className, {
    'tab--active': active === id
  });

  var handleTabSelect = function handleTabSelect(e) {
    e.preventDefault();
    e.stopPropagation();
    onChange(id);
  };

  return /*#__PURE__*/React__default.createElement("div", _extends$d({
    className: tabClasses,
    onClick: handleTabSelect,
    onKeyPress: handleKeyboardEvent(['Enter', ' '], handleTabSelect),
    role: "tab",
    tabIndex: "0" // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), /*#__PURE__*/React__default.createElement("span", null, title));
};

var TAB_PROP_TYPE = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  title: PropTypes.elementType.isRequired
};
Tab.propTypes = _objectSpread$1(_objectSpread$1({}, TAB_PROP_TYPE), {}, {
  active: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired
});
Tab.defaultProps = {
  active: '',
  className: null
};
var Tabs = /*#__PURE__*/forwardRef(function Tabs(props, ref) {
  var tabs = props.tabs,
      active = props.active,
      onChange = props.onChange,
      containerClassName = props.containerClassName,
      containerStyle = props.containerStyle,
      tabClassName = props.tabClassName,
      tabStyle = props.tabStyle;
  var containerClasses = cx(TABS, containerClassName);
  return /*#__PURE__*/React__default.createElement("div", {
    className: containerClasses,
    style: containerStyle,
    ref: ref
  }, tabs.map(function (data) {
    var id = _get(data, 'id');

    var title = _get(data, 'title');

    return /*#__PURE__*/React__default.createElement(Tab, {
      key: id,
      id: id,
      title: title,
      active: active,
      className: tabClassName,
      style: tabStyle,
      onChange: onChange
    });
  }));
});
Tabs.propTypes = {
  /**
   * The tabs of the Tabs.
   */
  // tabs: { type: { name: 'object', required: false } },
  tabs: PropTypes.arrayOf(PropTypes.shape(TAB_PROP_TYPE)),

  /**
   * The active tab id of the Tabs.
   */
  active: PropTypes.string,

  /**
   * The function called when the Tabs state changes.
   */
  onChange: PropTypes.func,

  /**
   * The className of the container of the Tabs.
   */
  containerClassName: PropTypes.string,

  /**
   * The style of the container of the Tabs.
   */
  // eslint-disable-next-line react/forbid-prop-types
  containerStyle: PropTypes.object,

  /**
   * The className of the tab of the Tabs.
   */
  tabClassName: PropTypes.string,

  /**
   * The style of the tab of the Tabs.
   */
  // eslint-disable-next-line react/forbid-prop-types
  tabStyle: PropTypes.object
};
Tabs.defaultProps = {
  tabs: [],
  active: '',
  onChange: function onChange() {},
  containerClassName: null,
  containerStyle: null,
  tabClassName: null,
  tabStyle: null
};
var CooldownButton = /*#__PURE__*/forwardRef(function CooldownButton(props, ref) {
  var timeoutMs = props.timeoutMs,
      propDisabled = props.disabled,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, ["timeoutMs", "disabled", "onClick"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      disabled = _useState2[0],
      setDisabled = _useState2[1];

  var cancelTimeout = useRef();
  useEffect(function () {
    return function () {
      if (cancelTimeout.current) {
        clearTimeout(cancelTimeout.current);
      }
    };
  }, [cancelTimeout]);

  var handleClick = function handleClick(e) {
    setDisabled(true);
    cancelTimeout.current = setTimeout(function () {
      return setDisabled(false);
    }, timeoutMs);
    onClick(e);
  };

  return /*#__PURE__*/React__default.createElement(DefaultComp, _extends$d({
    ref: ref,
    disabled: propDisabled || disabled,
    onClick: handleClick // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest));
});
CooldownButton.propTypes = {
  /**
   * The function called when the CooldownButton is clicked.
   */
  onClick: PropTypes.func,

  /**
   * The cooldown timeout in milliseconds.
   */
  timeoutMs: PropTypes.number
};
CooldownButton.defaultProps = {
  onClick: function onClick() {},
  timeoutMs: 1000
};
var CooldownButton$1 = /*#__PURE__*/memo(CooldownButton);
var SortableButton = /*#__PURE__*/forwardRef(function SortableButton(props, ref) {
  var content = props.content,
      onSortClick = props.onSortClick,
      field = props.field,
      sortBy = props.sortBy,
      sortAscending = props.sortAscending,
      defaultSortAscending = props.defaultSortAscending;
  return /*#__PURE__*/React__default.createElement(DefaultComp, {
    minimal: true,
    onClick: function onClick() {
      return onSortClick(field, defaultSortAscending);
    },
    className: SORT_BUTTON,
    ref: ref
  }, /*#__PURE__*/React__default.createElement("span", null, content, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    size: "xs",
    icon: sortBy === field ? sortAscending ? faAngleUp : faAngleDown : defaultSortAscending ? faAngleUp : faAngleDown,
    className: cx('arrow-icon', {
      active: sortBy === field
    })
  })));
});
SortableButton.propTypes = {
  /**
   * The content of the SortButton.
   */
  content: PropTypes.node.isRequired,

  /**
   * The function called when clicked on the SortButton.
   */
  onSortClick: PropTypes.func,

  /**
   * The field of the SortButton.
   */
  field: PropTypes.string,

  /**
   * The sortBy of the SortButton.
   */
  sortBy: PropTypes.string,

  /**
   * If true, sorts the SortButton in an ascending manner.
   */
  sortAscending: PropTypes.bool,

  /**
   * If true, sets the sorting of the SortButton in an ascending manner by default.
   */
  defaultSortAscending: PropTypes.bool
};
SortableButton.defaultProps = {
  onSortClick: function onSortClick() {},
  field: null,
  sortBy: null,
  sortAscending: false,
  defaultSortAscending: false
};
var GROUPING_INTERVAL_MS = 30 * 1000;
/**
 * @param {Object} notificationA - first notification
 * @param {Object} notificationB - second notification
 * @return {boolean} groupable
 */

var canBeGrouped = function canBeGrouped() {
  var notificationA = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var notificationB = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return notificationA.level === notificationB.level && Math.abs(notificationA.mts - notificationB.mts) < GROUPING_INTERVAL_MS;
};
/**
 * Adds a notification to a group, whether it is already grouped or not. Returns
 * a new group with both notifications merged.
 *
 * Can be used to merge multiple groups; n is preferred over groupN for the
 * primary label.
 *
 * @param {Object} notification - notification to add to group, used for primary label
 * @param {Object} groupN - optional, defaults to empty group
 * @return {Object} newGroupN
 */


var mergeCreateGroup = function mergeCreateGroup() {
  var notification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var groupN = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    mts: groupN.mts || notification.mts,
    cid: groupN.cid || notification.cid,
    message: notification.message || groupN.message,
    level: groupN.level || notification.level,
    group: [].concat(_toConsumableArray(groupN.group || [groupN]), _toConsumableArray(notification.group || [notification]))
  };
};

var groupNotifications = function groupNotifications() {
  var notifications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var groupedNotifications = notifications.reduce(function (all, current) {
    if (all.length === 0) {
      return [current];
    }

    var prevIndex = all.length - 1;
    var prevNotification = all[prevIndex];
    var grouped = canBeGrouped(current, prevNotification);

    if (!grouped) {
      // should not be grouped, append item
      return [].concat(_toConsumableArray(all), [current]);
    } // should be grouped, replace last index


    return all.map(function (item, idx) {
      if (idx === prevIndex) {
        return mergeCreateGroup(current, prevNotification);
      }

      return item;
    });
  }, []); // after calculating the groups, we reverse the array to allow newest groups on top

  return groupedNotifications.reverse();
};

var getIcon = function getIcon(level) {
  switch (level) {
    case Intent.NONE:
      {
        return faInfo;
      }

    case Intent.PRIMARY:
      {
        return faInfo;
      }

    case Intent.SUCCESS:
      {
        return faCheckCircle;
      }

    case Intent.WARNING:
      {
        return faExclamationCircle;
      }

    case Intent.ERROR:
      {
        return faBan;
      }

    default:
      {
        return faInfo;
      }
  }
};

var PROP_NOTIFICATION = {
  message: PropTypes.string.isRequired,
  level: PropTypes.oneOf(INTENT_TYPES_ARR).isRequired
};

var NotificationMessage = function NotificationMessage(props) {
  var level = props.level,
      message = props.message,
      group = props.group;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      groupIsExpanded = _useState2[0],
      setGroupIsExpanded = _useState2[1];

  var classes$1 = cx("".concat(NOTIFICATIONS, "__level"), "".concat(NOTIFICATIONS, "__level--").concat(level));
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "message"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: getIcon(level)
  })), /*#__PURE__*/React__default.createElement("ul", null, group && groupIsExpanded ? group.map(function (groupedMessage) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: groupedMessage.cid
    }, groupedMessage.message);
  }) : /*#__PURE__*/React__default.createElement("li", null, message))), group && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "expand-button",
    onClick: function onClick() {
      return setGroupIsExpanded(!groupIsExpanded);
    }
  }, groupIsExpanded ? 'Collapse' : "Expand (".concat(group.length, " more)")));
};

NotificationMessage.propTypes = PROP_NOTIFICATION;
var Notifications = /*#__PURE__*/forwardRef(function Notifications(props, ref) {
  var notifications = props.notifications;
  var groupedNotifications = groupNotifications(notifications);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: NOTIFICATIONS
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(NOTIFICATIONS, "__wrapper")
  }, groupedNotifications.map(function (notification) {
    return /*#__PURE__*/React__default.createElement(NotificationMessage, _extends$d({
      key: notification.cid // eslint-disable-next-line react/jsx-props-no-spreading

    }, notification));
  })));
});
Notifications.propTypes = {
  /**
   * The notifications of the Notifications.
   */
  notifications: PropTypes.arrayOf(PropTypes.shape(PROP_NOTIFICATION))
};
Notifications.defaultProps = {
  notifications: []
};
var Notifications$1 = /*#__PURE__*/memo(Notifications);
var DATE_FORMAT_OPTIONS = {
  'DD-MM-YY HH:mm:ss': {
    DATE_FORMAT: 'dd-MM-yyyy HH:mm:ss',
    INPUT_MASK: ['d', 'd', 'M', 'M', 'y', 'y', 'y', 'y', 'H', 'H', 'm', 'm', 's', 's'],
    INPUT_FORMAT: '##-##-#### ##:##:##'
  },
  'MM-DD-YY HH:mm:ss': {
    DATE_FORMAT: 'MM-dd-yyyy HH:mm:ss',
    INPUT_MASK: ['M', 'M', 'd', 'd', 'y', 'y', 'y', 'y', 'H', 'H', 'm', 'm', 's', 's'],
    INPUT_FORMAT: '##-##-#### ##:##:##'
  },
  'YY-MM-DD HH:mm:ss': {
    DATE_FORMAT: 'yyyy-MM-dd HH:mm:ss',
    INPUT_MASK: ['y', 'y', 'y', 'y', 'M', 'M', 'd', 'd', 'H', 'H', 'm', 'm', 's', 's'],
    INPUT_FORMAT: '####-##-## ##:##:##'
  }
};

var toDate = function toDate(date) {
  return date instanceof Date ? date : new Date(date);
};

var calculateMinMaxTime = function calculateMinMaxTime(_ref) {
  var date = _ref.date,
      minTime = _ref.minTime,
      maxTime = _ref.maxTime,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate;

  if (minTime && maxTime) {
    return {
      minTime: minTime,
      maxTime: maxTime
    };
  }

  if (!minDate) {
    return {};
  }

  var isSameDayAsMinDate = !date || isSameDay(date, minDate);

  if (isSameDayAsMinDate) {
    return {
      minTime: minDate,
      maxTime: endOfDay(minDate)
    };
  }

  var isSameDayAsMaxDate = maxDate && isSameDay(date, maxDate);

  if (isSameDayAsMaxDate) {
    return {
      minTime: startOfDay(maxDate),
      maxTime: maxDate
    };
  }

  return {};
};

var isValidDate = function isValidDate(date, value) {
  return isValid(date) || !isSameMinute(date, value);
};

var TEXT_ALIGNMENT$3 = TEXT_ALIGNMENT; // eslint-disable-next-line prefer-arrow-callback

var DateTimePicker = /*#__PURE__*/forwardRef(function DateTimePicker(props, ref) {
  var label = props.label,
      value = props.value,
      name = props.name,
      className = props.className,
      alignText = props.alignText,
      small = props.small,
      timeIntervals = props.timeIntervals,
      minDate = props.minDate,
      maxDate = props.maxDate,
      maxTimeProp = props.maxTime,
      minTimeProp = props.minTime,
      popperPlacement = props.popperPlacement,
      onChange = props.onChange,
      disabled = props.disabled,
      id = props.id,
      onBlur = props.onBlur,
      userDateFormat = props.userDateFormat,
      error = props.error,
      rest = _objectWithoutProperties(props, ["label", "value", "name", "className", "alignText", "small", "timeIntervals", "minDate", "maxDate", "maxTime", "minTime", "popperPlacement", "onChange", "disabled", "id", "onBlur", "userDateFormat", "error"]);

  var _DATE_FORMAT_OPTIONS$ = DATE_FORMAT_OPTIONS[userDateFormat],
      DATE_FORMAT = _DATE_FORMAT_OPTIONS$.DATE_FORMAT,
      INPUT_MASK = _DATE_FORMAT_OPTIONS$.INPUT_MASK,
      INPUT_FORMAT = _DATE_FORMAT_OPTIONS$.INPUT_FORMAT;
  var key = useMemo(function () {
    return id || _uniqueId();
  }, [id]);
  var handleChange = useCallback(function (date) {
    if (!isValidDate(date, value)) {
      return;
    } // seconds selection is not supported, so ensure seconds are "00"


    date.setSeconds(0);
    onChange(date);
  }, [onChange, value]);
  var handleDatePickerChange = useCallback(function (date) {
    if (!date) {
      onChange(null);
      return;
    }

    handleChange(date);
  }, [handleChange, onChange]);
  var handleTextInputChange = useCallback(function (_ref) {
    var formattedValue = _ref.formattedValue;
    handleChange(parse(formattedValue, DATE_FORMAT, 0));
  }, [DATE_FORMAT, handleChange]);
  var date = value && toDate(value);

  var _useMemo = useMemo(function () {
    return calculateMinMaxTime({
      date: date,
      maxTime: maxTimeProp,
      minTime: minTimeProp,
      minDate: minDate,
      maxDate: maxDate
    });
  }, [maxTimeProp, minTimeProp, minDate, date, maxDate]),
      maxTime = _useMemo.maxTime,
      minTime = _useMemo.minTime;

  var isError = !!error;
  return /*#__PURE__*/React__default.createElement("div", _extends$d({
    ref: ref,
    className: cx(INPUT, className) // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest), label && /*#__PURE__*/React__default.createElement(Label, {
    label: label,
    small: small,
    tag: "div"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cx('input-field-container', {
      disabled: disabled,
      'has-error': isError
    }),
    disabled: disabled
  }, /*#__PURE__*/React__default.createElement(DatePicker, {
    className: cx('input-field', "input-field".concat(alignmentModifier(alignText)), _defineProperty({}, "input-field".concat(SIZE_SMALL), small)),
    key: key,
    popperPlacement: popperPlacement,
    popperModifiers: {
      flip: {
        behavior: ['bottom']
      },
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      }
    },
    name: name,
    selected: date,
    onChange: handleDatePickerChange,
    onBlur: onBlur,
    dateFormat: DATE_FORMAT,
    showTimeSelect: true,
    shouldCloseOnSelect: false,
    timeIntervals: timeIntervals,
    minDate: minDate,
    maxDate: maxDate,
    maxTime: maxTime,
    minTime: minTime,
    popperClassName: "ufx-react-datepicker-popper",
    disabled: disabled,
    autoComplete: "off",
    customInput: /*#__PURE__*/React__default.createElement(NumberFormat, {
      format: INPUT_FORMAT,
      placeholder: DATE_FORMAT,
      onValueChange: handleTextInputChange,
      mask: INPUT_MASK
    })
  })), /*#__PURE__*/React__default.createElement("div", {
    className: cx('error-msg', {
      visible: isError
    })
  }, error));
});
DateTimePicker.propTypes = {
  /**
   * The ID of the DateTimePicker.
   */
  id: PropTypes.string,

  /**
   * The name attribute of the DateTimePicker.
   */
  name: PropTypes.string,

  /**
   * The value of the DateTimePicker.
   */
  value: PropTypes.object,

  /**
   * The label text of the DateTimePicker.
   */
  label: PropTypes.node,

  /**
   * The className of the DateTimePicker.
   */
  className: PropTypes.string,

  /**
   * If true, set the DateTimePicker to the disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * The function called when the DateTimePicker state changes to blur.
   */
  onBlur: PropTypes.func,

  /**
   * The function called when the DateTimePicker state changes.
   */
  onChange: PropTypes.func,

  /**
   * The error text of the DateTimePicker.
   */
  error: PropTypes.string,

  /**
   * The alignment of the DateTimePicker text.
   */
  alignText: PropTypes.oneOf(Object.values(TEXT_ALIGNMENT$3)),

  /**
   * If true, shows the DateTimePicker in a small style.
   */
  small: PropTypes.bool,

  /**
   * The time intervals of the DateTimePicker.
   */
  timeIntervals: PropTypes.number,

  /**
   * The minimum settable date of the DateTimePicker.
   */
  minDate: PropTypes.instanceOf(Date),

  /**
   * The maximum settable date of the DateTimePicker.
   */
  maxDate: PropTypes.instanceOf(Date),

  /**
   * The minimum settable time of the DateTimePicker.
   */
  minTime: PropTypes.instanceOf(Date),

  /**
   * The maximum settable time of the DateTimePicker.
   */
  maxTime: PropTypes.instanceOf(Date),

  /**
   * The date format of the DateTimePicker.
   */
  userDateFormat: PropTypes.oneOf(['DD-MM-YY HH:mm:ss', 'MM-DD-YY HH:mm:ss', 'YY-MM-DD HH:mm:ss']),

  /**
   * The placement of the DateTimePicker popper element.
   */
  popperPlacement: PropTypes.string
};
DateTimePicker.defaultProps = {
  value: null,
  id: null,
  name: null,
  label: '',
  className: null,
  disabled: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  timeIntervals: 15,
  popperPlacement: 'bottom-start',
  error: null,
  alignText: TEXT_ALIGNMENT$3.LEFT,
  small: false,
  minDate: null,
  maxDate: null,
  maxTime: null,
  minTime: null,
  userDateFormat: 'DD-MM-YY HH:mm:ss'
};
var UIDateTimePicker = /*#__PURE__*/React__default.memo(DateTimePicker);
/* eslint-disable import/prefer-default-export */

var NOTICE_TYPES = {
  NONE: '',
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  ERROR: 'error'
};

var _NOTICE_ICONS;

var NONE = NOTICE_TYPES.NONE,
    INFO = NOTICE_TYPES.INFO,
    WARNING = NOTICE_TYPES.WARNING,
    SUCCESS = NOTICE_TYPES.SUCCESS,
    ERROR = NOTICE_TYPES.ERROR;
var NOTICE_ICONS = (_NOTICE_ICONS = {}, _defineProperty(_NOTICE_ICONS, NONE, faInfoCircle), _defineProperty(_NOTICE_ICONS, INFO, faInfoCircle), _defineProperty(_NOTICE_ICONS, SUCCESS, faInfoCircle), _defineProperty(_NOTICE_ICONS, WARNING, faExclamationTriangle), _defineProperty(_NOTICE_ICONS, ERROR, faExclamationTriangle), _NOTICE_ICONS); // eslint-disable-next-line prefer-arrow-callback

var Notice = /*#__PURE__*/forwardRef(function Notice(props, ref) {
  var type = props.type,
      icon = props.icon,
      title = props.title,
      children = props.children;
  var wrapperClasses = cx(NOTICE, type);
  return /*#__PURE__*/React__default.createElement("div", {
    ref: ref,
    className: wrapperClasses
  }, icon || /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: NOTICE_ICONS[type],
    className: "icon"
  }), ' ', /*#__PURE__*/React__default.createElement("strong", null, title), ' ', children);
});
Notice.propTypes = {
  /**
   * The type of the Notice.
   */
  type: PropTypes.oneOf(Object.values(NOTICE_TYPES)),

  /**
   * The content of the Notice.
   */
  children: PropTypes.node.isRequired,

  /**
   * The title of the Notice.
   */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * The icon of the Notice.
   */
  icon: PropTypes.node
};
Notice.defaultProps = {
  type: INFO,
  title: undefined,
  icon: undefined
};
var ExternalLink = /*#__PURE__*/forwardRef(function ExternalLink(props, ref) {
  var link = props.link,
      children = props.children,
      className = props.className,
      target = props.target;
  return /*#__PURE__*/React__default.createElement("a", {
    href: link,
    ref: ref,
    target: target,
    rel: target === '_blank' ? 'noopener noreferrer' : '',
    className: className
  }, children);
});
ExternalLink.propTypes = {
  /**
   * The link/href of the ExternalLink.
   */
  link: PropTypes.string.isRequired,

  /**
   * The children of the ExternalLink.
   */
  children: PropTypes.node.isRequired,

  /**
   * The className of the ExternalLink.
   */
  className: PropTypes.string,

  /**
   * The target of the ExternalLink.
   */
  target: PropTypes.string
};
ExternalLink.defaultProps = {
  className: null,
  target: '_blank'
};
var ExternalLink$1 = /*#__PURE__*/memo(ExternalLink);
var QRCode = /*#__PURE__*/forwardRef(function QRCode(props, ref) {
  var value = props.value,
      className = props.className;
  return /*#__PURE__*/React__default.createElement(QRCodeUI, {
    ref: ref,
    value: value,
    className: className
  });
});
QRCode.propTypes = {
  /**
   * The value of the QRCode.
   */
  value: PropTypes.string.isRequired,

  /**
   * The className of the QRCode.
   */
  className: PropTypes.string
};
QRCode.defaultProps = {
  className: null
};
var QRCode$1 = /*#__PURE__*/memo(QRCode);

function DialogButton(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["primary", "secondary", "className"]);

  var intent;

  if (primary) {
    intent = Intent.PRIMARY;
  }

  if (secondary) {
    intent = Intent.SECONDARY;
  }

  return /*#__PURE__*/React__default.createElement(DefaultComp, _extends$d({
    className: cx('modal__button', className),
    small: true,
    intent: intent // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
}

function DialogFooter(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return /*#__PURE__*/React__default.createElement("div", _extends$d({
    className: "modal__footer"
  }, props));
}

var Modal = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var state = _ref.state,
      className = _ref.className,
      canOutsideClickClose = _ref.canOutsideClickClose,
      onClose = _ref.onClose,
      isCloseButtonShown = _ref.isCloseButtonShown,
      Icon = _ref.icon,
      title = _ref.title,
      isFullscreenInMobile = _ref.isFullscreenInMobile,
      hasStickyFooterInMobile = _ref.hasStickyFooterInMobile,
      children = _ref.children,
      width = _ref.width,
      height = _ref.height,
      textAlign = _ref.textAlign;
  return (
    /*#__PURE__*/

    /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
    React__default.createElement(FocusTrap, null, /*#__PURE__*/React__default.createElement("div", {
      className: cx(DIALOG)
    }, /*#__PURE__*/React__default.createElement("div", {
      className: cx('background', state, {
        'is-mobile-fullscreen': isFullscreenInMobile
      }),
      onClick: canOutsideClickClose ? onClose : undefined
    }), /*#__PURE__*/React__default.createElement("div", {
      role: "dialog",
      "aria-modal": "true",
      className: cx('modal', className, state, {
        'is-mobile-fullscreen': isFullscreenInMobile
      }),
      ref: ref,
      style: {
        maxWidth: width,
        height: height,
        textAlign: textAlign
      }
    }, isCloseButtonShown && /*#__PURE__*/React__default.createElement("button", {
      type: "button",
      className: "modal__close-button",
      onClick: onClose
    }, "\u2715"), Icon && /*#__PURE__*/React__default.createElement("div", {
      className: "modal__icon"
    }, typeof Icon === 'function' ? /*#__PURE__*/React__default.createElement(Icon, null) : Icon), title && /*#__PURE__*/React__default.createElement("div", {
      className: "modal__title"
    }, title), /*#__PURE__*/React__default.createElement("div", {
      className: cx('modal__body', {
        'is-sticky-footer': hasStickyFooterInMobile
      })
    }, children))))
  );
});
Modal.propTypes = {
  /**
   * A callback that is invoked when user interaction causes the overlay to close, such as
   * clicking on the overlay or pressing the `esc` key (if enabled).
   *
   * Receives the event from the user's interaction, if there was an event (generally either a
   * mouse or key event). Note that, since this component is controlled by the `isOpen` prop, it
   * will not actually close itself until that prop becomes `false`.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Title of the dialog. If provided, an element with `Classes.DIALOG_HEADER`
   * will be rendered inside the dialog before any children elements.
   */
  title: PropTypes.node,

  /**
   * An icon element to render in the dialog's header. Note that the header
   * will only be rendered if `title` is provided.
   */
  icon: PropTypes.node,

  /**
   * Whether to show the close button in the dialog's header.
   * Note that the header will only be rendered if `title` is provided.
   * @default true
   */
  isCloseButtonShown: PropTypes.bool,

  /**
   * Whether clicking outside the overlay element (either on backdrop when present or on document)
   * should invoke `onClose`.
   * @default true
   */
  canOutsideClickClose: PropTypes.bool,

  /**
   * Whether to show the modal in fullscreen mode on mobile.
   * @default false
   */
  isFullscreenInMobile: PropTypes.bool,

  /**
   * Whether to show the footer in fullscreen mode on mobile fixed to the bottom.
   * @default false
   */
  hasStickyFooterInMobile: PropTypes.bool,

  /** A space-delimited list of class names to pass along to a child element. */
  className: PropTypes.string,

  /** Determines the max width of the dialog in desktop. */
  width: PropTypes.number,

  /** Determines the max height of the dialog in desktop. */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Determines the text alignment of the dialog */
  textAlign: PropTypes.oneOf(['left', 'center', 'right'])
};
Modal.defaultProps = {
  icon: null,
  isCloseButtonShown: true,
  title: null,
  canOutsideClickClose: true,
  isFullscreenInMobile: false,
  hasStickyFooterInMobile: false,
  className: null,
  width: 460,
  height: 'auto',
  textAlign: 'center'
};

function createContainerElement(id, target) {
  var existingContainer = document.getElementById(id);

  if (existingContainer) {
    return existingContainer;
  }

  var container = document.createElement('div');
  container.id = id;
  target.appendChild(container);
  return container;
}

function Portal(_ref) {
  var children = _ref.children,
      id = _ref.id,
      target = _ref.target;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  useEffect(function () {
    var element = createContainerElement(id, target);
    requestAnimationFrame(function () {
      return setContainer(element);
    });
  }, [id, target]);

  if (container) {
    return /*#__PURE__*/createPortal(children, container);
  }

  return null;
}

Portal.propTypes = {
  /**
   * The content of the Portal.
   */
  children: PropTypes.node.isRequired,

  /**
   * The id of the Portal container.
   */
  id: PropTypes.string.isRequired,

  /**
   * The DOM target of the Portal container. This is where the container will be rendered to.
   */
  target: PropTypes.oneOfType([PropTypes.node, PropTypes.object])
};
Portal.defaultProps = {
  target: typeof document !== 'undefined' ? document.body : undefined
};
var Dialog = /*#__PURE__*/forwardRef(function Dialog(props, ref) {
  var children = props.children,
      isOpen = props.isOpen,
      onClose = props.onClose,
      canEscapeKeyClose = props.canEscapeKeyClose,
      canOutsideClickClose = props.canOutsideClickClose,
      className = props.className,
      icon = props.icon,
      title = props.title,
      isCloseButtonShown = props.isCloseButtonShown,
      isFullscreenInMobile = props.isFullscreenInMobile,
      hasStickyFooterInMobile = props.hasStickyFooterInMobile,
      width = props.width,
      height = props.height,
      textAlign = props.textAlign;
  useEffect(function () {
    var handleKeydown = function handleKeydown(e) {
      if (e.key === 'Escape' && isOpen && canEscapeKeyClose) {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeydown);
    return function () {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [onClose, isOpen, canEscapeKeyClose]);
  useEffect(function () {
    var addOrRemove = isOpen ? 'add' : 'remove';
    document.body.classList[addOrRemove](DIALOG_SCROLL_LOCK);
  }, [isOpen]);
  return /*#__PURE__*/React__default.createElement(Portal, {
    ref: ref,
    id: "dialog-container",
    target: document.body
  }, /*#__PURE__*/React__default.createElement(Transition, {
    "in": isOpen,
    timeout: 300,
    onEnter: function onEnter(node) {
      return node.offsetHeight;
    },
    mountOnEnter: true,
    unmountOnExit: true
  }, function (state) {
    return /*#__PURE__*/React__default.createElement(Modal, {
      state: state,
      className: className,
      icon: icon,
      title: title,
      canOutsideClickClose: canOutsideClickClose,
      isCloseButtonShown: isCloseButtonShown,
      isFullscreenInMobile: isFullscreenInMobile,
      hasStickyFooterInMobile: hasStickyFooterInMobile,
      onClose: onClose,
      width: width,
      height: height,
      textAlign: textAlign
    }, children);
  }));
});
Dialog.propTypes = {
  /**
   * Toggles the visibility of the overlay and its children.
   * This prop is required because the component is controlled.
   */
  isOpen: PropTypes.bool.isRequired,

  /**
   * A callback that is invoked when user interaction causes the overlay to close, such as
   * clicking on the overlay or pressing the `esc` key (if enabled).
   *
   * Receives the event from the user's interaction, if there was an event (generally either a
   * mouse or key event). Note that, since this component is controlled by the `isOpen` prop, it
   * will not actually close itself until that prop becomes `false`.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Title of the dialog. If provided, an element with `Classes.DIALOG_HEADER`
   * will be rendered inside the dialog before any children elements.
   */
  title: PropTypes.node,

  /**
   * An icon element to render in the dialog's header. Note that the header
   * will only be rendered if `title` is provided.
   */
  icon: PropTypes.node,

  /**
   * Whether to show the close button in the dialog's header.
   * Note that the header will only be rendered if `title` is provided.
   */
  isCloseButtonShown: PropTypes.bool,

  /**
   * Whether pressing the `esc` key should invoke `onClose`.
   */
  canEscapeKeyClose: PropTypes.bool,

  /**
   * Whether clicking outside the overlay element (either on backdrop when present or on document)
   * should invoke `onClose`.
   */
  canOutsideClickClose: PropTypes.bool,

  /**
   * Whether to show the modal in fullscreen mode on mobile.
   */
  isFullscreenInMobile: PropTypes.bool,

  /**
   * Whether to show the footer in fullscreen mode on mobile fixed to the bottom.
   */
  hasStickyFooterInMobile: PropTypes.bool,

  /**
   * A space-delimited list of class names to pass along to a child element.
   */
  className: PropTypes.string,

  /**
   * Determines the max width of the dialog in desktop.
   */
  width: PropTypes.number,

  /**
   * Determines the max height of the dialog in desktop.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Determines the text alignment of the dialog
   */
  textAlign: PropTypes.oneOf(['left', 'center', 'right'])
};
Dialog.defaultProps = {
  icon: null,
  isCloseButtonShown: true,
  title: null,
  canEscapeKeyClose: true,
  canOutsideClickClose: true,
  isFullscreenInMobile: false,
  hasStickyFooterInMobile: false,
  className: null,
  width: 460,
  height: 'auto',
  textAlign: 'center'
};
Dialog.Footer = DialogFooter;
Dialog.Button = DialogButton;
Dialog.Modal = Modal;
var Spinner = /*#__PURE__*/forwardRef(function Spinner(props, ref) {
  var useMarginWrapper = props.useMarginWrapper,
      size = props.size,
      className = props.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx(SPINNER, className, _defineProperty({}, "".concat(SPINNER, "__margin-wrapper"), useMarginWrapper)),
    ref: ref
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCircleNotch,
    size: size,
    spin: true,
    className: "fast-spin"
  }));
});
Spinner.propTypes = {
  /**
   * If true, add a margin top.
   */
  useMarginWrapper: PropTypes.bool,

  /**
   * The size of the Spinner.
   */
  size: PropTypes.string,

  /**
   * The className of the Spinner.
   */
  className: PropTypes.string
};
Spinner.defaultProps = {
  useMarginWrapper: true,
  size: 'lg',
  className: null
};
var Spinner$1 = /*#__PURE__*/memo(Spinner);

function ownKeys$2(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$2(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$2(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Flex = function Flex() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var children = props.children,
      style = props.style,
      className = props.className,
      id = props.id,
      horizontal = props.horizontal;

  var s = _objectSpread$2({
    display: 'flex',
    flexDirection: horizontal ? 'row' : 'column'
  }, style);

  return /*#__PURE__*/React__default.createElement("div", {
    id: id,
    style: s,
    className: className
  }, children);
};

Flex.propTypes = {
  /**
   * The children of the Flex.
   */
  children: PropTypes.node.isRequired,

  /**
   * The style of the Flex.
   */
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object,

  /**
   * The className of the Flex.
   */
  className: PropTypes.string,

  /**
   * The ID of the Flex.
   */
  id: PropTypes.string,

  /**
   * If true, renders the Flex in a row direction.
   */
  horizontal: PropTypes.bool
};
Flex.defaultProps = {
  style: null,
  className: null,
  id: '',
  horizontal: false
};

var Row = function Row(props) {
  return /*#__PURE__*/React__default.createElement(Flex, _extends$d({
    horizontal: true
  }, props));
};

var Column = function Column(props) {
  return /*#__PURE__*/React__default.createElement(Flex, _extends$d({
    horizontal: false
  }, props));
};
/**
 * Only fade trailing zeros if they are decimals
 *
 */


var FadeTrailingZeros = function FadeTrailingZeros(props) {
  var value = props.value;
  var stringValue = value.toString();
  var hasDecimals = stringValue.match(/\./);
  var trailingZeros = stringValue.match(/(0+)$/g);

  if (hasDecimals && trailingZeros) {
    var _stringValue$split = stringValue.split('.'),
        _stringValue$split2 = _slicedToArray(_stringValue$split, 2),
        prec = _stringValue$split2[0],
        dec = _stringValue$split2[1];

    var d = dec.replace(/(0+)$/g, '');
    return /*#__PURE__*/React__default.createElement("span", null, prec, ".", d, trailingZeros && /*#__PURE__*/React__default.createElement("span", {
      className: FADE_TRAILING_ZEROS
    }, trailingZeros[0]));
  }

  return /*#__PURE__*/React__default.createElement("span", null, stringValue);
};

FadeTrailingZeros.propTypes = {
  /**
   * The value to format
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};
var http_errors = {
  rate_limit: "You are being rate-limited, please try again in a moment"
};
var common = {
  no_data_available: "No data available",
  websocket_offiline: "Websocket connection offline",
  websocket_connected: "Websocket connected",
  websocket_disconnected: "Websocket disconnected",
  cancel: "Cancel",
  filter: "Filter",
  search: "Search",
  no_results_found: "No results found",
  created: "Created",
  modified: "Modified",
  at: " at ",
  yes: "Yes",
  copy: "Copy",
  copied: "Copied",
  copy_to_clipboard: "Copy to clipboard",
  no: "No"
};
var quickswap = {
  title: "Choose which assets to Swap",
  amount: "Amount",
  from_label: "Exchange",
  to_label: "Receive",
  expected_rate: "Expected rate",
  accept_terms: "I agree to the <0>Terms of Service</0> and confirm that I am not a US Person or otherwise prohibited from using the Services.",
  swap_now: "Swap now",
  token_required: "Please select a token to swap",
  error: {
    token_required: "Please select a token to swap",
    must_not_be_same: "Receive and Exchange token can not be same",
    accept_terms: "Please accept the terms to proceed"
  }
};
var error = {
  not_enough_balance: "Not enough balance, available balance is {{amount}}",
  must_be_number: "Must be a number",
  must_be_positive: "Must be a positive number",
  required: "{{fieldLabel}} is required",
  max_length: "{{fieldLabel}} cannot be longer than {{maxLength}} characters",
  no_decimals: "{{fieldLabel}} cannot have any decimal places",
  max_decimals: "Maximum {{allowedDecimals}} decimal places",
  invalid_date: "Invalid Date",
  must_be_date: "Date must be a valid date",
  date_must_be_within_interval: "Date must be between 1 to 7 days from today",
  must_be_before_max_date: "Date after max date",
  must_be_after_min_date: "Date before min date"
};
var marketlist = {
  symbol: "Symbol",
  last_price: "Last Price",
  last: "Last",
  "24h_change": "24h Change",
  change: "Change",
  "24h_high": "24h High",
  "24h_low": "24h Low",
  "24h_volume": "24h Volume",
  volume: "Volume",
  favorites: "Favorites"
};
var ticker = {
  volume: "Volume",
  high: "High",
  low: "Low"
};
var tickerlist = {
  pair: "Pair",
  last_price: "Last Price",
  last: "Last",
  "24h_change": "24h",
  volume: "Volume",
  favorites: "Favorites",
  empty: "No elements to show",
  fav_tooltip: "Show favorite tickers only",
  volume_tooltip: "Viewing 24h volume in terms of {{volumeUnit}} equivalent. Click to toggle",
  volume_tooltip_self: "Viewing 24h volume in terms of each currency. Click to toggle"
};
var trades = {
  time: "Time",
  amount: "Amount",
  price: "Price",
  market: "Market",
  user: "User",
  change_to_market: "Change to market",
  change_to_user: "Change to user"
};
var orderhistory = {
  pair: "Pair",
  type: "Type",
  amount: "Amount",
  ccy: "Ccy",
  price: "Price",
  average_price: "Avg. Price",
  status: "Status",
  placed: "Placed",
  no_orders: "No historic orders",
  sell_order_title: "Sell order (id: {{id}})",
  buy_order_title: "Buy order (id: {{id}})"
};
var orders = {
  pair: "Pair",
  type: "Type",
  amount: "Amount",
  ccy: "Ccy",
  price: "Price",
  status: "Status",
  placed: "Placed",
  no_orders: "No active orders",
  sell_order_title: "Sell order (id: {{id}})",
  buy_order_title: "Buy order (id: {{id}})"
};
var book = {
  cancel_order: "Cancel order",
  count: "Count",
  amount: "Amount",
  total: "Total",
  price: "Price",
  decrease_precision: "Decrease Precision",
  increase_precision: "Increase Precision",
  decrease_zoom: "Decrease Zoom",
  increase_zoom: "Increase Zoom"
};
var depthchart = {
  decrease_zoom: "Decrease Zoom",
  increase_zoom: "Increase Zoom"
};
var orderform = {
  amount: "Amount",
  price: "Price",
  set_price_bid: "Set price to current highest bid",
  set_price_ask: "Set price to current lowest ask",
  order_total_desc: "Approximate {{quoteCcy}} equivalent of this order at the limit price",
  postonly_desc: "\"Post Only\" limit orders are orders that allow you to be sure to always pay the maker fee. When placed, a \"Post Only\" limit order is either inserted into the order book or cancelled.",
  sell_ccy: "Sell {{ccy}}",
  buy_ccy: "Buy {{ccy}}",
  postonly: "Post Only",
  tif: "Tif",
  here: "here",
  tif_date: "Tif Date",
  date: "Date",
  best_market_price: "Best market price",
  limit_order: "Limit",
  market_order: "Market",
  of_your: "of your",
  order_of: "order of",
  was_canceled: "has been canceled",
  executed_partial: "has been partially executed",
  executed_full: "has been fully executed",
  buy: "buy",
  sell: "sell",
  price_impact: "Est. Price Impact: ",
  slippage: "Slippage",
  buy_price_out_of_range: "Price cannot be more than {{priceDeltaPercent}}% of the top ask price ({{maxPrice}})",
  sell_price_out_of_range: "Price cannot be less than {{priceDeltaPercent}}% of the top bid price ({{maxPrice}})",
  total: "Total",
  tif_desc: "Time-In-Force: specify datetime for automatic order cancellation."
};
var balances = {
  hide_small_balance: "Hide small Balances",
  hide_small_balance_tooltip: "Hide token with balance < {{threshold}}",
  name: "Name",
  available: "Available",
  total: "Total",
  deposit: "Deposit",
  withdraw: "Withdraw"
};
var grid = {
  ticker: "Ticker",
  tickers: "Tickers",
  order_form: "Order Form",
  order_book: "Order Book",
  chart: "Chart",
  depth_chart: "Depth Chart",
  trades: "Trades",
  balances: "Balances",
  order_history: "Order History",
  orders: "Orders",
  edit_layout: "Edit layout",
  save: "Save",
  reset: "Reset",
  close: "Close",
  close_edit: "Close edit",
  tip: "Drag or resize the grid components to change the layout",
  add_component: "Add component",
  add: "Add",
  undo: "Undo",
  layout_saved: "Layout saved"
};
var trading = {
  switching_to: "Switching to",
  title: "Trading"
};
var deposits = {
  title: "Deposit",
  deposits: "Deposits",
  memos: "memos",
  payment_ids: "Payment IDs",
  tags: "tags",
  addresses: "addresses",
  wallet: " Wallet",
  daemon_down: "The {{currency}} watchonly daemon is restarting, please come back in a few minutes",
  generate_address: "Click to generate address",
  change_address: "Change Address",
  scan_qr_code: "Scan QR-Code",
  amount: "Amount",
  min: "Min",
  max: "Max",
  to_my: "to my",
  wallet_select: "Select wallet",
  send_to_eth_warning_1: "At this time Bitfinex does not support Ethereum transactions generated from ",
  send_to_eth_warning_2: "smart contracts",
  send_to_eth_warning_3: ". To avoid missing deposits or deposit delays ETH and ETC should only be sent in traditional transactions.",
  send_to_eth_more: "If you are uncertain that your deposit will not be sent as part of an Ethereum contract execution, please find out for sure before sending your deposit.",
  understand: "I understand. Continue.",
  warnings: {
    send_to_eth_1: "At this time Bitfinex does not accept transactions sent from",
    send_to_eth_2: "smart contracts",
    send_to_eth_3: ".",
    iota_deposit_once_1: "Important: IOTA deposit addresses should not be used more than once. After the first use of a deposit address, subsequent deposits to the same address ",
    iota_deposit_once_2: "will not be credited",
    iota_deposit_once_3: ".",
    deposit_add_change_1: "You can generate new deposit addresses using the [ ",
    deposit_add_change_2: " ] buttons below.",
    deposit_add_change2: "When you generate a new deposit address, the old address is still valid for accepting deposits.",
    send_paymend_id: "Sending {{ccy}} requires both an address and a {{type}}. The {{type}} for each of your wallets is displayed in the table below.",
    send_special_deposit_address: "Bitfinex's {{ccy}} deposit address",
    payment_id_extra1: "WARNING: Failure to follow correct {{term}} deposit procedure will result in lost deposits.",
    payment_id_extra2: "Depositing {{term}} to Bitfinex requires BOTH a deposit address and a deposit {{field}}.",
    payment_id_extra3: "To make a {{term}} deposit, you need to use both",
    payment_id_extra4: "On the following page, the deposit address is shown at the top, and then below you will see a deposit {{field}} for each of your wallets.",
    payment_id_extra5: "To make a deposit to your Exchange wallet, for example, you will need to use the deposit address shown near the top and the deposit {{field}} next to your Exchange wallet.",
    payment_id_extra6: "Do NOT send {{term}} to Bitfinex unless you know how to indicate a {{field}}.",
    payment_id_extra7: "If you fail to include the {{field}} with your deposit the funds will be lost forever.",
    erc20_only: "Bitfinex supports ERC20 version of {{currency}} only. Do not deposit the new mainnet {{label}} tokens.",
    bch: "Depositing anything other than {{label}} WILL RESULT IN LOSS OF FUNDS. Bitfinex currently is not supporting automated chain splits. It is your responsibility to ensure you only deposit {{label}} to this address.",
    send_to_ccy: "Please do not send Ethereum, Tron, or any other currency to these addresses. They will not be credited."
  },
  more_info: "More Information",
  send_to1: "Please send {{currency}} to one of your deposit {{name}} displayed below.",
  send_to2: "The deposit will be credited in your corresponding wallet.",
  deposit_add_change_payid_1: "You can generate a new deposit {{type}} using the [ ",
  deposit_add_change_payid_2: " ] buttons below. When you generate a new deposit {{type}}, the old {{type}} is still valid for accepting deposits.",
  send_to_invoice: "Please enter an amount, select a wallet, and use the [Generate Invoice] button to generate an invoice for {{currency}}.",
  generate_invoice: "Generate Invoice",
  pay_invoice: "Pay Invoice",
  scan_invoice: "Scan the QR code below with your favorite Lightning wallet",
  deposit_complete: "Deposit is complete",
  contact_support_1: "Please ",
  contact_support_link: "contact support",
  contact_support_2: " if you have any questions or concerns.",
  no_active_tether: "No active tether protocols for deposits. Please try again.",
  send_tether_protocol: "Tethers can be sent on multiple transport protocols. Please select a transport protocol below to reveal the corresponding deposit addresses.",
  send_to_tether: "Please send assets to one of your Tether deposit addresses displayed below. The deposit will be credited in your corresponding wallet.",
  address_limit: "You have reached the limit of new deposit addresses per month",
  ampl_deposit_warning: "Please note, any deposits confirmed during the AMPL rebase (approximately from 01:50 am to 02:20 am UTC daily) will require manual processing and will be charged a fee - please see <0>the Ampleforth Support Article</0>.",
  error_get_address: "Error: Falied to get address"
};
var withdrawals = {
  title: "Withdraw",
  withdrawals: "Withdrawals",
  currency_available: "Available {{currency}} Balance",
  available_balance_explain: "If you have limit orders, this will decrease your available balance. To increase it, you can cancel limit orders",
  no_payment_id_info_1: "In some unusual situations a {{type}} is not needed when withdrawing {{ccy}}.",
  no_payment_id_info_2: "Please do not check this box unless you are ",
  no_payment_id_info_3: "CERTAIN",
  no_payment_id_info_4: " you do not need a {{type}}.",
  whats_this: "What's this?",
  wallet: "Wallet",
  withdraw_success: "Your withdrawal request has been successfully submitted.",
  request_for_withdrawal: "Request Withdrawal",
  invalid_payment_request: "Invoice is not a proper lightning payment request",
  invoice: "Invoice",
  invalid_fields: " invalid fields",
  tether_what: "What is Tether?",
  important: "Important:",
  tether_warning1: "Please confirm that you are sending tethers to a ",
  tether_enabled: "Tether-enabled wallet.",
  tether_warning2: "Tethers sent to a non-Tether compatible address may be non-retrievable by the recipient.",
  warnings: {
    erc20_only: "Bitfinex supports ERC20 version of {{currency}} only. Do not withdraw to a new mainnet {{label}} wallet."
  }
};
var movements = {
  deposit: "Deposit",
  withdraw: "Withdraw",
  address: "Address",
  recent_deposits_withdrawals: "Recent Deposits and Withdrawals",
  wallet_payment_id: "Payment ID",
  wallet_tag: "Tag",
  wallet_memo: "Memo",
  id: "ID",
  date: "Date",
  status: "Status",
  amount: "Amount",
  fee: "Fee",
  type: "Type",
  min_amount: "Min <0>{{minAmount}} {{symbol}}</0>",
  min_amount_usd_equiv: " ({{value}} USD Equivalent)",
  fiat_not_supported: "Fiat transfer is not supported.",
  tether_info_xaut_new: "Tether Gold (XAUt) is a digital token backed by physical gold. One full XAUt token represents one troy fine ounce of gold on a London Good Delivery bar. ",
  tether_info_xaut_link: "Learn more about XAUt",
  tether_info_new: "Tether's blockchain-enabled platform allows you to transact with real-world currency like bitcoin. Store, send, and receive 1-to-1 backed digital currency across Tether integrated exchanges, platforms, and wallets. ",
  tether_info_link: "Learn more",
  transport: "Transport",
  select_prompt: "Please select",
  help: "Help",
  errors: {
    required_field: "This field is required",
    invalid_invoice_amount: "Invoice amount must be greater than or equal to {{min}} and less than or equal to {{max}}"
  }
};
var iota_notice = {
  part0: "Understanding IOTA, Wallets, Nodes, and Tangle",
  part1: "IOTA is different than other major cryptocurrencies in several important ways.",
  part2: "Before using IOTA on Bitfinex, please review the following critical items.",
  part3: "Select each checkbox below to indicate that you have read, agree, and understand.",
  part4: "Learn more",
  link_intro: "An introduction to IOTA",
  link_wallet: "IOTA Node/Wallet Types",
  part5: "Connect your light wallet to {{address}}"
};
var wallets = {
  title: "Wallets",
  name: {
    exchange_wallet_name: "Exchange",
    trading_wallet_name: "Margin",
    deposit_wallet_name: "Funding"
  }
};
var enTrans = {
  http_errors: http_errors,
  common: common,
  quickswap: quickswap,
  error: error,
  marketlist: marketlist,
  ticker: ticker,
  tickerlist: tickerlist,
  trades: trades,
  orderhistory: orderhistory,
  orders: orders,
  book: book,
  depthchart: depthchart,
  orderform: orderform,
  balances: balances,
  grid: grid,
  trading: trading,
  deposits: deposits,
  withdrawals: withdrawals,
  movements: movements,
  iota_notice: iota_notice,
  wallets: wallets
};

function ownKeys$3(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$3(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$3(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var StoreContext = /*#__PURE__*/createContext({});

var StoreProvider = function StoreProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;

  var _ref2 = value || {},
      _ref2$translations = _ref2.translations,
      translations = _ref2$translations === void 0 ? {} : _ref2$translations,
      lang = _ref2.lang;

  var resources = _objectSpread$3({
    en: enTrans
  }, translations);

  initialiseI18n(lang, resources);
  return /*#__PURE__*/React__default.createElement(StoreContext.Provider, {
    value: value || {}
  }, children);
};

var useStore = function useStore() {
  return useContext(StoreContext);
};

var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var SUFFIX = {
  1: 'st',
  2: 'nd',
  3: 'rd'
}; // Return OrdinalNumber in string format from an integer value input

var numberToRank = function numberToRank(value) {
  if (!_isFinite(value) || value === 0) {
    return 'N/A';
  } // from https://www.easypacelearning.com/all-lessons/learning-english-level-1/97-ordinal-numbers-ranking-english-lesson
  // exception: 11, 12, 13 end in -th


  if (value > 10 && value < 14) {
    return "".concat(value, "th");
  } // other numbers use -st -nd -rd based on unit value


  var unit = value.toString().split('').pop();
  var suffix = SUFFIX[unit] || 'th';
  return "".concat(value).concat(suffix);
};

var PrettyDate = function PrettyDate(props) {
  var mts = props.mts,
      showDay = props.showDay,
      showYear = props.showYear,
      abbreviate = props.abbreviate,
      monthDayOnly = props.monthDayOnly;

  var _useStore = useStore(),
      offset = _useStore.timezoneOffset;

  var date = applyTimeZoneOffset(new Date(mts), offset);
  var day = DAY_NAMES[date.getDay()];
  var m = MONTH_NAMES[date.getMonth()];
  var month = abbreviate ? m && m.substr(0, 3) : m;
  var dayNumber = numberToRank(date.getDate());
  var now = new Date();
  var yy = date.getFullYear();
  var year = yy !== now.getFullYear() || showYear ? yy : '';

  if (monthDayOnly) {
    return "".concat(month, " ").concat(date.getDate());
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showDay ? "".concat(day, ", ").concat(month, " ").concat(dayNumber, " ").concat(year) : "".concat(month, " ").concat(dayNumber, " ").concat(year));
};

PrettyDate.propTypes = {
  mts: PropTypes.number.isRequired,
  showDay: PropTypes.bool,
  showYear: PropTypes.bool,
  abbreviate: PropTypes.bool,
  monthDayOnly: PropTypes.bool
};
PrettyDate.defaultProps = {
  showDay: true,
  showYear: false,
  abbreviate: false,
  monthDayOnly: false
};
/**
 * this component will merge all the number formatting functions
 * params will dictate how the value must be presented declaratively
 */
// TODO: add onclick keyboard support and styles

var PrettyValue = function PrettyValue(props) {
  var value = props.value,
      decimals = props.decimals,
      sigFig = props.sigFig,
      fadeTrailingZeros = props.fadeTrailingZeros,
      strike = props.strike,
      includeStrike = props.includeStrike,
      className = props.className,
      symbol = props.symbol,
      symbolBefore = props.symbolBefore,
      absolute = props.absolute,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, ["value", "decimals", "sigFig", "fadeTrailingZeros", "strike", "includeStrike", "className", "symbol", "symbolBefore", "absolute", "onClick"]);

  if (!_isFinite(+value)) {
    return /*#__PURE__*/React__default.createElement("span", null, value.toString());
  }

  var v = absolute ? Math.abs(value) : value;
  var opts = {
    number: v,
    decimals: decimals,
    significantFigures: sigFig,
    useGrouping: true
  };
  var prettyValue = formatNumber(opts);

  if (onClick) {
    rest.onClick = function () {
      return onClick(prettyValue.replace(',', ''));
    };
  }

  var color = getColors(v, {
    strike: strike,
    includeStrike: includeStrike
  });
  var classes = cx(color, className);
  var contentInner = fadeTrailingZeros ? /*#__PURE__*/React__default.createElement(FadeTrailingZeros, {
    value: prettyValue
  }) : prettyValue;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, symbol && symbolBefore && symbol, /*#__PURE__*/React__default.createElement("span", _extends$d({
    className: classes
  }, rest), contentInner), symbol && !symbolBefore && symbol);
};

PrettyValue.propTypes = {
  /**
  * The value to format
  */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * The number of decimal digits to show, will take precedence on sigFig prop
   */
  decimals: PropTypes.number,

  /**
   * The significant digits of the value
   */
  sigFig: PropTypes.number,

  /**
   * Whether to fade trailing zeros
   */
  fadeTrailingZeros: PropTypes.bool,

  /**
   * Strike if specified, colours the value in red if < than strike, green otherwise
   */
  strike: PropTypes.number,

  /**
   * Determines if strike has to be red or green
   */
  includeStrike: PropTypes.bool,

  /**
   * Class to pass along to the value wrapper element.
   */
  className: PropTypes.string,

  /**
   * The symbol to show beside the value
   */
  symbol: PropTypes.string,

  /**
   * Whether symbol should be before the value
   */
  symbolBefore: PropTypes.bool,

  /**
   * Whether it should show absolute value
   */
  absolute: PropTypes.bool,

  /**
   * Fn to call when value is clicked
   */
  onClick: PropTypes.func
}; // *   @param {string} symbol the symbol to show beside the value
// *   @param {boolean} symbolBefore determines if symbol must be after or before value

PrettyValue.defaultProps = {
  value: 'N/A',
  decimals: null,
  sigFig: null,
  fadeTrailingZeros: false,
  strike: null,
  includeStrike: false,
  symbol: null,
  symbolBefore: false,
  absolute: false,
  className: null,
  onClick: null
};

var Time = function Time(props) {
  var mts = props.mts,
      hideSeconds = props.hideSeconds;

  var _useStore = useStore(),
      offset = _useStore.timezoneOffset;

  var date = applyTimeZoneOffset(new Date(mts), offset);
  var HH = pad2(date.getHours());
  var MM = pad2(date.getMinutes());
  var SS = hideSeconds ? [] : pad2(date.getSeconds());
  var timeParts = [HH, MM].concat(SS);
  return timeParts.join(':');
};

Time.propTypes = {
  mts: PropTypes.number,
  hideSeconds: PropTypes.bool
};
Time.defaultProps = {
  hideSeconds: false
};

var DateComponent = function DateComponent(props) {
  var mts = props.mts;

  var _useStore = useStore(),
      offset = _useStore.timezoneOffset,
      format = _useStore.timeFormat;

  var date = applyTimeZoneOffset(new Date(mts), offset);
  var DD = pad2(date.getDate());
  var MM = pad2(date.getMonth() + 1);
  var YY = pad2(date.getFullYear()).toString().substr(-2);

  switch (format) {
    case 'YY-MM-DD HH:mm:ss':
      {
        return "".concat(YY, "-").concat(MM, "-").concat(DD);
      }

    case 'MM-DD-YY HH:mm:ss':
      {
        return "".concat(MM, "-").concat(DD, "-").concat(YY);
      }

    case 'DD-MM-YY HH:mm:ss':
      {
        return "".concat(DD, "-").concat(MM, "-").concat(YY);
      }

    default:
      {
        return date.toLocaleDateString();
      }
  }
};

DateComponent.propTypes = {
  mts: PropTypes.number.isRequired
};

var FullDate = function FullDate(props) {
  var ts = props.ts,
      mts = props.mts,
      style = props.style;
  var t = mts ? mts / 1000 : ts;
  return /*#__PURE__*/React__default.createElement("span", {
    style: style
  }, /*#__PURE__*/React__default.createElement(DateComponent, {
    mts: t
  }), ' ', /*#__PURE__*/React__default.createElement(Time, {
    mts: t
  }));
};

FullDate.propTypes = {
  ts: PropTypes.number,
  mts: PropTypes.number,
  // eslint-disable-next-line react/forbid-prop-types
  style: PropTypes.object
};
FullDate.defaultProps = {
  ts: 0,
  mts: 0,
  style: null
};
var ORDER_TYPES = {
  EXCHANGE_LIMIT: 'EXCHANGE LIMIT',
  EXCHANGE_MARKET: 'EXCHANGE MARKET'
};

var formatType = function formatType(type) {
  return type.split('_').join(' ');
};

var getTypes = function getTypes(allTypes) {
  return allTypes.split(';');
};

var OrderType = function OrderType(props) {
  var children = props.children;

  var renderTooltip = function renderTooltip() {
    var types = getTypes(children);
    return /*#__PURE__*/React__default.createElement("div", null, types.map(function (t) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: t
      }, formatType(t));
    }));
  };

  var types = getTypes(children);

  if (types.length === 0) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formatType(types[0]), types.length > 1 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ' ', /*#__PURE__*/React__default.createElement(Tooltip, {
    content: renderTooltip()
  }, /*#__PURE__*/React__default.createElement("small", null, "..."))));
};

OrderType.propTypes = {
  children: PropTypes.string.isRequired
};
/* eslint-disable import/prefer-default-export */

var getInitialState = function getInitialState(defFromToken, defToToken) {
  return {
    fromToken: defFromToken,
    fromAmount: '',
    toToken: defToToken,
    toAmount: '',
    acceptedTerms: false
  };
};

var formSchema = function formSchema(t) {
  return object({
    fromAmount: requiredPositiveNumber(t, t('amount')),
    fromToken: string().required('error.token_required'),
    toAmount: requiredPositiveNumber(t, t('amount')),
    toToken: string().required(t('error.token_required')).notOneOf([ref('fromToken'), null], t('error.must_not_be_same')),
    acceptedTerms: bool().oneOf([true], t('error.accept_terms'))
  });
};

var validateForm = function validateForm(getAvailableBalance, t) {
  return function (values) {
    var errors = {};
    var fromAmount = values.fromAmount,
        fromToken = values.fromToken,
        toAmount = values.toAmount,
        toToken = values.toToken;
    var availFromAmount = getAvailableBalance(fromToken);
    var availToAmount = getAvailableBalance(toToken); // check for errors

    if (fromAmount > availFromAmount) {
      errors.fromAmount = t('error:not_enough_balance', {
        amount: availFromAmount
      });
    } else {
      errors.fromAmount = '';
    }

    if (toAmount > availToAmount) {
      errors.toAmount = t('error:not_enough_balance', {
        amount: availToAmount
      });
    }

    return errors;
  };
};

var Input$1 = function Input$1(props) {
  var _props$field = props.field,
      name = _props$field.name,
      value = _props$field.value,
      onBlur = _props$field.onBlur,
      onChange = _props$field.onChange,
      _props$form = props.form,
      touched = _props$form.touched,
      errors = _props$form.errors,
      fieldsToValidate = props.fieldsToValidate,
      rest = _objectWithoutProperties(props, ["field", "form", "fieldsToValidate"]);

  var error = touched[name] && errors[name];

  if (!error && fieldsToValidate) {
    var errorField = fieldsToValidate.find(function (f) {
      return touched[f];
    });
    error = errorField && errors[errorField];
  }

  var errorMessage = error || '';

  var handleChange = function handleChange(_, e) {
    onChange(e);
  };

  return /*#__PURE__*/React__default.createElement(Input, _extends$d({
    name: name,
    value: value,
    onBlur: onBlur,
    onChange: handleChange,
    error: errorMessage // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest));
};

Input$1.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
};
var Input$2 = /*#__PURE__*/memo(Input$1);

var Dropdown$1 = function Dropdown$1(props) {
  var _props$field = props.field,
      name = _props$field.name,
      value = _props$field.value,
      onChange = _props$field.onChange,
      rest = _objectWithoutProperties(props, ["field"]);

  var handleOnChange = function handleOnChange(val) {
    // need to mimic a standard js event for Formik to pick this up
    var e = {
      target: {
        value: val,
        name: name
      }
    };
    onChange(e);
  };

  return /*#__PURE__*/React__default.createElement(Dropdown, _extends$d({
    name: name,
    value: value,
    onChange: handleOnChange // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest));
};

Dropdown$1.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
};
var Dropdown$2 = /*#__PURE__*/memo(Dropdown$1);

var Checkbox$1 = function Checkbox$1(props) {
  var _props$field = props.field,
      name = _props$field.name,
      value = _props$field.value,
      onChange = _props$field.onChange,
      _props$form = props.form,
      touched = _props$form.touched,
      errors = _props$form.errors,
      rest = _objectWithoutProperties(props, ["field", "form"]);

  var error = touched[name] && errors[name];

  var handleChange = function handleChange(checked, e) {
    onChange(e);
  };

  return /*#__PURE__*/React__default.createElement(Checkbox, _extends$d({
    name: name,
    checked: value,
    error: error,
    onChange: handleChange // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest));
};

Checkbox$1.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
};
var Checkbox$2 = /*#__PURE__*/memo(Checkbox$1);

var toDate$1 = function toDate(date) {
  return date instanceof Date ? date : new Date(date);
};

var removeUTCOffsetFromDate = function removeUTCOffsetFromDate(date, utcOffset) {
  return sub(date, {
    minutes: utcOffset + toDate$1(date).getTimezoneOffset()
  });
};

var applyUTCOffsetToDate = function applyUTCOffsetToDate(date, utcOffset) {
  return add(date, {
    minutes: utcOffset + toDate$1(date).getTimezoneOffset()
  });
};

var DateTimePicker$1 = function DateTimePicker(props) {
  var minDays = props.minDays,
      maxDays = props.maxDays,
      _props$field = props.field,
      name = _props$field.name,
      value = _props$field.value,
      onBlur = _props$field.onBlur,
      onChange = _props$field.onChange,
      _props$form = props.form,
      touched = _props$form.touched,
      errors = _props$form.errors,
      fieldsToValidate = props.fieldsToValidate,
      rest = _objectWithoutProperties(props, ["minDays", "maxDays", "field", "form", "fieldsToValidate"]);

  var _useStore = useStore(),
      timeFormat = _useStore.timeFormat,
      timezoneOffset = _useStore.timezoneOffset;

  var error = touched[name] && errors[name];

  if (!error && fieldsToValidate) {
    var errorField = fieldsToValidate.find(function (f) {
      return touched[f];
    });
    error = errorField && errors[errorField];
  }

  var errorMessage = error || '';
  var today = new Date();
  var minDate = startOfDay(addDays(today, minDays));
  var maxDate = addDays(today, maxDays);
  var maxTime = endOfDay(maxDate);
  var minTime = minDate;

  var handleChange = function handleChange(date) {
    // saves time in UTC format
    var dateInUtc = removeUTCOffsetFromDate(toDate$1(date), timezoneOffset); // we need to mimic a standard js event for Formik to pick this up

    var e = {
      target: {
        value: isValid(dateInUtc) ? dateInUtc.toISOString() : '',
        name: name
      }
    };
    onChange(e);
  }; // applies user timezone (from settings) for display purposes


  var dateWithTzOffset = applyUTCOffsetToDate(value ? toDate$1(value) : null, timezoneOffset);
  return /*#__PURE__*/React__default.createElement(UIDateTimePicker, _extends$d({
    value: isValid(dateWithTzOffset) ? dateWithTzOffset : null,
    name: name,
    minDate: minDate,
    maxDate: maxDate,
    onChange: handleChange,
    onBlur: onBlur,
    error: errorMessage,
    userDateFormat: timeFormat,
    maxTime: maxTime,
    minTime: minTime // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest));
};

DateTimePicker$1.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  minHours: PropTypes.number,
  maxDays: PropTypes.number
};
DateTimePicker$1.defaultProps = {
  minHours: null,
  maxDays: null
};
var DateTimePicker$2 = /*#__PURE__*/memo(DateTimePicker$1);

var _rect, _g, _defs;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function SvgBtc(props) {
  return /*#__PURE__*/createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#F2A900"
  })), _g || (_g = /*#__PURE__*/createElement("g", {
    clipPath: "url(#btc_svg__clip0)"
  }, /*#__PURE__*/createElement("path", {
    d: "M17.326 12.394c-.372-.48-.933-.81-1.683-.99.955-.488 1.375-1.314 1.26-2.481a2.45 2.45 0 00-.352-1.1c-.195-.312-.46-.562-.793-.75a4.368 4.368 0 00-1.087-.434c-.39-.099-.84-.171-1.346-.216V4h-1.48v2.356c-.257 0-.648.006-1.174.019V4h-1.48v2.423c-.212.007-.523.01-.933.01l-2.039-.01V8h1.068c.487 0 .772.218.856.654v2.76c.064 0 .115.003.153.01h-.153v3.865c-.052.327-.238.49-.558.49H6.518l-.298 1.76h1.923c.121 0 .298.001.529.004.23.004.403.005.519.005V20h1.48v-2.423c.27.007.661.01 1.174.01V20h1.48v-2.452c.526-.025.993-.073 1.4-.144a5.7 5.7 0 001.168-.332c.372-.15.682-.338.932-.563.25-.224.457-.509.62-.855.164-.347.268-.747.313-1.202.084-.891-.06-1.577-.432-2.058zM10.7 8.106l.38-.005.52-.01a5.61 5.61 0 01.557.024c.234.02.431.045.591.077.16.032.337.085.53.159.192.073.345.163.46.269.116.106.214.24.294.404.08.163.12.35.12.562 0 .18-.028.343-.086.49a.924.924 0 01-.26.371c-.115.1-.234.186-.356.26a1.63 1.63 0 01-.466.177c-.189.045-.354.08-.495.106a4.054 4.054 0 01-.529.053 10.56 10.56 0 01-.928.02l-.332-.006V8.106zm4.044 6.548c-.061.147-.14.276-.236.385a1.334 1.334 0 01-.38.288 3.24 3.24 0 01-.456.202 3.676 3.676 0 01-.534.135 7.04 7.04 0 01-1.11.12 12.675 12.675 0 01-.972.01 30.84 30.84 0 00-.356-.005v-3.25c.052 0 .204-.004.457-.01a10.309 10.309 0 011.284.02c.282.018.519.047.711.085.193.039.402.098.63.178.228.08.412.178.553.293.141.116.26.263.356.443.096.18.144.384.144.615 0 .18-.03.343-.091.49z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "btc_svg__clip0"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    transform: "translate(4 4)",
    d: "M0 0h16v16H0z"
  })))));
}

var _rect$1, _path, _path2;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function SvgDapp(props) {
  return /*#__PURE__*/createElement("svg", _extends$1({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#202047"
  })), _path || (_path = /*#__PURE__*/createElement("path", {
    d: "M13.354 11.994a1.366 1.366 0 10-1.368 1.364h1.365v-1.363l.003-.001z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/createElement("path", {
    d: "M18 18v-6a5.994 5.994 0 00-2.761-5.05l-.009 2.12-.01 2.544.024 3.626h-3.04c-.072.004-.143.008-.215.008a3.251 3.251 0 01-2.563-5.256 3.252 3.252 0 013.928-.95l.011-2.884a5.998 5.998 0 00-3.824 11.315 5.997 5.997 0 002.453.526H18L18 18z",
    fill: "#fff"
  })));
}

var _rect$2, _path$1;

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function SvgEmanate(props) {
  return /*#__PURE__*/createElement("svg", _extends$2({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#091F36"
  })), _path$1 || (_path$1 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6.103v4.706h1.276V8.81l1.64 1.206L9.558 8.81v5.586L5 11.689v5.177h1.276v-2.584l4.554 2.713V6.103L7.915 8.428 5 6.103zM15.477 15.359a1.886 1.886 0 01-1.83-1.889c0-1.01.82-1.827 1.832-1.826a1.83 1.83 0 011.83 1.826 1.886 1.886 0 01-1.832 1.863v.026zm0-7.868a1.264 1.264 0 01.093 2.521h-.093a1.274 1.274 0 110-2.547v.026zm2.454 3.623l-.047-.057a.61.61 0 01-.083-.864l.031-.057c.773-1.301.343-2.98-.96-3.752a2.746 2.746 0 00-3.76.958 2.733 2.733 0 000 2.794l.047.083a.61.61 0 01-.078.86l-.005.004a3.298 3.298 0 00-1.079 2.423A3.498 3.498 0 0015.498 17 3.498 3.498 0 0019 13.506a3.385 3.385 0 00-1.069-2.392z",
    fill: "#70FAF7"
  })));
}

var _rect$3, _path$2;

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function SvgEos(props) {
  return /*#__PURE__*/createElement("svg", _extends$3({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$3 || (_rect$3 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#000"
  })), _path$2 || (_path$2 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4c.05 0 .1.025.132.07l3.259 4.746c.013.02.023.042.028.066l1.577 7.677a.18.18 0 01-.072.186l-4.837 3.229A.152.152 0 0112 20a.152.152 0 01-.087-.026l-4.837-3.23a.18.18 0 01-.072-.185L8.58 8.882a.18.18 0 01.028-.066l3.26-4.746A.157.157 0 0112 4zm-.164.7L8.917 8.95l.764 2.558 2.155-4.052V4.701zM12 7.849l-2.185 4.108 1.335 4.467h1.7l1.335-4.467L12 7.848zm2.402 4.516l-1.213 4.059h3.371l-2.158-4.06zm1.87 4.407h-3.187l-.795 2.658 3.982-2.658zM12 19.266l.746-2.495h-1.492L12 19.266zm-1.189-2.843l-1.213-4.059-2.158 4.059h3.371zm-3.264-.902l1.917-3.605-.697-2.333-1.22 5.938zm.181 1.25h3.187l.795 2.658-3.982-2.658zm8.724-1.25l-1.917-3.605.697-2.333 1.22 5.938zm-1.37-6.57l-.764 2.557-2.154-4.052V4.701l2.918 4.25z",
    fill: "#fff"
  })));
}

var _rect$4, _path$3, _path2$1, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113;

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$4.apply(this, arguments);
}

function SvgEosdt(props) {
  return /*#__PURE__*/createElement("svg", _extends$4({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$4 || (_rect$4 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#1792FF"
  })), _path$3 || (_path$3 = /*#__PURE__*/createElement("path", {
    d: "M14.286 10.558l-.014 2.767L12 14.68l.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/createElement("path", {
    d: "M12.014 11.913L12 14.68l-2.285-1.355.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path3 || (_path3 = /*#__PURE__*/createElement("path", {
    d: "M14.286 10.558l-2.272 1.355-2.285-1.355L12 9.203l2.286 1.355z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.928 9.076a.14.14 0 01.143 0l2.286 1.355a.147.147 0 01.071.128l-.014 2.767c0 .052-.027.1-.07.126l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.355zm.072.296l-2.13 1.27-.013 2.598L12 14.51l2.13-1.27.012-2.598L12 9.373z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.604 10.484a.14.14 0 01.195-.053l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.148l.013-2.681-2.213-1.313a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.41 10.484a.15.15 0 01-.053.2l-2.271 1.356a.14.14 0 01-.196-.053.15.15 0 01.052-.201l2.272-1.355a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/createElement("path", {
    d: "M16.572 11.91l-.014 2.766-2.272 1.356.014-2.767 2.272-1.356z",
    fill: "#1792FF"
  })), _path8 || (_path8 = /*#__PURE__*/createElement("path", {
    d: "M14.3 13.265l-.014 2.767L12 14.676l.014-2.767 2.285 1.356z",
    fill: "#1792FF"
  })), _path9 || (_path9 = /*#__PURE__*/createElement("path", {
    d: "M16.571 11.91L14.3 13.265l-2.285-1.355 2.272-1.355 2.285 1.355z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.214 10.428a.14.14 0 01.143 0l2.286 1.355a.148.148 0 01.071.128l-.013 2.767c0 .052-.028.1-.072.126l-2.272 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.355zm.072.296l-2.13 1.27-.012 2.598 2.142 1.27 2.13-1.27.012-2.597-2.142-1.27z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.89 11.836a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.147l.013-2.682-2.213-1.312a.15.15 0 01-.053-.201z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.695 11.836a.15.15 0 01-.051.2l-2.272 1.356a.14.14 0 01-.195-.054.15.15 0 01.051-.2l2.272-1.356a.14.14 0 01.195.054z",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/createElement("path", {
    d: "M14.286 7.854l-.014 2.767L12 11.976l.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path14 || (_path14 = /*#__PURE__*/createElement("path", {
    d: "M12.014 9.21L12 11.975l-2.285-1.355.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path15 || (_path15 = /*#__PURE__*/createElement("path", {
    d: "M14.286 7.854l-2.272 1.355L9.73 7.854 12 6.499l2.286 1.355z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.928 6.371a.14.14 0 01.143 0l2.286 1.355a.148.148 0 01.071.129l-.014 2.766c0 .053-.027.1-.07.127l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.356zm.072.297l-2.13 1.27-.013 2.598L12 11.806l2.13-1.27.012-2.598L12 6.668z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.604 7.78a.14.14 0 01.195-.053l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.147l.013-2.682-2.213-1.313a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.41 7.78a.15.15 0 01-.053.201l-2.271 1.355a.14.14 0 01-.196-.053.15.15 0 01.052-.2l2.272-1.356a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/createElement("path", {
    d: "M16.572 9.206l-.014 2.767-2.272 1.355.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path20 || (_path20 = /*#__PURE__*/createElement("path", {
    d: "M14.3 10.56l-.014 2.768L12 11.973l.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path21 || (_path21 = /*#__PURE__*/createElement("path", {
    d: "M16.571 9.206L14.3 10.56l-2.285-1.355 2.272-1.355 2.285 1.355z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.214 7.723a.14.14 0 01.143 0l2.286 1.356a.148.148 0 01.071.128l-.013 2.766c0 .053-.028.1-.072.127l-2.272 1.355a.14.14 0 01-.143 0L11.93 12.1a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.356zm.072.297l-2.13 1.27-.012 2.598 2.142 1.27 2.13-1.27.012-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.89 9.132a.14.14 0 01.195-.054l2.286 1.356a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.148l.013-2.681-2.213-1.313a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.695 9.132a.15.15 0 01-.051.2l-2.272 1.356a.14.14 0 01-.195-.053.15.15 0 01.051-.201L16.5 9.079a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/createElement("path", {
    d: "M18.857 10.617l-.014 2.766-2.272 1.356.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path26 || (_path26 = /*#__PURE__*/createElement("path", {
    d: "M16.585 11.972l-.013 2.767-2.286-1.356.014-2.766 2.285 1.355z",
    fill: "#1792FF"
  })), _path27 || (_path27 = /*#__PURE__*/createElement("path", {
    d: "M18.857 10.617l-2.272 1.355-2.285-1.355 2.272-1.356 2.285 1.356z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9.134a.14.14 0 01.142 0l2.286 1.355a.147.147 0 01.071.128l-.013 2.767c0 .052-.028.1-.072.127l-2.271 1.355a.14.14 0 01-.143 0l-2.286-1.355a.148.148 0 01-.071-.128l.013-2.767c0-.052.028-.1.071-.127L16.5 9.134zm.071.297l-2.13 1.27-.012 2.598 2.142 1.27 2.13-1.27.012-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.176 10.543a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.072.129l-.014 2.766a.145.145 0 01-.144.147.145.145 0 01-.142-.148l.013-2.682-2.213-1.312a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.98 10.543a.15.15 0 01-.051.2L16.657 12.1a.14.14 0 01-.195-.053.15.15 0 01.052-.201l2.271-1.356a.14.14 0 01.196.054z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/createElement("path", {
    d: "M16.572 6.502l-.014 2.767-2.272 1.355.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path32 || (_path32 = /*#__PURE__*/createElement("path", {
    d: "M14.3 7.857l-.014 2.767L12 9.27l.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path33 || (_path33 = /*#__PURE__*/createElement("path", {
    d: "M16.571 6.502L14.3 7.857l-2.285-1.355 2.272-1.355 2.285 1.355z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.214 5.02a.14.14 0 01.143 0l2.286 1.355a.148.148 0 01.071.128l-.013 2.767c0 .052-.028.1-.072.126l-2.272 1.355a.14.14 0 01-.143 0L11.93 9.397a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.355zm.072.297l-2.13 1.27-.012 2.597 2.142 1.27 2.13-1.27.012-2.597-2.142-1.27z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.89 6.429a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.148l.013-2.681-2.213-1.313a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.695 6.428a.15.15 0 01-.051.201l-2.272 1.355a.14.14 0 01-.195-.053.15.15 0 01.051-.2L16.5 6.374a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/createElement("path", {
    d: "M12 11.969l-.013 2.767-2.272 1.355.014-2.767L12 11.969zM9.727 13.324l-.014 2.767-2.285-1.356.013-2.766 2.286 1.355z",
    fill: "#1792FF"
  })), _path38 || (_path38 = /*#__PURE__*/createElement("path", {
    d: "M12 11.969l-2.272 1.355-2.286-1.355 2.272-1.356L12 11.97z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.642 10.486a.14.14 0 01.143 0l2.285 1.355a.147.147 0 01.072.128l-.014 2.767c0 .052-.027.1-.07.127l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.127l2.272-1.355zm.072.297l-2.13 1.27-.013 2.598 2.142 1.27 2.13-1.27.013-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.318 11.895a.14.14 0 01.195-.054L9.8 13.197a.148.148 0 01.071.128l-.014 2.766a.145.145 0 01-.143.147.145.145 0 01-.142-.148l.013-2.682-2.214-1.312a.15.15 0 01-.052-.2z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.123 11.895a.15.15 0 01-.052.2L9.8 13.452a.14.14 0 01-.196-.053.15.15 0 01.052-.201l2.272-1.356a.14.14 0 01.195.054z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/createElement("path", {
    d: "M14.286 13.32l-.014 2.767L12 17.442l.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path43 || (_path43 = /*#__PURE__*/createElement("path", {
    d: "M12.014 14.675L12 17.442l-2.285-1.355.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path44 || (_path44 = /*#__PURE__*/createElement("path", {
    d: "M14.286 13.32l-2.272 1.355L9.73 13.32 12 11.965l2.286 1.355z",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.928 11.838a.14.14 0 01.143 0l2.286 1.355a.147.147 0 01.071.128l-.014 2.767c0 .052-.027.1-.07.126L12.07 17.57a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.355zm.072.297l-2.13 1.27-.013 2.598L12 17.273l2.13-1.27.012-2.598L12 12.135z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.604 13.247a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.147l.013-2.682-2.213-1.313a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.41 13.246a.15.15 0 01-.053.201l-2.271 1.356a.14.14 0 01-.196-.054.15.15 0 01.052-.2l2.272-1.356a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/createElement("path", {
    d: "M16.572 14.73l-.014 2.768-2.272 1.355.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path49 || (_path49 = /*#__PURE__*/createElement("path", {
    d: "M14.3 16.086l-.014 2.767L12 17.498l.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path50 || (_path50 = /*#__PURE__*/createElement("path", {
    d: "M16.571 14.73L14.3 16.087l-2.285-1.355 2.272-1.355 2.285 1.355z",
    fill: "#fff"
  })), _path51 || (_path51 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.214 13.249a.14.14 0 01.143 0l2.286 1.355a.148.148 0 01.071.128l-.013 2.767c0 .052-.028.1-.072.126l-2.272 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.355zm.072.296l-2.13 1.27-.012 2.598 2.142 1.27 2.13-1.27.012-2.597-2.142-1.27z",
    fill: "#fff"
  })), _path52 || (_path52 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.89 14.658a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.148l.013-2.681-2.213-1.313a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path53 || (_path53 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.695 14.657a.15.15 0 01-.051.201l-2.272 1.355a.14.14 0 01-.195-.053.15.15 0 01.051-.201l2.272-1.355a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/createElement("path", {
    d: "M12 9.264l-.013 2.767-2.272 1.355.014-2.766L12 9.264zM9.727 10.62l-.014 2.767-2.285-1.356.013-2.767 2.286 1.356z",
    fill: "#1792FF"
  })), _path55 || (_path55 = /*#__PURE__*/createElement("path", {
    d: "M12 9.264L9.728 10.62 7.442 9.265l2.272-1.356L12 9.265z",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.642 7.782a.14.14 0 01.143 0l2.285 1.355a.148.148 0 01.072.128l-.014 2.767c0 .052-.027.1-.07.127l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128L7.3 9.264c0-.052.027-.1.071-.127l2.272-1.355zm.072.297l-2.13 1.27-.013 2.598 2.142 1.27 2.13-1.27.013-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path57 || (_path57 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.318 9.191a.14.14 0 01.195-.054L9.8 10.492a.148.148 0 01.071.128l-.014 2.767a.145.145 0 01-.143.146.145.145 0 01-.142-.147l.013-2.682L7.37 9.392a.15.15 0 01-.052-.201z",
    fill: "#fff"
  })), _path58 || (_path58 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.123 9.19a.15.15 0 01-.052.202L9.8 10.747a.14.14 0 01-.196-.054.15.15 0 01.052-.2l2.272-1.356a.14.14 0 01.195.054z",
    fill: "#fff"
  })), _path59 || (_path59 = /*#__PURE__*/createElement("path", {
    d: "M14.286 10.617l-.014 2.766L12 14.74l.014-2.767 2.272-1.355zM12.014 11.972L12 14.739l-2.285-1.356.014-2.766 2.285 1.355z",
    fill: "#1792FF"
  })), _path60 || (_path60 = /*#__PURE__*/createElement("path", {
    d: "M14.286 10.617l-2.272 1.355-2.285-1.355L12 9.26l2.286 1.356z",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.928 9.134a.14.14 0 01.143 0l2.286 1.355a.148.148 0 01.071.128l-.014 2.767c0 .052-.027.1-.07.127l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.127l2.272-1.355zm.072.297l-2.13 1.27-.013 2.598L12 14.569l2.13-1.27.012-2.598L12 9.431z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.604 10.543a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.071.129l-.013 2.766a.145.145 0 01-.144.147.145.145 0 01-.142-.148l.013-2.682-2.213-1.312a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.41 10.543a.15.15 0 01-.053.2L12.087 12.1a.14.14 0 01-.196-.053.15.15 0 01.052-.201l2.272-1.356a.14.14 0 01.195.054z",
    fill: "#fff"
  })), _path64 || (_path64 = /*#__PURE__*/createElement("path", {
    d: "M16.572 12.027l-.014 2.767-2.272 1.355.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path65 || (_path65 = /*#__PURE__*/createElement("path", {
    d: "M14.3 13.383l-.014 2.766L12 14.794l.014-2.767 2.285 1.356z",
    fill: "#1792FF"
  })), _path66 || (_path66 = /*#__PURE__*/createElement("path", {
    d: "M16.571 12.027L14.3 13.383l-2.285-1.356 2.272-1.355 2.285 1.355z",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.214 10.545a.14.14 0 01.143 0l2.286 1.355a.148.148 0 01.071.128l-.013 2.767c0 .052-.028.1-.072.126l-2.272 1.355a.14.14 0 01-.143 0l-2.285-1.354a.148.148 0 01-.072-.129l.014-2.766c0-.053.027-.1.071-.127l2.272-1.355zm.072.297l-2.13 1.27-.012 2.598 2.142 1.27 2.13-1.27.012-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path68 || (_path68 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.89 11.954a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.147l.013-2.682-2.213-1.313a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path69 || (_path69 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.695 11.954a.15.15 0 01-.051.2l-2.272 1.356a.14.14 0 01-.195-.054.15.15 0 01.051-.2L16.5 11.9a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/createElement("path", {
    d: "M12 6.56l-.013 2.768-2.272 1.355.014-2.767L12 6.561zM9.727 7.916l-.014 2.767-2.285-1.355.013-2.767 2.286 1.355z",
    fill: "#1792FF"
  })), _path71 || (_path71 = /*#__PURE__*/createElement("path", {
    d: "M12 6.56L9.728 7.917 7.442 6.561l2.272-1.355L12 6.56z",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.642 5.079a.14.14 0 01.143 0l2.285 1.355a.148.148 0 01.072.128l-.014 2.767c0 .052-.027.1-.07.126L9.784 10.81a.14.14 0 01-.143 0L7.357 9.455a.148.148 0 01-.072-.128L7.3 6.56c0-.052.027-.1.071-.126l2.272-1.355zm.072.296l-2.13 1.27-.013 2.598 2.142 1.27 2.13-1.27.013-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.318 6.487a.14.14 0 01.195-.054L9.8 7.79a.148.148 0 01.071.128l-.014 2.767a.145.145 0 01-.143.146.145.145 0 01-.142-.148l.013-2.681L7.37 6.688a.15.15 0 01-.052-.2z",
    fill: "#fff"
  })), _path74 || (_path74 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.123 6.487a.15.15 0 01-.052.2L9.8 8.044a.14.14 0 01-.196-.053.15.15 0 01.052-.201l2.272-1.355a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path75 || (_path75 = /*#__PURE__*/createElement("path", {
    d: "M14.286 7.913l-.014 2.767L12 12.035l.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path76 || (_path76 = /*#__PURE__*/createElement("path", {
    d: "M12.014 9.268L12 12.035 9.715 10.68l.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path77 || (_path77 = /*#__PURE__*/createElement("path", {
    d: "M14.286 7.913l-2.272 1.355L9.73 7.913 12 6.558l2.286 1.355z",
    fill: "#fff"
  })), _path78 || (_path78 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.928 6.43a.14.14 0 01.143 0l2.286 1.356a.148.148 0 01.071.128l-.014 2.767c0 .052-.027.1-.07.126l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.355zm.072.297l-2.13 1.27-.013 2.598L12 11.865l2.13-1.27.012-2.597L12 6.728z",
    fill: "#fff"
  })), _path79 || (_path79 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.604 7.84a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.148l.013-2.681L9.657 8.04a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path80 || (_path80 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.41 7.84a.15.15 0 01-.053.2l-2.271 1.355a.14.14 0 01-.196-.053.15.15 0 01.052-.201l2.272-1.355a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path81 || (_path81 = /*#__PURE__*/createElement("path", {
    d: "M16.572 9.324l-.014 2.767-2.272 1.355.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path82 || (_path82 = /*#__PURE__*/createElement("path", {
    d: "M14.3 10.679l-.014 2.767L12 12.09l.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path83 || (_path83 = /*#__PURE__*/createElement("path", {
    d: "M16.571 9.324L14.3 10.679l-2.285-1.355 2.272-1.356 2.285 1.356z",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.214 7.841a.14.14 0 01.143 0l2.286 1.355a.148.148 0 01.071.128l-.013 2.767c0 .052-.028.1-.072.127l-2.272 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.356zm.072.297l-2.13 1.27-.012 2.598 2.142 1.27 2.13-1.27.012-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path85 || (_path85 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.89 9.25a.14.14 0 01.195-.054l2.286 1.356a.147.147 0 01.071.128l-.013 2.766a.145.145 0 01-.144.147.145.145 0 01-.142-.148l.013-2.682-2.213-1.312a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path86 || (_path86 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.695 9.25a.15.15 0 01-.051.2l-2.272 1.356a.14.14 0 01-.195-.053.15.15 0 01.051-.201L16.5 9.196a.14.14 0 01.195.054z",
    fill: "#fff"
  })), _path87 || (_path87 = /*#__PURE__*/createElement("path", {
    d: "M12 14.73l-.013 2.768-2.272 1.355.014-2.767L12 14.731zM9.727 16.086l-.014 2.767-2.285-1.355.013-2.767 2.286 1.355z",
    fill: "#1792FF"
  })), _path88 || (_path88 = /*#__PURE__*/createElement("path", {
    d: "M12 14.73l-2.272 1.356-2.286-1.355 2.272-1.355L12 14.73z",
    fill: "#fff"
  })), _path89 || (_path89 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.642 13.249a.14.14 0 01.143 0l2.285 1.355a.148.148 0 01.072.128l-.014 2.767c0 .052-.027.1-.07.126L9.784 18.98a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128L7.3 14.73c0-.052.027-.1.071-.126l2.272-1.355zm.072.296l-2.13 1.27-.013 2.598 2.142 1.27 2.13-1.27.013-2.597-2.142-1.27z",
    fill: "#fff"
  })), _path90 || (_path90 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.318 14.658a.14.14 0 01.195-.054L9.8 15.959a.148.148 0 01.071.128l-.014 2.767a.145.145 0 01-.143.146.145.145 0 01-.142-.148l.013-2.681-2.214-1.313a.15.15 0 01-.052-.2z",
    fill: "#fff"
  })), _path91 || (_path91 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.123 14.657a.15.15 0 01-.052.201L9.8 16.213a.14.14 0 01-.196-.053.15.15 0 01.052-.201l2.272-1.355a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path92 || (_path92 = /*#__PURE__*/createElement("path", {
    d: "M9.713 10.675L9.7 13.442l-2.272 1.355.013-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path93 || (_path93 = /*#__PURE__*/createElement("path", {
    d: "M7.442 12.03l-.014 2.767-2.285-1.355.013-2.767 2.286 1.355z",
    fill: "#1792FF"
  })), _path94 || (_path94 = /*#__PURE__*/createElement("path", {
    d: "M9.714 10.675L7.442 12.03l-2.286-1.355L7.428 9.32l2.286 1.355z",
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.357 9.193a.14.14 0 01.143 0l2.285 1.355a.148.148 0 01.072.128l-.014 2.767c0 .052-.027.1-.071.126L7.5 14.924a.14.14 0 01-.143 0L5.072 13.57A.148.148 0 015 13.44l.014-2.767c0-.052.027-.1.07-.126l2.273-1.355zm.072.297l-2.13 1.27-.013 2.598 2.142 1.27 2.13-1.27.013-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path96 || (_path96 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.033 10.602a.14.14 0 01.195-.054l2.285 1.355a.148.148 0 01.072.128l-.014 2.767a.145.145 0 01-.143.146.145.145 0 01-.142-.147l.013-2.682-2.214-1.313a.15.15 0 01-.052-.2z",
    fill: "#fff"
  })), _path97 || (_path97 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.837 10.601a.15.15 0 01-.052.201l-2.272 1.356a.14.14 0 01-.195-.054.15.15 0 01.052-.2l2.272-1.356a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path98 || (_path98 = /*#__PURE__*/createElement("path", {
    d: "M12 12.027l-.013 2.767-2.272 1.355.014-2.767L12 12.027zM9.727 13.383l-.014 2.766-2.285-1.355.013-2.767 2.286 1.356z",
    fill: "#1792FF"
  })), _path99 || (_path99 = /*#__PURE__*/createElement("path", {
    d: "M12 12.027l-2.272 1.356-2.286-1.356 2.272-1.355L12 12.027z",
    fill: "#fff"
  })), _path100 || (_path100 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.642 10.545a.14.14 0 01.143 0L12.07 11.9a.147.147 0 01.072.128l-.014 2.767c0 .052-.027.1-.07.126l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.354a.148.148 0 01-.072-.129l.014-2.766c0-.053.027-.1.071-.127l2.272-1.355zm.072.297l-2.13 1.27-.013 2.598 2.142 1.27 2.13-1.27.013-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path101 || (_path101 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.318 11.954a.14.14 0 01.195-.054L9.8 13.255a.148.148 0 01.071.128l-.014 2.767a.145.145 0 01-.143.146.145.145 0 01-.142-.147l.013-2.682-2.214-1.313a.15.15 0 01-.052-.2z",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.123 11.954a.15.15 0 01-.052.2L9.8 13.51a.14.14 0 01-.196-.054.15.15 0 01.052-.2l2.272-1.356a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path103 || (_path103 = /*#__PURE__*/createElement("path", {
    d: "M14.286 13.438l-.014 2.767L12 17.56l.014-2.767 2.272-1.355z",
    fill: "#1792FF"
  })), _path104 || (_path104 = /*#__PURE__*/createElement("path", {
    d: "M12.014 14.793L12 17.56l-2.285-1.355.014-2.767 2.285 1.355z",
    fill: "#1792FF"
  })), _path105 || (_path105 = /*#__PURE__*/createElement("path", {
    d: "M14.286 13.438l-2.272 1.355-2.285-1.355L12 12.083l2.286 1.355z",
    fill: "#fff"
  })), _path106 || (_path106 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.928 11.956a.14.14 0 01.143 0l2.286 1.355a.148.148 0 01.071.128l-.014 2.767c0 .052-.027.1-.07.126l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128l.014-2.767c0-.052.027-.1.071-.126l2.272-1.355zm.072.296l-2.13 1.27-.013 2.598L12 17.39l2.13-1.27.012-2.597L12 12.253z",
    fill: "#fff"
  })), _path107 || (_path107 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.604 13.365a.14.14 0 01.195-.054l2.286 1.355a.148.148 0 01.071.128l-.013 2.767a.145.145 0 01-.144.146.145.145 0 01-.142-.148l.013-2.681-2.213-1.313a.15.15 0 01-.053-.2z",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.41 13.364a.15.15 0 01-.053.201l-2.271 1.355a.14.14 0 01-.196-.053.15.15 0 01.052-.2l2.272-1.356a.14.14 0 01.195.053z",
    fill: "#fff"
  })), _path109 || (_path109 = /*#__PURE__*/createElement("path", {
    d: "M12 9.324l-.013 2.767-2.272 1.355.014-2.767L12 9.324zM9.727 10.679l-.014 2.767-2.285-1.355.013-2.767 2.286 1.355z",
    fill: "#1792FF"
  })), _path110 || (_path110 = /*#__PURE__*/createElement("path", {
    d: "M12 9.324l-2.272 1.355-2.286-1.355 2.272-1.356L12 9.324z",
    fill: "#fff"
  })), _path111 || (_path111 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.642 7.841a.14.14 0 01.143 0l2.285 1.355a.148.148 0 01.072.128l-.014 2.767c0 .052-.027.1-.07.127l-2.273 1.355a.14.14 0 01-.143 0l-2.285-1.355a.148.148 0 01-.072-.128L7.3 9.323c0-.052.027-.1.071-.126L9.642 7.84zm.072.297l-2.13 1.27-.013 2.598 2.142 1.27 2.13-1.27.013-2.598-2.142-1.27z",
    fill: "#fff"
  })), _path112 || (_path112 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.318 9.25a.14.14 0 01.195-.054L9.8 10.552a.148.148 0 01.071.128l-.014 2.766a.145.145 0 01-.143.147.145.145 0 01-.142-.148l.013-2.682L7.37 9.451a.15.15 0 01-.052-.2z",
    fill: "#fff"
  })), _path113 || (_path113 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.123 9.25a.15.15 0 01-.052.2L9.8 10.807a.14.14 0 01-.196-.053.15.15 0 01.052-.201l2.272-1.356a.14.14 0 01.195.054z",
    fill: "#fff"
  })));
}

var _rect$5, _g$1, _defs$1;

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

function SvgEth(props) {
  return /*#__PURE__*/createElement("svg", _extends$5({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$5 || (_rect$5 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#fff"
  })), _g$1 || (_g$1 = /*#__PURE__*/createElement("g", {
    clipPath: "url(#eth_svg__clip1)"
  }, /*#__PURE__*/createElement("path", {
    d: "M12.498 3l-.12.41v11.9l.12.12 5.498-3.265L12.498 3z",
    fill: "#343434"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.498 3L7 12.165l5.498 3.265V3z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.498 16.476l-.067.083v4.238l.067.199L18 13.212l-5.502 3.264z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.498 20.996v-4.52L7 13.212l5.498 7.784z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.498 15.43l5.498-3.265-5.498-2.51v5.775z",
    fill: "#141414"
  }), /*#__PURE__*/createElement("path", {
    d: "M7 12.165l5.498 3.265V9.654L7 12.164z",
    fill: "#393939"
  }))), _defs$1 || (_defs$1 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: "eth_svg__clip1"
  }, /*#__PURE__*/createElement("path", {
    fill: "#fff",
    d: "M7 3h11v18H7z"
  })))));
}

var _rect$6, _path$4, _path2$2;

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

function SvgIq(props) {
  return /*#__PURE__*/createElement("svg", _extends$6({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$6 || (_rect$6 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#fff"
  })), _path$4 || (_path$4 = /*#__PURE__*/createElement("path", {
    d: "M10.551 5.205a7.085 7.085 0 00-4.276 2.972c-.494.745-.791 1.452-.993 2.369-.14.611-.186 1.687-.103 2.348.21 1.729 1.06 3.265 2.432 4.428.718.607 1.526 1.055 1.526.846 0-.03-.087-.134-.19-.239-.705-.69-1.076-1.9-.927-3.026.197-1.498.804-2.499 1.987-3.277.223-.147.425-.268.45-.268.086 0 .032-.176-.182-.594-.412-.791-.56-1.336-.56-2.055 0-1.105.46-2.286 1.17-3.001.206-.205.23-.247.23-.41 0-.164-.007-.176-.11-.172-.066 0-.268.037-.454.08z",
    fill: "#5DF"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/createElement("path", {
    d: "M14.744 5.645c0 .033.061.15.14.26.367.527.56 1.096.59 1.749.036.79-.174 1.477-.561 1.825-.285.255-.532.263-.887.037-.251-.163-.28-.28-.111-.498.284-.364.458-.933.458-1.519 0-.607-.116-.946-.43-1.239-.337-.314-.68-.406-1.137-.297-.466.105-.903.611-1.138 1.318-.12.364-.223.992-.223 1.356.004.687.206 1.495.499 1.989.165.28.573.74.816.92.091.067.17.138.17.151 0 .017-.087.059-.194.1-.792.298-1.588 1.19-1.942 2.173-.227.627-.31 1.138-.28 1.724.032.72.16 1.059.564 1.503.318.351.92.51 1.641.44.833-.089 1.472-.39 2.02-.963.24-.256.29-.285.334-.23.042.05.033.091-.053.242-.544.938-1.559 1.741-2.499 1.976-.206.05-.293.092-.293.138 0 .15 1.283-.059 2.058-.335 1.983-.703 3.616-2.373 4.275-4.365.273-.825.318-1.152.322-2.177.004-.8-.008-.984-.09-1.39-.4-2.017-1.683-3.737-3.559-4.775-.33-.184-.49-.222-.49-.113z",
    fill: "#B3B3B3"
  })));
}

var _rect$7, _path$5, _path2$3, _path3$1, _path4$1, _path5$1, _path6$1, _path7$1, _path8$1, _defs$2;

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

function SvgLeo(props) {
  return /*#__PURE__*/createElement("svg", _extends$7({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$7 || (_rect$7 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#0A1116"
  })), _path$5 || (_path$5 = /*#__PURE__*/createElement("path", {
    d: "M9.56 11.141h.005l.092.032.092.031.091.037.092.031.091.032.092.031.092.037.091.031.092.032.092.031.091.037.092.031.092.031.091.032.092.037.091.03.092.032.086.032.092.036.091.032.092.031v-1.262H9.436l-.086.042-.216.11-.215.11-.21.105-.216.11-.21.11-.216.11-.215.104-.21.11-.216.11-.216.105-.194.1L7 14.885l.21.146.216.147.215.147.21.141.216.147.216.146.097.068.113-.146.215-.273.022-.026-.022-.01-.215-.147-.21-.146-.216-.147-.215-.147-.21-.146-.06-.042.01-2.503.05-.02.21-.105.215-.105.216-.1.21-.104.215-.105.21-.1.216-.104.216-.105.21-.105z",
    fill: "url(#leo_svg__paint0_linear)"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/createElement("path", {
    d: "M13.248 17.047l-.184.073-.2.074-.199.078-.199.079-.097.036-.102-.052-.2-.094-.2-.1-.199-.1-.2-.093-.193-.1-.2-.1-.199-.094-.2-.099-.199-.1-.2-.094-.199-.1-.199-.099-.022-.01v-2.524h-.571v2.87l.194.099.2.094.199.1.2.099.199.094.2.1.199.1.2.093.198.1.2.094.194.1.2.1.199.093.2.1.199.1.075.036.124-.047.2-.079.199-.078.2-.079.199-.073.194-.079-.194-.481-.016-.037z",
    fill: "url(#leo_svg__paint1_linear)"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/createElement("path", {
    d: "M16.799 13.534l.01 1.194-.059.036-.334.236-.34.23-.339.236-.334.236-.34.235-.339.23-.334.236-.205.142-.135-.105-.34-.252-.333-.25-.34-.252-.34-.251-.053-.042v-1.278l.053-.057.34-.346.34-.34.334-.346.34-.34.328-.335h-4.042l.334.345.34.34.34.346.333.34.34.346.043.047v1.55l.296.22.335.251.34.251.339.252.334.256.34.252.123.089.216-.147.334-.236.34-.235.34-.23.333-.236.34-.236.34-.23.333-.236.34-.235.286-.194.054-1.466-.34-.01-.291-.011z",
    fill: "url(#leo_svg__paint2_linear)"
  })), _path4$1 || (_path4$1 = /*#__PURE__*/createElement("path", {
    d: "M7.544 10.77h.038l.01-1.587.222-.13.27-.163.263-.157.27-.157.27-.162.263-.157.27-.163.27-.157.263-.157.27-.162h.005l.264.141.264.147.27.152.27.146.264.147.269.152.27.146.258.142.011-.016.264-.471-.264-.147-.27-.152-.269-.146-.27-.147-.264-.147-.269-.151-.27-.147-.264-.147-.27-.146-.005-.005-.264.157-.264.157-.27.157-.269.162-.264.157-.27.162-.269.158-.264.157-.27.162-.269.157-.264.162-.258.152-.011 1.895.27.006h.263z",
    fill: "url(#leo_svg__paint3_linear)"
  })), _path5$1 || (_path5$1 = /*#__PURE__*/createElement("path", {
    d: "M17.995 9.314l-.134-.105-.14-.11-.14-.11-.14-.104-.14-.11-.141-.11-.14-.11-.14-.11-.14-.11-.103-.078-.038.041-.14.173-.14.168-.043.052.043.032.14.115.14.115.14.115.14.11.14.115.141.115.14.116.07.057.011 2.55-.08.052-.141.084-.14.089-.14.084-.14.089-.14.084-.14.089-.14.083-.14.09-.141.083-.14.09-.14.083-.14.089-.14.084-.14.089-.14.083-.146.09.145.214.14.215.022.036.119-.068.14-.083.14-.084.14-.084.14-.084.14-.089.14-.083.14-.084.14-.084.14-.084.14-.084.14-.089.141-.083.14-.084.14-.084.14-.084.14-.083.14-.084.14-.09-.005-3.125z",
    fill: "url(#leo_svg__paint4_linear)"
  })), _path6$1 || (_path6$1 = /*#__PURE__*/createElement("path", {
    d: "M13.418 10.838v1.11l.043-.021.189-.074.183-.073.188-.073.19-.074.182-.073.19-.073.182-.073.189-.074.189-.073.183-.073.188-.074V7.775l-.215-.12-.216-.126-.215-.12-.21-.126-.216-.12-.216-.121-.215-.126-.216-.12-.21-.12-.216-.126-.215-.12-.216-.121-.215-.126-.216-.12L12.4 6l-.102.052-.216.116-.215.115-.216.11-.215.115-.216.115-.21.11.21.12.216.12.14.08.075-.043.216-.11.215-.11.216-.104.086-.047.124.073.216.12.215.12.216.127.215.12.216.12.21.126.216.12.215.12.216.127.216.12.21.12.07.042v2.466h-1.52",
    fill: "url(#leo_svg__paint5_linear)"
  })), _path7$1 || (_path7$1 = /*#__PURE__*/createElement("path", {
    d: "M13.42 11.948l2.096-.828-2.102-.56",
    fill: "url(#leo_svg__paint6_linear)"
  })), _path8$1 || (_path8$1 = /*#__PURE__*/createElement("path", {
    d: "M11.484 11.948v-1.372l-1.919.56 1.92.801",
    fill: "url(#leo_svg__paint7_linear)"
  })), _defs$2 || (_defs$2 = /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("linearGradient", {
    id: "leo_svg__paint0_linear",
    x1: 9.242,
    y1: 10.565,
    x2: 9.242,
    y2: 15.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#F7EC12"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.132,
    stopColor: "#F7E213"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.359,
    stopColor: "#F5C616"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.652,
    stopColor: "#F49A1B"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.998,
    stopColor: "#F15C22"
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#F15C22"
  })), /*#__PURE__*/createElement("linearGradient", {
    id: "leo_svg__paint1_linear",
    x1: 11.372,
    y1: 13.63,
    x2: 11.372,
    y2: 17.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#F7EC12"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.132,
    stopColor: "#F7E213"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.359,
    stopColor: "#F5C616"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.652,
    stopColor: "#F49A1B"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.998,
    stopColor: "#F15C22"
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#F15C22"
  })), /*#__PURE__*/createElement("linearGradient", {
    id: "leo_svg__paint2_linear",
    x1: 13.881,
    y1: 12.352,
    x2: 13.881,
    y2: 17.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#F7EC12"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.132,
    stopColor: "#F7E213"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.359,
    stopColor: "#F5C616"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.652,
    stopColor: "#F49A1B"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.998,
    stopColor: "#F15C22"
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#F15C22"
  })), /*#__PURE__*/createElement("linearGradient", {
    id: "leo_svg__paint3_linear",
    x1: 9.822,
    y1: 6.969,
    x2: 9.822,
    y2: 10.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#F7EC12"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.132,
    stopColor: "#F7E213"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.359,
    stopColor: "#F5C616"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.652,
    stopColor: "#F49A1B"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.998,
    stopColor: "#F15C22"
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#F15C22"
  })), /*#__PURE__*/createElement("linearGradient", {
    id: "leo_svg__paint4_linear",
    x1: 16.529,
    y1: 8.256,
    x2: 16.529,
    y2: 14.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#F7EC12"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.132,
    stopColor: "#F7E213"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.359,
    stopColor: "#F5C616"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.652,
    stopColor: "#F49A1B"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.998,
    stopColor: "#F15C22"
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#F15C22"
  })), /*#__PURE__*/createElement("linearGradient", {
    id: "leo_svg__paint5_linear",
    x1: 13.26,
    y1: 6,
    x2: 13.26,
    y2: 11.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#F7EC12"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.132,
    stopColor: "#F7E213"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.359,
    stopColor: "#F5C616"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.652,
    stopColor: "#F49A1B"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.998,
    stopColor: "#F15C22"
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#F15C22"
  })), /*#__PURE__*/createElement("linearGradient", {
    id: "leo_svg__paint6_linear",
    x1: 14.465,
    y1: 10.558,
    x2: 14.465,
    y2: 11.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#F7EC12"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.132,
    stopColor: "#F7E213"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.359,
    stopColor: "#F5C616"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.652,
    stopColor: "#F49A1B"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.998,
    stopColor: "#F15C22"
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#F15C22"
  })), /*#__PURE__*/createElement("linearGradient", {
    id: "leo_svg__paint7_linear",
    x1: 10.504,
    y1: 11.599,
    x2: 10.935,
    y2: 10.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/createElement("stop", {
    stopColor: "#F7EC12"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.132,
    stopColor: "#F7E213"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.359,
    stopColor: "#F5C616"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.652,
    stopColor: "#F49A1B"
  }), /*#__PURE__*/createElement("stop", {
    offset: 0.998,
    stopColor: "#F15C22"
  }), /*#__PURE__*/createElement("stop", {
    offset: 1,
    stopColor: "#F15C22"
  })))));
}

var _rect$8, _path$6, _path2$4, _path3$2;

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

function SvgNut(props) {
  return /*#__PURE__*/createElement("svg", _extends$8({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$8 || (_rect$8 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#002C54"
  })), _path$6 || (_path$6 = /*#__PURE__*/createElement("path", {
    d: "M7.335 16.272l.078-.354c.274-1.191.552-2.382.82-3.574.037-.166.086-.203.258-.127 2.57 1.131 5.144 2.257 7.72 3.378.218.096.274.276.354.448.181.378.206.302-.16.508-1.4.793-2.805 1.584-4.203 2.382-.156.088-.273.09-.43 0-1.42-.814-2.843-1.62-4.265-2.431-.076-.041-.189-.068-.172-.23zM16.046 12.401c.01.092-.025.111-.091.085-.049-.02-.096-.043-.143-.065-2.32-1.076-4.643-2.15-6.965-3.225-.161-.076-.197-.148-.158-.317a3.27 3.27 0 01.615-1.287c.857-1.135 1.688-2.29 2.53-3.436.152-.207.156-.207.307-.005l2.91 3.894a.685.685 0 01.125.273c.285 1.337.57 2.673.857 4.009l.013.074z",
    fill: "#FEFEFE"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/createElement("path", {
    d: "M6 14.295c.011-.048.023-.11.04-.17.341-1.318.684-2.636 1.028-3.953l.015-.055c.074-.248.174-.293.418-.185l4.103 1.836 5.637 2.525c.024.01.047.022.072.031.048.018.098.06.147.03.064-.037.026-.103.015-.154-.114-.562-.229-1.124-.346-1.685l-.386-1.868a.584.584 0 01-.016-.186.159.159 0 01.046-.102.172.172 0 01.103-.05c.095-.013.172.016.209.104.025.065.045.132.058.2l.822 3.918c.009.043.015.087.024.13.021.09.017.177-.063.242-.089.07-.183.049-.276.007l-1.659-.743-8.293-3.719c-.245-.11-.248-.108-.312.138l-.946 3.623a1.356 1.356 0 01-.056.18c-.04.092-.113.144-.216.127-.116-.019-.159-.102-.168-.221z",
    fill: "#FEFEFE"
  })), _path3$2 || (_path3$2 = /*#__PURE__*/createElement("path", {
    d: "M11.46 18.258c-.097 0-.147-.046-.202-.076-1.096-.623-2.189-1.25-3.287-1.865-.162-.09-.193-.182-.154-.348.241-1.019.472-2.038.705-3.058.05-.217.058-.22.269-.129.418.183.835.368 1.254.548.102.044.172.101.2.212l1.2 4.611c.009.03.01.061.015.105zM12.37 18.245l.203-.747c.228-.84.458-1.679.68-2.52.042-.16.097-.205.268-.128.802.36 1.61.71 2.415 1.063.06.026.124.046.163.102.076.11.11.2-.05.29-1.18.66-2.353 1.326-3.529 1.991-.043.024-.087.07-.142.038-.034-.019-.009-.057-.008-.089zM11.93 18.251c-.072-.07-.072-.143-.089-.208a1822.54 1822.54 0 01-1.086-4.166c-.017-.065-.07-.145-.017-.196.061-.057.134.014.195.041.61.264 1.216.534 1.825.796.119.051.175.104.138.241-.313 1.135-.62 2.272-.929 3.408a.633.633 0 01-.037.084zM12.249 5.02c.073.015.095.08.131.129a3965.79 3965.79 0 012.258 3.02.889.889 0 01.164.358c.217 1.029.438 2.056.656 3.085.012.056.063.128-.01.172-.054.032-.112-.017-.163-.041-.338-.155-.673-.313-1.011-.466a.439.439 0 01-.225-.224c-.588-1.22-1.178-2.44-1.77-3.66a.618.618 0 01-.069-.273V5.14c0-.043-.012-.091.039-.12zM11.794 4.967c0 .412-.028.803.006 1.19a3.418 3.418 0 01-.46 2.061c-.225.39-.395.809-.58 1.218-.058.125-.12.158-.254.093a39.744 39.744 0 00-1.222-.567c-.126-.056-.154-.126-.122-.252.055-.233.157-.452.3-.647.723-.973 1.436-1.953 2.154-2.93.04-.054.066-.123.178-.166zM13.494 10.867c-.093.022-.145-.024-.202-.05-.686-.317-1.37-.639-2.058-.95-.147-.067-.174-.133-.105-.274.248-.507.485-1.02.727-1.528.03-.062.054-.13.147-.132.092-.001.12.065.15.128.44.906.879 1.813 1.317 2.722a.56.56 0 01.024.084z",
    fill: "#002C54"
  })));
}

var _mask, _g$2;

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

function SvgPlaceholder(props) {
  return /*#__PURE__*/createElement("svg", _extends$9({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/createElement("mask", {
    id: "placeholder_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#0A1116"
  }))), _g$2 || (_g$2 = /*#__PURE__*/createElement("g", {
    mask: "url(#placeholder_svg__a)"
  }, /*#__PURE__*/createElement("path", {
    d: "M32 0H-9v25h41V0z",
    fill: "#C4C4C4"
  }))));
}

var _rect$9, _path$7;

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

function SvgUsd(props) {
  return /*#__PURE__*/createElement("svg", _extends$a({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$9 || (_rect$9 = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#21BB8B"
  })), _path$7 || (_path$7 = /*#__PURE__*/createElement("path", {
    d: "M15.027 11.897c-.531-.424-1.316-.835-2.397-1.258-1.178-.458-1.658-.74-1.853-.896-.23-.184-.337-.425-.337-.758 0-.238 0-.962 1.9-.962 1.019 0 1.944.165 2.75.49a.347.347 0 00.47-.251l.364-1.698a.349.349 0 00-.246-.408c-.665-.19-1.524-.305-2.558-.343V4.376A.35.35 0 0012.773 4H11.58a.35.35 0 00-.348.377l.01 1.515c-1.046.16-1.854.55-2.404 1.163-.603.672-.908 1.459-.908 2.34 0 1.02.437 1.888 1.303 2.58.507.4 1.298.81 2.418 1.257.853.337 1.442.63 1.75.874.32.253.476.546.476.897 0 .654-.76.986-2.262.986a8.65 8.65 0 01-3.118-.562.347.347 0 00-.466.253l-.363 1.721c-.04.186.078.37.263.412 1.033.239 2.138.37 3.29.392l.006 1.426a.339.339 0 00.08.26c.066.07.158.109.254.109h1.217a.348.348 0 00.34-.427l.005-1.484c2.108-.371 3.219-1.623 3.219-3.636 0-.997-.442-1.856-1.314-2.556z",
    fill: "#fff"
  })));
}

var _rect$a, _path$8;

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

function SvgUsdt(props) {
  return /*#__PURE__*/createElement("svg", _extends$b({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect$a || (_rect$a = /*#__PURE__*/createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#53AE94"
  })), _path$8 || (_path$8 = /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.424 12.988c-.08.006-.49.03-1.407.03-.73 0-1.247-.021-1.429-.03-2.818-.125-4.921-.62-4.921-1.211 0-.592 2.103-1.086 4.921-1.213v1.932c.185.013.712.044 1.442.044.875 0 1.313-.036 1.392-.044v-1.931c2.812.126 4.91.62 4.91 1.212 0 .59-2.098 1.085-4.91 1.21l.002.001zm0-2.623V8.636h3.925V6H6.664v2.636h3.924v1.729C7.398 10.511 5 11.149 5 11.912c0 .763 2.398 1.4 5.588 1.548V19h2.836v-5.542C16.606 13.31 19 12.674 19 11.912c0-.763-2.392-1.4-5.576-1.548v.001z",
    fill: "#fff"
  })));
}

var icons = {
  btc: SvgBtc,
  eth: SvgEth,
  dapp: SvgDapp,
  emanate: SvgEmanate,
  eos: SvgEos,
  eosdt: SvgEosdt,
  iq: SvgIq,
  leo: SvgLeo,
  nut: SvgNut,
  usd: SvgUsd,
  usdt: SvgUsdt
};

var TokenListIcon = function TokenListIcon(props) {
  var icon = props.icon;
  var TokenIcon = icons[icon] || SvgPlaceholder;
  return /*#__PURE__*/React__default.createElement(TokenIcon, null);
};

TokenListIcon.propTypes = {
  icon: PropTypes.string.isRequired
};

var renderer = function renderer(key, value) {
  if (!value) {
    return false;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: "tokenlist-renderer"
  }, /*#__PURE__*/React__default.createElement(TokenListIcon, {
    icon: key
  }), /*#__PURE__*/React__default.createElement("div", null, value));
};

var TokenList = function TokenList(props) {
  return /*#__PURE__*/React__default.createElement(Dropdown$2, _extends$d({
    searchable: true,
    valueRenderer: renderer,
    optionRenderer: renderer // eslint-disable-next-line react/jsx-props-no-spreading

  }, props));
};

TokenList.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired
};

var AmountInput = function AmountInput(props) {
  var name = props.name,
      label = props.label,
      dropdownName = props.dropdownName,
      dropdownClassName = props.dropdownClassName,
      tokenList = props.tokenList,
      className = props.className,
      handleAmountChange = props.handleAmountChange;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  var value = _get(values, name);

  var handleOnChange = function handleOnChange(val) {
    setFieldValue(name, val);
    handleAmountChange(val);
  };

  var leftElement = /*#__PURE__*/React__default.createElement(Field, {
    name: dropdownName,
    options: tokenList,
    component: TokenList,
    className: cx('token-dropdown', dropdownClassName)
  });
  return /*#__PURE__*/React__default.createElement(Field, {
    component: Input$2,
    name: name,
    label: label,
    leftElement: leftElement,
    fieldsToValidate: [dropdownName] // set type='text' to avoid formik validation issue with value like 1.1.1
    ,
    type: "text",
    placeholder: 0,
    alignText: "right",
    className: className,
    onChange: handleOnChange,
    value: value
  });
};

AmountInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  dropdownName: PropTypes.string.isRequired,
  dropdownClassName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  tokenList: PropTypes.object.isRequired,
  className: PropTypes.string
};
AmountInput.defaultProps = {
  className: null,
  dropdownClassName: null
};
var AmountInput$1 = /*#__PURE__*/memo(AmountInput);
/* eslint-disable no-unused-vars */

var QuickSwapRate = function QuickSwapRate(props) {
  var getConversionRate = props.getConversionRate;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values;

  var _values$fromToken = values.fromToken,
      from = _values$fromToken === void 0 ? '' : _values$fromToken,
      _values$toToken = values.toToken,
      to = _values$toToken === void 0 ? '' : _values$toToken;

  var _useTranslation = useTranslation(['quickswap']),
      t = _useTranslation.t;

  var expectedRateText = t('expected_rate');
  var expectedRate = "1 ".concat(from.toUpperCase(), " ~ ").concat(getConversionRate({
    from: from,
    to: to
  }), " ").concat(to.toUpperCase());
  return /*#__PURE__*/React__default.createElement("div", {
    className: "rate-label"
  }, /*#__PURE__*/React__default.createElement(Label, {
    tag: "div",
    label: expectedRate
  }), /*#__PURE__*/React__default.createElement(Label, {
    label: expectedRateText,
    tag: "div"
  }));
};

QuickSwapRate.propTypes = {
  getConversionRate: PropTypes.func.isRequired
};
var QuickSwapRate$1 = /*#__PURE__*/memo(QuickSwapRate);

var _path$9;

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

function SvgSwap(props) {
  return /*#__PURE__*/createElement("svg", _extends$c({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/createElement("path", {
    d: "M4.707 18l2.147 2.146a.5.5 0 01-.708.708l-3-3a.5.5 0 010-.708l3-3a.5.5 0 01.708.708L4.707 17H18.5a1.5 1.5 0 001.5-1.5v-3a.5.5 0 011 0v3a2.5 2.5 0 01-2.5 2.5H4.707zM19.293 7l-2.147-2.146a.5.5 0 01.708-.708l3 3a.5.5 0 010 .708l-3 3a.5.5 0 01-.708-.708L19.293 8H5.5A1.5 1.5 0 004 9.5v3a.5.5 0 01-1 0v-3A2.5 2.5 0 015.5 7h13.793z",
    fill: "#21BB8B"
  })));
}

var QuickSwapToggle = function QuickSwapToggle() {
  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue,
      validateForm = _useFormikContext.validateForm;

  var fromAmount = values.fromAmount,
      toAmount = values.toAmount,
      _values$fromToken = values.fromToken,
      from = _values$fromToken === void 0 ? '' : _values$fromToken,
      _values$toToken = values.toToken,
      to = _values$toToken === void 0 ? '' : _values$toToken;

  var toggle = function toggle() {
    var newValues = values;
    newValues.fromAmount = toAmount;
    newValues.toAmount = fromAmount;
    newValues.fromToken = to;
    newValues.toToken = from;
    setFieldValue('fromAmount', newValues.fromAmount);
    setFieldValue('toAmount', newValues.toAmount);
    setFieldValue('fromToken', newValues.fromToken);
    setFieldValue('toToken', newValues.toToken);
    validateForm(newValues);
  };

  return /*#__PURE__*/React__default.createElement(DefaultComp, {
    onClick: toggle,
    onKeyPress: toggle,
    className: "swap-icon"
  }, /*#__PURE__*/React__default.createElement(SvgSwap, null));
};

var AMOUNT_DECIMALS = PLATFORM_SETTINGS.AMOUNT_DECIMALS;

var QuickSwapForm = function QuickSwapForm(props) {
  var tokenList = props.tokenList,
      getConversionRate = props.getConversionRate,
      termsUrl = props.termsUrl;

  var _useTranslation = useTranslation(['quickswap']),
      t = _useTranslation.t;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue;

  var from = values.fromToken,
      to = values.toToken;

  var handleFromAmountChange = function handleFromAmountChange(fromAmount) {
    if (!fromAmount || _isNaN(Number(fromAmount))) {
      setFieldValue('toAmount', '');
    } else {
      var amount = new Big(fromAmount).multipliedBy(getConversionRate({
        from: from,
        to: to
      })).decimalPlaces(AMOUNT_DECIMALS).toString();
      setFieldValue('toAmount', amount);
    }
  };

  var handleToAmountChange = function handleToAmountChange(toAmount) {
    if (!toAmount || _isNaN(Number(toAmount))) {
      setFieldValue('fromAmount', '');
    } else {
      var amount = new Big(toAmount).dividedBy(getConversionRate({
        from: from,
        to: to
      })).decimalPlaces(AMOUNT_DECIMALS).toString();
      setFieldValue('fromAmount', amount);
    }
  };

  var checkbox = /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Trans, {
    i18nKey: "quickswap:accept_terms",
    components: [/*#__PURE__*/React__default.createElement("a", {
      href: termsUrl,
      target: "_black",
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, "Terms")]
  }));
  return /*#__PURE__*/React__default.createElement(Form, {
    className: QUICKSWAP
  }, /*#__PURE__*/React__default.createElement(Heading, {
    intent: Intent.SUCCESS,
    tag: "h3",
    alignText: "center",
    className: "title"
  }, t('title')), /*#__PURE__*/React__default.createElement(AmountInput$1, {
    label: t('from_label'),
    name: "fromAmount",
    otherName: "toAmount",
    dropdownName: "fromToken",
    dropdownClassName: "from-token",
    className: "from-amount",
    tokenList: tokenList,
    handleAmountChange: handleFromAmountChange
  }), /*#__PURE__*/React__default.createElement(QuickSwapToggle, null), /*#__PURE__*/React__default.createElement(AmountInput$1, {
    label: t('to_label'),
    name: "toAmount",
    otherName: "fromAmount",
    dropdownName: "toToken",
    dropdownClassName: "to-token",
    tokenList: tokenList,
    className: "to-amount",
    handleAmountChange: handleToAmountChange
  }), /*#__PURE__*/React__default.createElement(QuickSwapRate$1, {
    getConversionRate: getConversionRate
  }), /*#__PURE__*/React__default.createElement(Field, {
    component: Checkbox$2,
    name: "acceptedTerms",
    label: checkbox,
    className: "accept-terms"
  }), /*#__PURE__*/React__default.createElement(DefaultComp, {
    type: "submit",
    className: "swap-button",
    intent: Intent.SUCCESS
  }, " ", t('swap_now')));
};

QuickSwapForm.propTypes = {
  tokenList: PropTypes.objectOf(PropTypes.string),
  getConversionRate: PropTypes.func,
  termsUrl: PropTypes.string
};
QuickSwapForm.defaultProps = {
  tokenList: {},
  getConversionRate: function getConversionRate() {},
  termsUrl: ''
};

var QuickSwap = function QuickSwap(props) {
  var tokenList = props.tokenList,
      defaultFromToken = props.defaultFromToken,
      defaultToToken = props.defaultToToken,
      onSwapClick = props.onSwapClick,
      getAvailableBalance = props.getAvailableBalance,
      getConversionRate = props.getConversionRate,
      termsUrl = props.termsUrl;

  var _useTranslation = useTranslation(['quickswap']),
      t = _useTranslation.t;

  return /*#__PURE__*/React__default.createElement(Formik, {
    initialValues: getInitialState(defaultFromToken, defaultToToken),
    validate: validateForm(getAvailableBalance, t),
    validationSchema: formSchema(t),
    onSubmit: function onSubmit(values) {
      onSwapClick(values);
    }
  }, /*#__PURE__*/React__default.createElement(QuickSwapForm, {
    tokenList: tokenList,
    getConversionRate: getConversionRate,
    termsUrl: termsUrl
  }));
};

QuickSwap.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tokenList: PropTypes.objectOf(PropTypes.string),
  defaultFromToken: PropTypes.string,
  defaultToToken: PropTypes.string,
  onSwapClick: PropTypes.func,
  getAvailableBalance: PropTypes.func,
  getConversionRate: PropTypes.func,
  termsUrl: PropTypes.string
};
var defaultProps$1 = {
  tokenList: {},
  defaultFromToken: 'btc',
  defaultToToken: 'eth',
  onSwapClick: function onSwapClick() {},
  getAvailableBalance: function getAvailableBalance() {},
  getConversionRate: function getConversionRate() {},
  termsUrl: ''
};
QuickSwap.defaultProps = defaultProps$1;
var QuickSwap$1 = withI18nProvider(ResponsiveWrapper( /*#__PURE__*/memo(QuickSwap)));
/**
 * MobileLayoutWrapper
 *
 * HOC that passes the prop isMobileLayout to the child component
 * Takes isMobileLayout if it’s passed as prop, or else checks if the
 * components width is smaller than the breakpoint.
 *
 * Note: Requires to be wrapped inside a withResponsive HOC
 *
 * @param {Number} breakpoint
 * @returns {ReactNode} Component
 */
// disabled arrow-callback rule to have display name in devtools instead of Anonymous
// eslint-disable-next-line prefer-arrow-callback

var MobileLayoutWrapper = function MobileLayoutWrapper() {
  var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BREAKPOINTS.SM;
  return function (Component) {
    return /*#__PURE__*/forwardRef(function MobileLayoutWrapperComp(props, ref) {
      var _ResponsiveState = ResponsiveState(),
          width = _ResponsiveState.width;

      var isMobileLayout = !_isUndefined(props.isMobileLayout) ? !!props.isMobileLayout : width < breakpoint;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/jsx-props-no-spreading
        React__default.createElement(Component, _extends$d({
          ref: ref
        }, props, {
          isMobileLayout: isMobileLayout
        }))
      );
    });
  };
};

var _MAPPING;

var FAV_TAB = 'fav_tab';
var ACTION_TYPES = {
  SET_FILTER: 'SET_FILTER',
  SET_SORT: 'SET_SORT',
  SET_FAV: 'SET_FAV'
};
var KEYS = {
  ID: 'id',
  FAV: 'fav',
  BASE_CCY: 'baseCcy',
  QUOTE_CCY: 'quoteCcy',
  LAST_PRICE: 'lastPrice',
  CHANGE_PERC: 'changePerc',
  HIGH: 'high',
  LOW: 'low',
  VOLUME: 'volume'
};
var MAPPING = (_MAPPING = {}, _defineProperty(_MAPPING, KEYS.LAST_PRICE, {
  defaultValue: 0,
  format: formatPrice
}), _defineProperty(_MAPPING, KEYS.CHANGE_PERC, {
  defaultValue: 0,
  format: formatVolumePercentChange
}), _defineProperty(_MAPPING, KEYS.HIGH, {
  defaultValue: 0,
  format: formatPrice
}), _defineProperty(_MAPPING, KEYS.LOW, {
  defaultValue: 0,
  format: formatPrice
}), _defineProperty(_MAPPING, KEYS.VOLUME, {
  defaultValue: 0,
  format: formatVolume
}), _MAPPING);
/* eslint-disable import/prefer-default-export */
// label: column header
// cellStyle : td, th style
// headerCellClassName: th classname
// cellClassName: td classname
// renderer: for content to be renderered inside td

var getColumns = function getColumns() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = args.t,
      isSmallView = args.isSmallView;
  return [{
    key: KEYS.FAV,
    label: '',
    cellStyle: {
      minWidth: '45px'
    },
    renderer: function renderer(_ref) {
      var isFav = _ref.isFav,
          toggleFav = _ref.toggleFav;
      return /*#__PURE__*/React__default.createElement(DefaultComp, {
        minimal: true,
        onClick: function onClick(e) {
          e.stopPropagation();
          toggleFav();
        },
        className: "fav-button"
      }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        size: "sm",
        icon: isFav ? faStar : faStar$1
      }));
    }
  }, {
    key: KEYS.BASE_CCY,
    label: t('marketlist:symbol'),
    cellStyle: {
      width: isSmallView ? '40%' : '20%'
    },
    renderer: function renderer(_ref2) {
      var formattedValue = _ref2.formattedValue,
          quoteCcy = _ref2.quoteCcy;
      return "".concat(formattedValue, "/").concat(quoteCcy);
    }
  }, {
    key: KEYS.LAST_PRICE,
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: "hidden-lg hidden-md hidden-sm hidden-xs"
    }, t('marketlist:last_price')), /*#__PURE__*/React__default.createElement("span", {
      className: "hidden-xl"
    }, t('marketlist:last'))),
    cellStyle: {
      width: isSmallView ? '30%' : '15%'
    },
    headerCellClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT
  }, {
    key: KEYS.CHANGE_PERC,
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: "hidden-lg hidden-md hidden-sm hidden-xs"
    }, t('marketlist:24h_change')), /*#__PURE__*/React__default.createElement("span", {
      className: "hidden-xl"
    }, t('marketlist:change'))),
    cellStyle: {
      width: isSmallView ? '25%' : '15%'
    },
    headerCellClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT,
    renderer: function renderer(_ref3) {
      var formattedValue = _ref3.formattedValue,
          value = _ref3.value;
      return /*#__PURE__*/React__default.createElement("span", {
        className: getColors(value, {
          strike: 0,
          includeStrike: true
        })
      }, formattedValue);
    }
  }, {
    key: KEYS.HIGH,
    label: t('marketlist:24h_high'),
    cellStyle: {
      width: '13%'
    },
    headerCellClassName: "hidden-sm hidden-xs ".concat(RIGHT_TO_LEFT),
    cellClassName: "hidden-sm hidden-xs ".concat(RIGHT_TO_LEFT)
  }, {
    key: KEYS.LOW,
    label: t('marketlist:24h_low'),
    cellStyle: {
      width: '13%'
    },
    headerCellClassName: "hidden-sm hidden-xs ".concat(RIGHT_TO_LEFT),
    cellClassName: "hidden-sm hidden-xs ".concat(RIGHT_TO_LEFT)
  }, {
    key: KEYS.VOLUME,
    label: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, t('marketlist:24h_volume'))),
    cellStyle: {
      width: '16%'
    },
    headerCellClassName: "hidden-sm hidden-xs ".concat(RIGHT_TO_LEFT),
    cellClassName: "hidden-sm hidden-xs ".concat(RIGHT_TO_LEFT),
    renderer: function renderer(_ref4) {
      var formattedValue = _ref4.formattedValue,
          quoteCcy = _ref4.quoteCcy;
      return /*#__PURE__*/React__default.createElement("span", null, "".concat(formattedValue, " ").concat(quoteCcy));
    }
  }, {
    key: 'action',
    label: '',
    cellStyle: {
      width: '4%'
    },
    headerCellClassName: "hidden-sm hidden-xs ".concat(RIGHT_TO_LEFT),
    cellClassName: "hidden-sm hidden-xs ".concat(RIGHT_TO_LEFT),
    renderer: function renderer() {
      return /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        icon: faAngleRight
      });
    }
  }];
};

var MarketListHeader = function MarketListHeader(props) {
  var sortBy = props.sortBy,
      sortAscending = props.sortAscending,
      dispatch = props.dispatch,
      columns = props.columns;
  var icon = /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    size: "xs",
    icon: sortAscending ? faCaretUp : faCaretDown
  });

  var handleSort = function handleSort(key, label) {
    if (label) {
      dispatch({
        type: ACTION_TYPES.SET_SORT,
        payload: {
          sortBy: key,
          sortAscending: sortBy === key ? !sortAscending : false
        }
      });
    }
  };

  return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(function (_ref) {
    var key = _ref.key,
        label = _ref.label,
        headerCellClassName = _ref.headerCellClassName,
        cellStyle = _ref.cellStyle;
    return /*#__PURE__*/React__default.createElement("th", {
      key: key,
      onClick: function onClick() {
        return handleSort(key, label);
      },
      style: cellStyle,
      className: headerCellClassName
    }, label && /*#__PURE__*/React__default.createElement(DefaultComp, null, /*#__PURE__*/React__default.createElement("div", {
      className: "table-header"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "table-header__text"
    }, label), key === sortBy ? icon : /*#__PURE__*/React__default.createElement("div", {
      className: "table-header__default-icon"
    }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faCaretDown,
      size: "xs"
    }), /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faCaretUp,
      size: "xs"
    })))));
  })));
};

MarketListHeader.propTypes = {
  sortBy: PropTypes.string.isRequired,
  sortAscending: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
var Header = /*#__PURE__*/memo(MarketListHeader, _isEqual);

function ownKeys$4(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$4(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$4(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var getDefaultTab = function getDefaultTab(tabs) {
  return _get(tabs, [0, 'id'], '');
};

var getInitState = function getInitState(tabs, defaultSortBy) {
  return {
    filter: {
      baseCcy: '',
      quoteCcy: getDefaultTab(tabs)
    },
    sortBy: defaultSortBy,
    sortAscending: false
  };
};

var reducer = function reducer(state, action) {
  var type = action.type,
      payload = action.payload;
  var filterKey = payload.filterKey,
      filterValue = payload.filterValue,
      sortBy = payload.sortBy,
      sortAscending = payload.sortAscending;

  switch (type) {
    case ACTION_TYPES.SET_FILTER:
      {
        var filter = _objectSpread$4(_objectSpread$4({}, state.filter), {}, _defineProperty({}, filterKey, filterValue));

        return _objectSpread$4(_objectSpread$4({}, state), {}, {
          filter: filter
        });
      }

    case ACTION_TYPES.SET_SORT:
      return _objectSpread$4(_objectSpread$4({}, state), {}, {
        sortBy: sortBy,
        sortAscending: sortAscending
      });

    default:
      return state;
  }
};

var filterData = function filterData(_ref) {
  var data = _ref.data,
      favs = _ref.favs,
      activeTab = _ref.activeTab,
      searchTerm = _ref.searchTerm,
      sortBy = _ref.sortBy,
      sortAscending = _ref.sortAscending,
      getMappedValue = _ref.getMappedValue,
      getMappedKey = _ref.getMappedKey;

  var term = _toLower(searchTerm);

  var tab = _toLower(activeTab);

  var filtered = _filter(data, function (item) {
    var getDisplayValue = getMappedValue(item);
    var id = getDisplayValue(KEYS.ID);

    var baseCcy = _toLower(getDisplayValue(KEYS.BASE_CCY));

    var quoteCcy = _toLower(getDisplayValue(KEYS.QUOTE_CCY));

    return (quoteCcy === tab || activeTab === FAV_TAB && favs[id]) && ( // filter by activeTab
    _includes(baseCcy, term) || _includes(quoteCcy, term)); // filter by searchTerm
  });

  var mappedSortBy = getMappedKey(sortBy);

  var sorted = _orderBy(filtered, [mappedSortBy]);

  if (sortAscending) {
    return sorted;
  }

  return _reverse(sorted);
};

var MarketListRow = function MarketListRow(props) {
  var data = props.data,
      isFav = props.isFav,
      toggleFav = props.toggleFav,
      onRowClick = props.onRowClick,
      getMappedValue = props.getMappedValue,
      columns = props.columns,
      customMapping = props.customMapping;
  var getDisplayValue = getMappedValue(data);
  var quoteCcy = getDisplayValue(KEYS.QUOTE_CCY);

  var handleRowClick = function handleRowClick() {
    var id = getDisplayValue(KEYS.ID);
    onRowClick(id);
  };

  return /*#__PURE__*/React__default.createElement("tr", {
    tabIndex: "0",
    onClick: handleRowClick,
    onKeyPress: handleKeyboardEvent(['Enter'], handleRowClick)
  }, columns.map(function (_ref) {
    var key = _ref.key,
        cellClassName = _ref.cellClassName,
        cellStyle = _ref.cellStyle,
        defRenderer = _ref.renderer;
    var formattedValue = getDisplayValue(key);
    var value = getDisplayValue(key, false);

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    return /*#__PURE__*/React__default.createElement("td", {
      key: key,
      className: cellClassName,
      style: cellStyle
    }, renderer ? renderer({
      value: value,
      formattedValue: formattedValue,
      data: data,
      isFav: isFav,
      toggleFav: toggleFav,
      quoteCcy: quoteCcy
    }) : formattedValue);
  }));
};

MarketListRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  isFav: PropTypes.bool,
  toggleFav: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  getMappedValue: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  customMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)).isRequired
};
MarketListRow.defaultProps = {
  isFav: false
};
var Row$1 = /*#__PURE__*/memo(MarketListRow);

var MarketListToolbar = function MarketListToolbar(props) {
  var tabs = props.tabs,
      activeTab = props.activeTab,
      searchTerm = props.searchTerm,
      dispatch = props.dispatch;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var options = {};
  tabs.forEach(function (tab) {
    var id = _get(tab, 'id');

    var title = _get(tab, 'title');

    options[id] = title;
  });

  var applyFilter = function applyFilter(filterKey, filterValue) {
    return dispatch({
      type: ACTION_TYPES.SET_FILTER,
      payload: {
        filterKey: filterKey,
        filterValue: filterValue
      }
    });
  };

  var toggleFavButton = function toggleFavButton() {
    var selectedTab = activeTab !== FAV_TAB ? FAV_TAB : getDefaultTab(tabs);
    applyFilter(KEYS.QUOTE_CCY, selectedTab);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(MARKET_LIST, "__toolbar")
  }, /*#__PURE__*/React__default.createElement(DefaultComp, {
    className: cx('fav-button', {
      'fav-button--active': activeTab === FAV_TAB
    }),
    onClick: toggleFavButton
  }, activeTab === FAV_TAB ? /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faStar
  }) : /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faStar$1
  }), ' ', /*#__PURE__*/React__default.createElement("span", {
    className: "hidden-xs"
  }, t('marketlist:favorites'))), /*#__PURE__*/React__default.createElement(Tabs, {
    tabs: tabs,
    active: activeTab,
    containerClassName: "hidden-md hidden-sm hidden-xs",
    onChange: function onChange(value) {
      return applyFilter(KEYS.QUOTE_CCY, value);
    }
  }), /*#__PURE__*/React__default.createElement(Dropdown, {
    value: activeTab,
    options: options,
    onChange: function onChange(value) {
      return applyFilter(KEYS.QUOTE_CCY, value);
    },
    searchable: true,
    className: "quoteccy-dropdown hidden-xl hidden-lg"
  }), /*#__PURE__*/React__default.createElement(Input, {
    className: "search-input",
    rightElement: /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faSearch
    }),
    value: searchTerm,
    onChange: function onChange(value) {
      return applyFilter(KEYS.BASE_CCY, value);
    }
  }));
};

MarketListToolbar.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape(TAB_PROP_TYPE)).isRequired,
  activeTab: PropTypes.string.isRequired,
  searchTerm: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired
};
var Toolbar = /*#__PURE__*/memo(MarketListToolbar, _isEqual);

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var MarketList = function MarketList(props) {
  var data = props.data,
      tabs = props.tabs,
      onRowClick = props.onRowClick,
      favs = props.favs,
      saveFavs = props.saveFavs,
      filterData = props.filterData,
      defaultSortBy = props.defaultSortBy,
      customMapping = props.rowMapping,
      isSmallView = props.isMobileLayout;

  var _useReducer = useReducer(reducer, getInitState(tabs, defaultSortBy)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var searchTerm = _get(state, "filter.".concat(KEYS.BASE_CCY));

  var activeTab = _get(state, "filter.".concat(KEYS.QUOTE_CCY));

  var sortBy = _get(state, 'sortBy');

  var sortAscending = _get(state, 'sortAscending');

  var getMappedKey = getMappingForKey(customMapping);
  var getMappedValue = useCallback(function (d) {
    return getValue({
      mapping: MAPPING,
      customMapping: customMapping,
      data: d
    });
  }, [customMapping]);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var columns = useMemo(function () {
    return getColumns({
      t: t,
      isSmallView: isSmallView
    });
  }, [t, isSmallView]);
  var filtered = useMemo(function () {
    return filterData({
      data: data,
      favs: favs,
      activeTab: activeTab,
      searchTerm: searchTerm,
      sortBy: sortBy,
      sortAscending: sortAscending,
      getMappedKey: getMappedKey,
      getMappedValue: getMappedValue
    });
  }, [data, favs, activeTab, searchTerm, sortBy, sortAscending, filterData, getMappedKey, getMappedValue]);

  var _toggleFav = function toggleFav(id) {
    var newFavs = _objectSpread$5(_objectSpread$5({}, favs), {}, _defineProperty({}, id, !favs[id]));

    saveFavs(newFavs);
  };

  var keyForId = getMappedKey(KEYS.ID);
  return /*#__PURE__*/React__default.createElement("div", {
    className: MARKET_LIST
  }, /*#__PURE__*/React__default.createElement(Toolbar, {
    tabs: tabs,
    activeTab: activeTab,
    searchTerm: searchTerm,
    dispatch: dispatch
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "divider"
  }), /*#__PURE__*/React__default.createElement(Table, {
    className: "".concat(MARKET_LIST, "__table"),
    interactive: true
  }, /*#__PURE__*/React__default.createElement(Header, {
    sortBy: sortBy,
    sortAscending: sortAscending,
    dispatch: dispatch,
    getMappedValue: getMappedValue,
    columns: columns
  })), /*#__PURE__*/React__default.createElement("div", {
    className: TABLE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(Table, {
    className: "".concat(MARKET_LIST, "__table"),
    interactive: true,
    striped: true
  }, /*#__PURE__*/React__default.createElement("tbody", null, filtered.map(function (row) {
    var id = _get(row, keyForId);

    return /*#__PURE__*/React__default.createElement(Row$1, {
      key: id,
      data: row,
      isFav: favs[id],
      toggleFav: function toggleFav() {
        return _toggleFav(id);
      },
      onRowClick: onRowClick,
      getMappedValue: getMappedValue,
      customMapping: customMapping,
      columns: columns
    });
  })))));
};

MarketList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape(TAB_PROP_TYPE)).isRequired,
  onRowClick: PropTypes.func,
  favs: PropTypes.objectOf(PropTypes.bool).isRequired,
  saveFavs: PropTypes.func.isRequired,
  defaultSortBy: PropTypes.string,
  filterData: PropTypes.func,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),

  /**
   * If true, show the OrderHistory in a condensed mobile layout. By default
   * the mobile layout will be enabled when the screen size is below the mobile
   * breakpoint (BREAKPOINTS.SM).
   */
  isMobileLayout: PropTypes.bool
};
var defaultProps$2 = {
  defaultSortBy: 'volume',
  filterData: filterData,
  rowMapping: {},
  onRowClick: function onRowClick() {},
  isMobileLayout: undefined
};
MarketList.defaultProps = defaultProps$2;
var MarketList$1 = compose(withI18nProvider, ResponsiveWrapper, MobileLayoutWrapper(BREAKPOINTS.SM), memo)(MarketList);

var _MAPPING$1;

var KEYS$1 = {
  BASE_CCY: 'baseCcy',
  QUOTE_CCY: 'quoteCcy',
  LAST_PRICE: 'lastPrice',
  CHANGE: 'change',
  CHANGE_PERC: 'changePerc',
  VOLUME: 'volume',
  HIGH: 'high',
  LOW: 'low'
};
var MAPPING$1 = (_MAPPING$1 = {}, _defineProperty(_MAPPING$1, KEYS$1.QUOTE_CCY, {
  renderer: function renderer(_ref) {
    var formattedValue = _ref.formattedValue;
    return "/ ".concat(formattedValue);
  }
}), _defineProperty(_MAPPING$1, KEYS$1.LAST_PRICE, {
  defaultValue: 0,
  format: formatPrice
}), _defineProperty(_MAPPING$1, KEYS$1.CHANGE, {
  defaultValue: 0,
  format: formatPrice
}), _defineProperty(_MAPPING$1, KEYS$1.CHANGE_PERC, {
  defaultValue: 0,
  format: function format(value) {
    return formatVolumePercentChange(value, 2);
  },
  renderer: function renderer(_ref2) {
    var value = _ref2.value,
        formattedValue = _ref2.formattedValue;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      className: "change-icon",
      icon: value >= 0 ? faCaretUp : faCaretDown
    }), "(", formattedValue, ")");
  }
}), _defineProperty(_MAPPING$1, KEYS$1.VOLUME, {
  defaultValue: 0,
  format: formatVolume,
  renderer: function renderer(_ref3) {
    var formattedValue = _ref3.formattedValue,
        volumeUnit = _ref3.volumeUnit;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "label"
    }, i18n.t('ticker:volume')), /*#__PURE__*/React__default.createElement("div", {
      className: "value"
    }, formattedValue, "\xA0", volumeUnit));
  }
}), _defineProperty(_MAPPING$1, KEYS$1.HIGH, {
  defaultValue: 0,
  format: formatPrice,
  renderer: function renderer(_ref4) {
    var formattedValue = _ref4.formattedValue;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "label"
    }, i18n.t('ticker:high')), /*#__PURE__*/React__default.createElement("div", {
      className: "value"
    }, formattedValue));
  }
}), _defineProperty(_MAPPING$1, KEYS$1.LOW, {
  defaultValue: 0,
  format: formatPrice,
  renderer: function renderer(_ref5) {
    var formattedValue = _ref5.formattedValue;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "label"
    }, i18n.t('ticker:low')), /*#__PURE__*/React__default.createElement("div", {
      className: "value"
    }, formattedValue));
  }
}), _MAPPING$1);

var Ticker = function Ticker(props) {
  var data = props.data,
      ccyIcon = props.ccyIcon,
      onShowInfoClick = props.onShowInfoClick,
      showCoinInfoIcon = props.showCoinInfoIcon,
      className = props.className,
      customMapping = props.dataMapping,
      volumeUnit = props.volumeUnit;
  var getDisplayValue = getValue({
    mapping: MAPPING$1,
    customMapping: customMapping,
    data: data
  });
  var quoteCcy = getDisplayValue(KEYS$1.QUOTE_CCY);
  var changePerc = getDisplayValue(KEYS$1.CHANGE_PERC, false);
  var classes$1 = cx(TICKER, className);
  var colorClass = getColors(changePerc, {
    strike: 0,
    includeStrike: true
  });

  var renderCell = function renderCell(key) {
    var value = getDisplayValue(key, false);
    var formattedValue = getDisplayValue(key);

    var renderer = _get(customMapping, [key, 'renderer']) || _get(MAPPING$1, [key, 'renderer']) || function (_ref) {
      var v = _ref.formattedValue;
      return v;
    };

    return renderer({
      value: value,
      formattedValue: formattedValue,
      data: data,
      quoteCcy: quoteCcy,
      volumeUnit: volumeUnit
    });
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "info"
  }, ccyIcon && /*#__PURE__*/React__default.createElement("div", {
    className: "ccy-icon"
  }, ccyIcon), /*#__PURE__*/React__default.createElement("div", {
    className: "highlight"
  }, renderCell(KEYS$1.BASE_CCY)), /*#__PURE__*/React__default.createElement("div", {
    className: "quote-ccy"
  }, renderCell(KEYS$1.QUOTE_CCY)), showCoinInfoIcon && /*#__PURE__*/React__default.createElement(DefaultComp, {
    className: "info-icon",
    onClick: onShowInfoClick
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    size: "sm",
    icon: faInfoCircle
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "last-price"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "price highlight"
  }, renderCell(KEYS$1.LAST_PRICE))), /*#__PURE__*/React__default.createElement("div", {
    className: cx('price-change', colorClass)
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "price"
  }, renderCell(KEYS$1.CHANGE)), /*#__PURE__*/React__default.createElement("span", {
    className: "perc"
  }, renderCell(KEYS$1.CHANGE_PERC))), /*#__PURE__*/React__default.createElement("div", {
    className: "volume"
  }, renderCell(KEYS$1.VOLUME)), /*#__PURE__*/React__default.createElement("div", {
    className: "high"
  }, renderCell(KEYS$1.HIGH)), /*#__PURE__*/React__default.createElement("div", {
    className: "low"
  }, renderCell(KEYS$1.LOW)));
};

Ticker.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  ccyIcon: PropTypes.node,
  showCoinInfoIcon: PropTypes.bool,
  onShowInfoClick: PropTypes.func,
  className: PropTypes.string,
  dataMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING))
};
var defaultProps$3 = {
  data: {},
  ccyIcon: null,
  showCoinInfoIcon: false,
  onShowInfoClick: function onShowInfoClick() {},
  className: null,
  dataMapping: {}
};
Ticker.defaultProps = defaultProps$3;
var Ticker$1 = withI18nProvider( /*#__PURE__*/memo(Ticker));

var _MAPPING$2;

var KEYS$2 = {
  ID: 'id',
  BASE_CCY: 'baseCcy',
  QUOTE_CCY: 'quoteCcy',
  LAST_PRICE: 'lastPrice',
  CHANGE_PERC: 'changePerc',
  CCY_LABELS: 'ccyLabels',
  VOLUME: 'volume'
};

var formatVolumePerc = function formatVolumePerc(value) {
  return "".concat((value * 100).toFixed(2), "%");
};

var MAPPING$2 = (_MAPPING$2 = {}, _defineProperty(_MAPPING$2, KEYS$2.LAST_PRICE, {
  defaultValue: 0,
  format: formatPrice
}), _defineProperty(_MAPPING$2, KEYS$2.CHANGE_PERC, {
  defaultValue: 0,
  format: formatVolumePerc
}), _defineProperty(_MAPPING$2, KEYS$2.VOLUME, {
  defaultValue: 0,
  format: formatVolume
}), _MAPPING$2); // key: column key
// defaultSortAsc: default sort direction to use when column sort icon is clicked
// cellStyle : td, th style
// headerCellClassName: th classname
// renderer: for content to be renderered inside td

var getColumns$1 = function getColumns() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      t = _ref.t;

  return [{
    label: t('tickerlist:pair'),
    key: KEYS$2.BASE_CCY,
    defaultSortAsc: true,
    cellStyle: {
      width: '26%',
      textAlign: 'left',
      wordBreak: 'break-all'
    },
    headerCellClassName: 'pair',
    renderer: function renderer(_ref2) {
      var baseCcy = _ref2.baseCcy,
          quoteCcy = _ref2.quoteCcy;
      return /*#__PURE__*/React__default.createElement("span", null, baseCcy, "/", /*#__PURE__*/React__default.createElement("span", {
        className: "price-unit"
      }, quoteCcy));
    }
  }, {
    label: t('tickerlist:last_price'),
    key: KEYS$2.LAST_PRICE,
    defaultSortAsc: false,
    cellStyle: {
      width: '23%',
      textAlign: 'left'
    },
    headerCellClassName: 'last-price'
  }, {
    label: t('tickerlist:24h_change'),
    key: KEYS$2.CHANGE_PERC,
    defaultSortAsc: false,
    cellStyle: {
      width: '15%',
      textAlign: 'right'
    },
    renderer: function renderer(_ref3) {
      var formattedValue = _ref3.formattedValue,
          value = _ref3.value;
      return /*#__PURE__*/React__default.createElement("span", {
        className: getColors(value, {
          strike: 0,
          includeStrike: true
        })
      }, formattedValue);
    }
  }, {
    label: t('tickerlist:volume'),
    key: KEYS$2.VOLUME,
    defaultSortAsc: false,
    cellStyle: {
      width: '29%',
      textAlign: 'right'
    }
  }];
};

var Favorite = function Favorite(props) {
  var showOnlyFavs = props.showOnlyFavs,
      setShowOnlyFavs = props.setShowOnlyFavs;

  var _useTranslation = useTranslation('tickerlist'),
      t = _useTranslation.t;

  return /*#__PURE__*/React__default.createElement("th", {
    className: "fav-col"
  }, /*#__PURE__*/React__default.createElement(DefaultComp, {
    minimal: true,
    className: "fav-button",
    onClick: function onClick() {
      return setShowOnlyFavs(!showOnlyFavs);
    }
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: t('fav_tooltip')
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: showOnlyFavs ? faStar : faStar$1,
    className: "fav-icon"
  }))));
};

Favorite.propTypes = {
  showOnlyFavs: PropTypes.bool.isRequired,
  setShowOnlyFavs: PropTypes.func.isRequired
};
var FavoriteHeader = /*#__PURE__*/memo(Favorite);

var Volume = function Volume(props) {
  var volumeUnit = props.volumeUnit,
      setVolumeUnit = props.setVolumeUnit,
      volumeUnitList = props.volumeUnitList;

  var _useTranslation = useTranslation('tickerlist'),
      t = _useTranslation.t;

  return /*#__PURE__*/React__default.createElement("span", {
    className: "volume-header"
  }, /*#__PURE__*/React__default.createElement("span", null, t('volume')), /*#__PURE__*/React__default.createElement(Tooltip, {
    className: "".concat(TICKER_LIST, "__volume-tooltip"),
    content: volumeUnit === volumeUnitList.SELF ? t('volume_tooltip_self') : t('volume_tooltip', {
      volumeUnit: volumeUnit
    }),
    placement: "top"
  }, /*#__PURE__*/React__default.createElement("span", {
    onClick: setVolumeUnit,
    onKeyPress: handleKeyboardEvent('Enter', setVolumeUnit),
    className: "unit",
    role: "button",
    tabIndex: "0"
  }, volumeUnitList[volumeUnit])));
};

Volume.propTypes = {
  volumeUnit: PropTypes.string,
  setVolumeUnit: PropTypes.func.isRequired,
  volumeUnitList: PropTypes.objectOf(PropTypes.string).isRequired
};
Volume.defaultProps = {
  volumeUnit: null
};
var VolumeHeader = /*#__PURE__*/memo(Volume);

var TickerListHeader = function TickerListHeader(props) {
  var sortBy = props.sortBy,
      setSortBy = props.setSortBy,
      sortAsc = props.sortAsc,
      setSortAsc = props.setSortAsc,
      showOnlyFavs = props.showOnlyFavs,
      setShowOnlyFavs = props.setShowOnlyFavs,
      showVolumeUnit = props.showVolumeUnit,
      volumeUnitList = props.volumeUnitList,
      volumeUnit = props.volumeUnit,
      setVolumeUnit = props.setVolumeUnit,
      dataMapping = props.dataMapping,
      columns = props.columns;

  var toggleVolumeUnit = function toggleVolumeUnit(e) {
    e.stopPropagation(); // Do not propagate to avoid sorting when clicking volumeUnit buttons

    var units = _keys(volumeUnitList);

    var nextUnitIndex = (_indexOf(units, volumeUnit) + 1) % units.length;
    setVolumeUnit(units[nextUnitIndex]);
  };

  var onSort = function onSort() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        key = _ref.key,
        defaultSortAsc = _ref.defaultSortAsc;

    var mappedKey = getMappedKey(key, dataMapping);
    setSortAsc(mappedKey === sortBy ? !sortAsc : defaultSortAsc);
    setSortBy(mappedKey);
  };

  return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement(FavoriteHeader, {
    showOnlyFavs: showOnlyFavs,
    setShowOnlyFavs: setShowOnlyFavs
  }), columns.map(function (column) {
    var _ref2 = column || {},
        key = _ref2.key,
        label = _ref2.label,
        defaultSortAsc = _ref2.defaultSortAsc,
        cellStyle = _ref2.cellStyle,
        headerCellClassName = _ref2.headerCellClassName;

    var mappedKey = getMappedKey(key, dataMapping);
    return /*#__PURE__*/React__default.createElement("th", {
      key: mappedKey,
      className: headerCellClassName,
      style: cellStyle
    }, /*#__PURE__*/React__default.createElement(SortableButton, {
      content: showVolumeUnit && key === KEYS$2.VOLUME ? /*#__PURE__*/React__default.createElement(VolumeHeader, {
        volumeUnit: volumeUnit,
        setVolumeUnit: toggleVolumeUnit,
        volumeUnitList: volumeUnitList,
        showVolumeUnit: showVolumeUnit,
        field: key
      }) : label,
      onSortClick: function onSortClick() {
        return onSort(column);
      },
      sortBy: sortBy,
      sortAscending: sortAsc,
      defaultSortAscending: defaultSortAsc,
      field: mappedKey
    }));
  })));
};

TickerListHeader.propTypes = {
  sortBy: PropTypes.string.isRequired,
  setSortBy: PropTypes.func.isRequired,
  sortAsc: PropTypes.bool.isRequired,
  setSortAsc: PropTypes.func.isRequired,
  showOnlyFavs: PropTypes.bool.isRequired,
  setShowOnlyFavs: PropTypes.func.isRequired,
  showVolumeUnit: PropTypes.bool.isRequired,
  volumeUnitList: PropTypes.objectOf(PropTypes.string).isRequired,
  volumeUnit: PropTypes.string,
  setVolumeUnit: PropTypes.func.isRequired,
  dataMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
TickerListHeader.defaultProps = {
  volumeUnit: null,
  dataMapping: {}
};
var TickerListHeader$1 = /*#__PURE__*/memo(TickerListHeader);

var TickerListRow = function TickerListRow(props) {
  var data = props.data,
      isFav = props.isFav,
      toggleFav = props.toggleFav,
      onRowClick = props.onRowClick,
      customMapping = props.dataMapping,
      columns = props.columns;
  var getDisplayValue = getValue({
    mapping: MAPPING$2,
    customMapping: customMapping,
    data: data
  });
  var baseCcy = getDisplayValue(KEYS$2.BASE_CCY);
  var quoteCcy = getDisplayValue(KEYS$2.QUOTE_CCY);
  var id = getDisplayValue(KEYS$2.ID);

  var handleRowClick = function handleRowClick() {
    onRowClick(id, data);
  };

  var handleFavIconClick = function handleFavIconClick(e) {
    e.stopPropagation();
    toggleFav(id);
  };

  return /*#__PURE__*/React__default.createElement("tr", {
    tabIndex: "0",
    onClick: handleRowClick,
    onKeyPress: handleKeyboardEvent(['Enter'], handleRowClick)
  }, /*#__PURE__*/React__default.createElement("td", {
    className: "fav-col"
  }, /*#__PURE__*/React__default.createElement(DefaultComp, {
    minimal: true,
    onClick: handleFavIconClick
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: isFav ? faStar : faStar$1,
    className: "fav-icon"
  }))), columns.map(function (_ref) {
    var key = _ref.key,
        defRenderer = _ref.renderer,
        cellStyle = _ref.cellStyle;
    var formattedValue = getDisplayValue(key);
    var value = getDisplayValue(key, false);

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    return /*#__PURE__*/React__default.createElement("td", {
      key: key,
      style: cellStyle
    }, renderer ? renderer({
      value: value,
      formattedValue: formattedValue,
      data: data,
      baseCcy: baseCcy,
      quoteCcy: quoteCcy
    }) : formattedValue);
  }));
};

TickerListRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,
  isFav: PropTypes.bool.isRequired,
  toggleFav: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  dataMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
TickerListRow.defaultProps = {
  dataMapping: {}
};
var Row$2 = /*#__PURE__*/memo(TickerListRow);

var TickerListToolbar = function TickerListToolbar(props) {
  var searchTerm = props.searchTerm,
      setSearchTerm = props.setSearchTerm;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var onCancelClick = useCallback(function () {
    return setSearchTerm('');
  }, [setSearchTerm]);
  return /*#__PURE__*/React__default.createElement(Input, {
    placeholder: "".concat(t('common:search'), ".."),
    small: true,
    rightElement: searchTerm ? /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faTimes,
      className: "search-icon",
      onClick: onCancelClick
    }) : /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faSearch,
      className: "search-icon"
    }),
    value: searchTerm,
    className: "search-ccy",
    onChange: setSearchTerm,
    type: "search"
  });
};

TickerListToolbar.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired
};
var TickerListToolbar$1 = /*#__PURE__*/memo(TickerListToolbar);

function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$6(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$6(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var TickerList = function TickerList(props) {
  var data = props.data,
      favs = props.favs,
      saveFavs = props.saveFavs,
      onRowClick = props.onRowClick,
      showVolumeUnit = props.showVolumeUnit,
      volumeUnitList = props.volumeUnitList,
      volumeUnit = props.volumeUnit,
      setVolumeUnit = props.setVolumeUnit,
      rowMapping = props.rowMapping,
      showOnlyFavs = props.showOnlyFavs,
      setShowOnlyFavs = props.setShowOnlyFavs,
      className = props.className;
  var keyForId = getMappedKey(KEYS$2.ID, rowMapping);
  var keyForBaseCcy = getMappedKey(KEYS$2.BASE_CCY, rowMapping);
  var keyForQuoteCcy = getMappedKey(KEYS$2.QUOTE_CCY, rowMapping);
  var keyForCcyLabels = getMappedKey(KEYS$2.CCY_LABELS, rowMapping);
  var keyForVolume = getMappedKey(KEYS$2.VOLUME, rowMapping);

  var _useState = useState(keyForVolume),
      _useState2 = _slicedToArray(_useState, 2),
      sortBy = _useState2[0],
      setSortBy = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      sortAsc = _useState4[0],
      setSortAsc = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchTerm = _useState6[0],
      setSearchTerm = _useState6[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var ordered = _orderBy(data, [sortBy], [sortAsc ? 'asc' : 'desc']); // filter ccys matching search-term and marked as fav


  var filtered = ordered.filter(function (row) {
    var baseCcy = _get(row, keyForBaseCcy);

    var quoteCcy = _get(row, keyForQuoteCcy); // added backward compatibility


    var ccyLabels = _get(row, keyForCcyLabels, [baseCcy, quoteCcy]);

    var matches = _toLower(_join([].concat(_toConsumableArray(ccyLabels), [baseCcy + quoteCcy])));

    return _includes(matches, _toLower(searchTerm)) && (!showOnlyFavs || favs[row[keyForId]]);
  });

  var toggleFav = function toggleFav(id) {
    var newFavs = _objectSpread$6(_objectSpread$6({}, favs), {}, _defineProperty({}, id, !favs[id]));

    saveFavs(newFavs);
  };

  var columns = useMemo(function () {
    return getColumns$1({
      t: t
    });
  }, [t]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx(TICKER_LIST, className)
  }, /*#__PURE__*/React__default.createElement(TickerListToolbar$1, {
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm
  }), /*#__PURE__*/React__default.createElement(Table, {
    condensed: true
  }, /*#__PURE__*/React__default.createElement(TickerListHeader$1, {
    sortBy: sortBy,
    setSortBy: setSortBy,
    sortAsc: sortAsc,
    setSortAsc: setSortAsc,
    showOnlyFavs: showOnlyFavs,
    setShowOnlyFavs: setShowOnlyFavs,
    showVolumeUnit: showVolumeUnit,
    volumeUnitList: volumeUnitList,
    volumeUnit: volumeUnit,
    setVolumeUnit: setVolumeUnit,
    dataMapping: rowMapping,
    columns: columns
  })), _isEmpty(filtered) ? /*#__PURE__*/React__default.createElement("div", {
    className: "empty-tickerlist"
  }, t('tickerlist:empty')) : /*#__PURE__*/React__default.createElement("div", {
    className: TABLE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(Table, {
    condensed: true,
    interactive: true,
    striped: true
  }, /*#__PURE__*/React__default.createElement("tbody", null, filtered.map(function (row) {
    var id = _get(row, keyForId);

    return /*#__PURE__*/React__default.createElement(Row$2, {
      key: id,
      data: row,
      dataMapping: rowMapping,
      isFav: !!favs[id],
      toggleFav: toggleFav,
      onRowClick: onRowClick,
      columns: columns
    });
  })))));
};

TickerList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  favs: PropTypes.objectOf(PropTypes.bool).isRequired,
  saveFavs: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  showVolumeUnit: PropTypes.bool,
  volumeUnitList: PropTypes.objectOf(PropTypes.string),
  volumeUnit: PropTypes.string,
  setVolumeUnit: PropTypes.func,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  setShowOnlyFavs: PropTypes.func.isRequired,
  showOnlyFavs: PropTypes.bool.isRequired,
  className: PropTypes.string
};
var defaultProps$4 = {
  data: [],
  onRowClick: function onRowClick() {},
  showVolumeUnit: false,
  volumeUnitList: {},
  volumeUnit: null,
  setVolumeUnit: function setVolumeUnit() {},
  rowMapping: {},
  className: null
};
TickerList.defaultProps = defaultProps$4;
var TickerList$1 = withI18nProvider( /*#__PURE__*/memo(TickerList));

var TradesToggle = function TradesToggle(props) {
  var isMarket = props.isMarket,
      toggle = props.toggle,
      authenticated = props.authenticated;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var handleClick = function handleClick() {
    toggle(!isMarket);
  };

  if (!authenticated) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement(DefaultComp, {
    minimal: true,
    onClick: handleClick,
    title: isMarket ? t('trades:change_to_user') : t('trades:change_to_market')
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(TRADES, "__toggle")
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: isMarket ? faChartLine : faUser
  }), /*#__PURE__*/React__default.createElement("span", null, isMarket ? t('trades:market') : t('trades:user'))));
};

TradesToggle.propTypes = {
  isMarket: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  authenticated: PropTypes.bool
};
TradesToggle.defaultProps = {
  isMarket: true,
  authenticated: false
};
var Button_TradesToggle = withI18nProvider( /*#__PURE__*/memo(TradesToggle));
/* eslint-disable import/prefer-default-export */

var KEYS$3 = {
  ID: 'id',
  MTS: 'mts',
  PRICE: 'price',
  AMOUNT: 'amount'
};
var AMOUNT_SIG_FIGS = PLATFORM_SETTINGS.AMOUNT_SIG_FIGS,
    PRICE_SIG_FIGS = PLATFORM_SETTINGS.PRICE_SIG_FIGS;
var TRADE_AMOUNT_DECIMALS = 4; // key: column key
// label: column header
// renderer: for content to be renderered inside td

var getColumns$2 = function getColumns() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = args.t;
  return [{
    key: KEYS$3.ID,
    label: '',
    cellStyle: {
      width: '10%'
    },
    renderer: function renderer(_ref) {
      var isBuy = _ref.isBuy;
      var icon = isBuy ? faChevronUp : faChevronDown;
      return /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        icon: icon
      });
    }
  }, {
    key: KEYS$3.MTS,
    label: t('trades:time'),
    cellStyle: {
      width: '30%'
    },
    renderer: function renderer(_ref2) {
      var formattedValue = _ref2.formattedValue;
      return /*#__PURE__*/React__default.createElement(Time, {
        mts: formattedValue
      });
    }
  }, {
    key: KEYS$3.AMOUNT,
    label: t('trades:amount'),
    cellStyle: {
      width: '30%'
    },
    renderer: function renderer(_ref3) {
      var formattedValue = _ref3.formattedValue;
      return /*#__PURE__*/React__default.createElement(PrettyValue, {
        value: formattedValue,
        sigFig: AMOUNT_SIG_FIGS,
        decimals: TRADE_AMOUNT_DECIMALS,
        fadeTrailingZeros: true,
        absolute: true
      });
    }
  }, {
    key: KEYS$3.PRICE,
    label: t('trades:price'),
    cellStyle: {
      width: '30%'
    },
    renderer: function renderer(_ref4) {
      var formattedValue = _ref4.formattedValue;
      return /*#__PURE__*/React__default.createElement(PrettyValue, {
        value: formattedValue,
        sigFig: PRICE_SIG_FIGS,
        fadeTrailingZeros: true
      });
    }
  }];
};

var TradesHeader = function TradesHeader(props) {
  var columns = props.columns;
  return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(function (_ref) {
    var key = _ref.key,
        label = _ref.label,
        headerCellClassName = _ref.headerCellClassName,
        cellStyle = _ref.cellStyle;
    return /*#__PURE__*/React__default.createElement("th", {
      key: key,
      style: cellStyle,
      className: headerCellClassName
    }, label);
  })));
};

TradesHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
var TradesHeader$1 = /*#__PURE__*/memo(TradesHeader);

var getOpacityPercentage = function getOpacityPercentage(_ref) {
  var _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 1 : _ref$amount,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0.001 : _ref$min;
  var base = amount / (min * 1000);
  var percentage = Math.abs(base).toFixed(2);
  return _min([percentage, 1]);
};

var groupByDate = function groupByDate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : KEYS$3.MTS;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var groupedData = _groupBy(data, function () {
    var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var date = applyTimeZoneOffset(new Date(o[key]), offset);
    return date.toDateString();
  });

  var mtsList = Object.keys(groupedData);
  var result = mtsList.reduce(function (all, mts) {
    return [].concat(_toConsumableArray(all), [mts], _toConsumableArray(groupedData[mts]));
  }, []);
  return result;
};

var BASE_OPACITY = 0.05;
var MAX_OPACITY = 0.2;
var color = {
  red: '224, 61, 84',
  // $intent-error #e03d54
  green: '33, 187, 139' // $intent-success #21bb8b

};

var TradeRow = function TradeRow(props) {
  var data = props.data,
      customMapping = props.rowMapping,
      columns = props.columns,
      minOrderSize = props.minOrderSize;
  var getDisplayValue = getValue({
    customMapping: customMapping,
    data: data
  });
  var amount = getDisplayValue(KEYS$3.AMOUNT);
  var perc = getOpacityPercentage({
    amount: amount,
    min: minOrderSize
  });
  var isBuy = amount > 0;
  var opacity = MAX_OPACITY * perc + BASE_OPACITY;
  var style = {
    background: "rgba(".concat(isBuy ? color.green : color.red, ", ").concat(opacity, ")")
  };
  return /*#__PURE__*/React__default.createElement("tr", {
    style: style
  }, columns.map(function (_ref) {
    var key = _ref.key,
        cellClassName = _ref.cellClassName,
        cellStyle = _ref.cellStyle,
        defRenderer = _ref.renderer;
    var formattedValue = getDisplayValue(key);
    var value = getDisplayValue(key, false);

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    return /*#__PURE__*/React__default.createElement("td", {
      key: key,
      className: cellClassName,
      style: cellStyle
    }, renderer ? renderer({
      value: value,
      formattedValue: formattedValue,
      data: data,
      isBuy: isBuy
    }) : formattedValue);
  }));
};

TradeRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  minOrderSize: PropTypes.number.isRequired
};
TradeRow.defaultProps = {
  data: {},
  rowMapping: {}
};
var TradesRow = /*#__PURE__*/memo(TradeRow);
var TRADE_TYPES$1 = TRADE_TYPES,
    TRADE_TYPES_ARR$1 = TRADE_TYPES_ARR,
    TRADE_PAGE_SIZE$1 = TRADE_PAGE_SIZE;

var Trades = function Trades(props) {
  var online = props.online,
      user = props.user,
      market = props.market,
      showType = props.showType,
      loading = props.loading,
      pageSize = props.pageSize,
      className = props.className,
      rowMapping = props.rowMapping,
      userRowMapping = props.userRowMapping,
      minOrderSize = props.minOrderSize;
  var classes$1 = cx(TRADES, className);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useStore = useStore(),
      timezoneOffset = _useStore.timezoneOffset;

  var isMarketTrades = showType === TRADE_TYPES$1.MARKET;
  var mtsKey = getMappedKey(KEYS$3.MTS, isMarketTrades ? rowMapping : userRowMapping);
  var columns = useMemo(function () {
    return getColumns$2({
      t: t
    });
  }, [t]);

  var getTradesData = function getTradesData(data) {
    var orderedData = _orderBy(data, mtsKey, 'desc');

    var slicedData = _slice(orderedData, 0, pageSize);

    var groupedData = groupByDate(slicedData, mtsKey, timezoneOffset);
    return groupedData;
  };

  var noTrades = isMarketTrades ? _isEmpty(market) : _isEmpty(user);
  var trades = isMarketTrades ? getTradesData(market) : getTradesData(user);

  if (loading) {
    return /*#__PURE__*/React__default.createElement(Spinner$1, null);
  }

  if (!online || noTrades) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(TRADES, "__error")
    }, /*#__PURE__*/React__default.createElement("small", null, online ? noTrades && t('common:no_data_available') : t('common:websocket_offiline')));
  }

  var keyForId = getMappedKey(KEYS$3.ID, rowMapping);
  var mapping = isMarketTrades ? rowMapping : userRowMapping;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement(Table, {
    condensed: true
  }, /*#__PURE__*/React__default.createElement(TradesHeader$1, {
    columns: columns
  })), /*#__PURE__*/React__default.createElement("div", {
    className: TABLE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(Table, {
    condensed: true
  }, /*#__PURE__*/React__default.createElement("tbody", null, trades.map(function (trade, index) {
    // handle date row for grouped user trades
    if (_isString(trade) || _isDate(trade)) {
      var nextRow = trades[index + 1] || {};
      var mts = nextRow[mtsKey] || new Date(trade).getTime();
      return /*#__PURE__*/React__default.createElement("tr", {
        key: mts
      }, /*#__PURE__*/React__default.createElement("td", {
        colSpan: 4,
        className: CENTER
      }, /*#__PURE__*/React__default.createElement(PrettyDate, {
        mts: mts
      })));
    }

    return /*#__PURE__*/React__default.createElement(TradesRow, {
      key: _get(trade, keyForId),
      columns: columns,
      rowMapping: mapping,
      data: trade,
      minOrderSize: minOrderSize
    });
  })))));
};

Trades.propTypes = {
  online: PropTypes.bool,
  loading: PropTypes.bool,
  showType: PropTypes.oneOf(TRADE_TYPES_ARR$1),
  pageSize: PropTypes.number,
  market: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.object), PropTypes.arrayOf(PropTypes.object)]),
  user: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.object), PropTypes.arrayOf(PropTypes.object)]),
  className: PropTypes.string,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  userRowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  minOrderSize: PropTypes.number
};
var defaultProps$5 = {
  online: false,
  loading: false,
  showType: TRADE_TYPES$1.MARKET,
  pageSize: TRADE_PAGE_SIZE$1,
  market: {},
  user: {},
  className: null,
  rowMapping: {},
  userRowMapping: {},
  minOrderSize: 0.001
};
Trades.defaultProps = defaultProps$5;
var Trades$1 = withI18nProvider( /*#__PURE__*/memo(Trades));

var _MAPPING$3;

var AMOUNT_DECIMALS$1 = PLATFORM_SETTINGS.AMOUNT_DECIMALS,
    PRICE_SIG_FIGS$1 = PLATFORM_SETTINGS.PRICE_SIG_FIGS;
var KEYS$4 = {
  ICON: 'icon',
  ID: 'id',
  PAIR: 'pair',
  TYPE: 'type',
  BASE_CCY: 'baseCcy',
  QUOTE_CCY: 'quoteCcy',
  AMOUNT: 'amount',
  ORIGINAL_AMOUNT: 'originalAmount',
  PRICE: 'price',
  PRICE_AVERAGE: 'priceAverage',
  PLACED: 'placed',
  STATUS: 'status'
};
var MAPPING$3 = (_MAPPING$3 = {}, _defineProperty(_MAPPING$3, KEYS$4.TYPE, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(OrderType, null, value);
  }
}), _defineProperty(_MAPPING$3, KEYS$4.AMOUNT, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(PrettyValue, {
      value: value,
      decimals: AMOUNT_DECIMALS$1,
      fadeTrailingZeros: true
    });
  }
}), _defineProperty(_MAPPING$3, KEYS$4.PRICE, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(PrettyValue, {
      value: value,
      sigFig: PRICE_SIG_FIGS$1,
      fadeTrailingZeros: true
    });
  }
}), _defineProperty(_MAPPING$3, KEYS$4.PRICE_AVERAGE, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(PrettyValue, {
      value: value,
      sigFig: PRICE_SIG_FIGS$1,
      fadeTrailingZeros: true
    });
  }
}), _defineProperty(_MAPPING$3, KEYS$4.PLACED, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(FullDate, {
      ts: value
    });
  }
}), _MAPPING$3); // label: column header
// cellStyle : td, th style
// headerCellClassName: th classname
// cellClassName: td classname
// renderer: for content to be renderered inside td
// truncate: for cell content to be truncated with ellipsis

var getColumns$3 = function getColumns() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = args.t,
      isMobile = args.isMobile;
  return [{
    key: KEYS$4.ICON,
    label: '',
    cellStyle: {
      width: '3%'
    },
    cellClassName: 'intent',
    truncate: false,
    renderer: function renderer(_ref) {
      var orderTitle = _ref.orderTitle,
          colorClass = _ref.colorClass,
          isSellOrder = _ref.isSellOrder;

      if (isMobile) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: isSellOrder ? 'sell' : 'buy'
        });
      }

      return /*#__PURE__*/React__default.createElement("span", {
        title: orderTitle
      }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        icon: faCircle,
        className: colorClass,
        size: "sm"
      }));
    }
  }, {
    key: KEYS$4.PAIR,
    label: t('pair'),
    cellStyle: {
      width: isMobile ? '17%' : '12%'
    },
    cellClassName: 'pair',
    truncate: true,
    renderer: function renderer(_ref2) {
      var formattedValue = _ref2.formattedValue,
          type = _ref2.type;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formattedValue, isMobile && /*#__PURE__*/React__default.createElement("span", {
        className: "mobile-order-type"
      }, type));
    }
  }].concat(_toConsumableArray(isMobile ? [] : [{
    key: KEYS$4.TYPE,
    label: t('type'),
    cellStyle: {
      width: '10%'
    },
    truncate: true
  }]), [{
    key: KEYS$4.AMOUNT,
    label: t('amount'),
    cellStyle: {
      width: '15%'
    },
    headerCellClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT,
    truncate: true
  }, {
    key: KEYS$4.BASE_CCY,
    label: t('ccy'),
    cellStyle: {
      width: '7%'
    },
    headerCellClassName: CENTER,
    cellClassName: CENTER,
    truncate: true
  }, {
    key: KEYS$4.PRICE,
    label: t('price'),
    cellStyle: {
      width: isMobile ? '20%' : '12.5%'
    },
    headerCellClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT,
    truncate: true
  }, {
    key: KEYS$4.PRICE_AVERAGE,
    label: t('average_price'),
    cellStyle: {
      width: isMobile ? '18%' : '12.5%'
    },
    headerCellClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT,
    truncate: true
  }, {
    key: KEYS$4.STATUS,
    label: t('status'),
    cellStyle: {
      width: isMobile ? '20%' : '13%'
    },
    headerCellClassName: isMobile ? RIGHT_TO_LEFT : CENTER,
    cellClassName: cx('status', isMobile ? RIGHT_TO_LEFT : CENTER),
    truncate: true,
    renderer: function renderer(_ref3) {
      var formattedValue = _ref3.formattedValue,
          placed = _ref3.placed;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formattedValue, isMobile && /*#__PURE__*/React__default.createElement("span", {
        className: "mobile-order-placed"
      }, placed));
    }
  }], _toConsumableArray(isMobile ? [] : [{
    key: KEYS$4.PLACED,
    label: t('placed'),
    cellStyle: {
      width: '15%'
    },
    truncate: true
  }]));
};

var Truncate = /*#__PURE__*/forwardRef(function Truncate(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/React__default.createElement("span", _extends$d({
    ref: ref,
    className: cx(TRUNCATE, className),
    title: typeof children === 'string' ? children : undefined // eslint-disable-next-line react/jsx-props-no-spreading

  }, props), children);
});
Truncate.prototype = {
  /**
   * The className of the Truncate.
   */
  className: PropTypes.string,

  /**
   * The children of the Truncate.
   */
  children: PropTypes.string
};

var OrderHHeader = function OrderHHeader(props) {
  var columns = props.columns,
      rowMapping = props.rowMapping;
  return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(function (_ref) {
    var key = _ref.key,
        label = _ref.label,
        headerCellClassName = _ref.headerCellClassName,
        cellStyle = _ref.cellStyle;

    var truncate = _get(rowMapping, [key, 'truncate'], false);

    return /*#__PURE__*/React__default.createElement("th", {
      key: key,
      style: cellStyle,
      className: headerCellClassName
    }, truncate ? /*#__PURE__*/React__default.createElement(Truncate, null, label) : label);
  })));
};

OrderHHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
var Header$1 = /*#__PURE__*/memo(OrderHHeader);

var OrderHRow = function OrderHRow(props) {
  var data = props.data,
      columns = props.columns,
      customMapping = props.rowMapping;

  var _useTranslation = useTranslation('orderhistory'),
      t = _useTranslation.t;

  var getDisplayValue = getValue({
    mapping: MAPPING$3,
    customMapping: customMapping,
    data: data
  });
  var type = getDisplayValue(KEYS$4.TYPE);
  var baseCcy = getDisplayValue(KEYS$4.BASE_CCY);
  var quoteCcy = getDisplayValue(KEYS$4.QUOTE_CCY);
  var originalAmount = getDisplayValue(KEYS$4.ORIGINAL_AMOUNT);
  var id = getDisplayValue(KEYS$4.ID);
  var placed = getDisplayValue(KEYS$4.PLACED);
  var isSellOrder = originalAmount < 0;
  var orderTitle = isSellOrder ? t('sell_order_title', {
    id: id
  }) : t('buy_order_title', {
    id: id
  });
  var colorClass = getColors(originalAmount, {
    strike: 0,
    includeStrike: true
  });
  return /*#__PURE__*/React__default.createElement("tr", {
    className: "row"
  }, columns.map(function (_ref) {
    var key = _ref.key,
        cellClassName = _ref.cellClassName,
        cellStyle = _ref.cellStyle,
        defRenderer = _ref.renderer;
    var formattedValue = getDisplayValue(key);
    var value = getDisplayValue(key, false);

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    var truncate = _get(customMapping, [key, 'truncate'], false);

    var content = renderer ? renderer({
      value: value,
      formattedValue: formattedValue,
      data: data,
      orderTitle: orderTitle,
      colorClass: colorClass,
      isSellOrder: isSellOrder,
      type: type,
      baseCcy: baseCcy,
      quoteCcy: quoteCcy,
      placed: placed
    }) : formattedValue;
    return /*#__PURE__*/React__default.createElement("td", {
      key: key,
      className: cellClassName,
      style: cellStyle
    }, truncate ? /*#__PURE__*/React__default.createElement(Truncate, null, content) : content);
  }));
};

OrderHRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING))
};
OrderHRow.defaultProps = {
  data: {},
  rowMapping: {}
};
var Row$3 = /*#__PURE__*/memo(OrderHRow);

var OrderHistory = function OrderHistory(props) {
  var orders = props.orders,
      loading = props.loading,
      rowMapping = props.rowMapping,
      className = props.className,
      isMobile = props.isMobileLayout;

  var _useTranslation = useTranslation('orderhistory'),
      t = _useTranslation.t;

  var keyForId = getMappedKey(KEYS$4.ID, rowMapping);
  var columns = useMemo(function () {
    return getMappedColumns(getColumns$3({
      t: t,
      isMobile: isMobile
    }), rowMapping);
  }, [t, isMobile, rowMapping]);

  if (loading) {
    return /*#__PURE__*/React__default.createElement(Spinner$1, null);
  }

  var classes$1 = cx(ORDER_HISTORY, className, {
    'mobile-table': isMobile
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: TABLE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(Table, {
    condensed: true,
    striped: true
  }, /*#__PURE__*/React__default.createElement(Header$1, {
    columns: columns,
    rowMapping: rowMapping
  }), /*#__PURE__*/React__default.createElement("tbody", null, orders.map(function (order) {
    return /*#__PURE__*/React__default.createElement(Row$3, {
      key: _get(order, keyForId),
      columns: columns,
      rowMapping: rowMapping,
      data: order
    });
  }))), orders.length === 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "empty"
  }, /*#__PURE__*/React__default.createElement("small", null, t('no_orders')))));
};

OrderHistory.propTypes = {
  /**
   * The orders to be displayed in the OrderHistory’s component.
   */
  orders: PropTypes.arrayOf(PropTypes.object),

  /**
   * If true, show the loading message.
   */
  loading: PropTypes.bool,

  /**
   * The custom field/column mapping for the data.
   */
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),

  /**
   * The className of the OrderHistory’s outer element.
   */
  className: PropTypes.string,

  /**
   * If true, show the OrderHistory in a condensed mobile layout. By default
   * the mobile layout will be enabled when the screen size is below the mobile
   * breakpoint (BREAKPOINTS.SM).
   */
  isMobileLayout: PropTypes.bool
};
var defaultProps$6 = {
  orders: [],
  loading: false,
  rowMapping: {},
  className: null,
  isMobileLayout: undefined
};
OrderHistory.defaultProps = defaultProps$6;
var OrderHistory$1 = compose(withI18nProvider, ResponsiveWrapper, MobileLayoutWrapper(), memo)(OrderHistory);

var _MAPPING$4;

var AMOUNT_DECIMALS$2 = PLATFORM_SETTINGS.AMOUNT_DECIMALS,
    PRICE_SIG_FIGS$2 = PLATFORM_SETTINGS.PRICE_SIG_FIGS;
var CANCEL_TIMEOUT_MS = 1500;
var KEYS$5 = {
  ID: 'id',
  PAIR: 'pair',
  TYPE: 'type',
  BASE_CCY: 'baseCcy',
  AMOUNT: 'amount',
  PRICE: 'price',
  STATUS: 'status',
  PLACED: 'placed'
};
var MAPPING$4 = (_MAPPING$4 = {}, _defineProperty(_MAPPING$4, KEYS$5.TYPE, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(OrderType, null, value);
  }
}), _defineProperty(_MAPPING$4, KEYS$5.AMOUNT, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(PrettyValue, {
      value: value,
      decimals: AMOUNT_DECIMALS$2,
      fadeTrailingZeros: true
    });
  }
}), _defineProperty(_MAPPING$4, KEYS$5.PRICE, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(PrettyValue, {
      value: value,
      sigFig: PRICE_SIG_FIGS$2,
      fadeTrailingZeros: true
    });
  }
}), _defineProperty(_MAPPING$4, KEYS$5.PLACED, {
  format: function format(value) {
    return /*#__PURE__*/React__default.createElement(FullDate, {
      ts: value
    });
  }
}), _MAPPING$4); // label: column header
// cellStyle : td, th style
// headerCellClassName: th classname
// cellClassName: td classname
// renderer: for content to be renderered inside td

var getColumns$4 = function getColumns() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = args.t,
      isMobile = args.isMobile;
  return [{
    key: '',
    label: '',
    cellStyle: {
      width: '3%'
    },
    cellClassName: 'intent',
    truncate: false,
    renderer: function renderer(_ref) {
      var orderTitle = _ref.orderTitle,
          colorClass = _ref.colorClass,
          isSellOrder = _ref.isSellOrder;

      if (isMobile) {
        return /*#__PURE__*/React__default.createElement("span", {
          className: isSellOrder ? 'sell' : 'buy'
        });
      }

      return /*#__PURE__*/React__default.createElement(Tooltip, {
        content: orderTitle,
        persistent: true
      }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        icon: faCircle,
        className: colorClass,
        size: "sm"
      }));
    }
  }, {
    key: KEYS$5.PAIR,
    label: t('pair'),
    cellStyle: {
      width: isMobile ? '17%' : '12%'
    },
    cellClassName: 'pair',
    truncate: true,
    renderer: function renderer(_ref2) {
      var formattedValue = _ref2.formattedValue,
          type = _ref2.type;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formattedValue, isMobile && /*#__PURE__*/React__default.createElement("span", {
        className: "mobile-order-type"
      }, type));
    }
  }].concat(_toConsumableArray(isMobile ? [] : [{
    key: KEYS$5.TYPE,
    label: t('type'),
    cellStyle: {
      width: '10%'
    },
    truncate: true
  }]), [{
    key: KEYS$5.AMOUNT,
    label: t('amount'),
    cellStyle: {
      width: '15%'
    },
    headerCellClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT,
    truncate: true
  }, {
    key: KEYS$5.BASE_CCY,
    label: t('ccy'),
    cellStyle: {
      width: '7%'
    },
    headerCellClassName: CENTER,
    cellClassName: CENTER,
    truncate: true
  }, {
    key: KEYS$5.PRICE,
    label: t('price'),
    cellStyle: {
      width: isMobile ? '20%' : '17%'
    },
    headerCellClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT,
    truncate: true
  }, {
    key: KEYS$5.STATUS,
    label: t('status'),
    cellStyle: {
      width: isMobile ? '20%' : '13%'
    },
    headerCellClassName: isMobile ? RIGHT_TO_LEFT : CENTER,
    cellClassName: cx('status', isMobile ? RIGHT_TO_LEFT : CENTER),
    truncate: true,
    renderer: function renderer(_ref3) {
      var formattedValue = _ref3.formattedValue,
          placed = _ref3.placed;
      return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formattedValue, isMobile && /*#__PURE__*/React__default.createElement("span", {
        className: "mobile-order-placed"
      }, placed));
    }
  }], _toConsumableArray(isMobile ? [] : [{
    key: KEYS$5.PLACED,
    label: t('placed'),
    cellStyle: {
      width: '15%'
    },
    truncate: true
  }]), [{
    key: 'cancel_order',
    label: '',
    cellStyle: {
      width: '3%'
    },
    renderer: function renderer(_ref4) {
      var cancelButton = _ref4.cancelButton;

      if (isMobile) {
        return cancelButton;
      }

      return /*#__PURE__*/React__default.createElement(Tooltip, {
        content: t('common:cancel')
      }, cancelButton);
    }
  }]);
};

var OrdersHeader = function OrdersHeader(props) {
  var columns = props.columns,
      rowMapping = props.rowMapping;
  return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(function (_ref) {
    var key = _ref.key,
        label = _ref.label,
        headerCellClassName = _ref.headerCellClassName,
        cellStyle = _ref.cellStyle;

    var truncate = _get(rowMapping, [key, 'truncate'], false);

    return /*#__PURE__*/React__default.createElement("th", {
      key: key,
      style: cellStyle,
      className: headerCellClassName
    }, truncate ? /*#__PURE__*/React__default.createElement(Truncate, null, label) : label);
  })));
};

OrdersHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
var OrdersHeader$1 = /*#__PURE__*/memo(OrdersHeader);

var OrderRow = function OrderRow(props) {
  var data = props.data,
      columns = props.columns,
      customMapping = props.rowMapping,
      cancelOrder = props.cancelOrder;

  var _useTranslation = useTranslation('orders'),
      t = _useTranslation.t;

  var getDisplayValue = getValue({
    mapping: MAPPING$4,
    customMapping: customMapping,
    data: data
  });
  var id = getDisplayValue(KEYS$5.ID);
  var type = getDisplayValue(KEYS$5.TYPE);
  var amount = getDisplayValue(KEYS$5.AMOUNT, false);
  var isSellOrder = amount < 0;
  var orderTitle = isSellOrder ? t('sell_order_title', {
    id: id
  }) : t('buy_order_title', {
    id: id
  });

  var handleCancel = function handleCancel() {
    return cancelOrder(id, data);
  };

  var colorClass = getColors(amount, {
    strike: 0,
    includeStrike: true
  });
  var cancelButton = /*#__PURE__*/React__default.createElement(CooldownButton$1, {
    minimal: true,
    onClick: handleCancel,
    timeoutMs: CANCEL_TIMEOUT_MS
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faTimes
  }));
  return /*#__PURE__*/React__default.createElement("tr", {
    className: "row"
  }, columns.map(function (_ref) {
    var key = _ref.key,
        cellClassName = _ref.cellClassName,
        cellStyle = _ref.cellStyle,
        defRenderer = _ref.renderer;
    var formattedValue = getDisplayValue(key);
    var value = getDisplayValue(key, false);

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    var truncate = _get(customMapping, [key, 'truncate'], false);

    var content = renderer ? renderer({
      value: value,
      formattedValue: formattedValue,
      data: data,
      orderTitle: orderTitle,
      colorClass: colorClass,
      isSellOrder: isSellOrder,
      type: type,
      cancelButton: cancelButton
    }) : formattedValue;
    return /*#__PURE__*/React__default.createElement("td", {
      key: key,
      className: cellClassName,
      style: cellStyle
    }, truncate ? /*#__PURE__*/React__default.createElement(Truncate, null, content) : content);
  }));
};

OrderRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  cancelOrder: PropTypes.func.isRequired
};
OrderRow.defaultProps = {
  data: {},
  rowMapping: {}
};
var OrderRow$1 = /*#__PURE__*/memo(OrderRow);

var Orders = function Orders(props) {
  var orders = props.orders,
      loading = props.loading,
      rowMapping = props.rowMapping,
      className = props.className,
      cancelOrder = props.cancelOrder,
      isMobile = props.isMobileLayout;

  var _useTranslation = useTranslation('orders'),
      t = _useTranslation.t;

  var keyForId = getMappedKey(KEYS$5.ID, rowMapping);
  var classes$1 = cx(ORDERS, className, {
    'mobile-table': isMobile
  });
  var columns = useMemo(function () {
    return getMappedColumns(getColumns$4({
      t: t,
      isMobile: isMobile
    }), rowMapping);
  }, [t, isMobile, rowMapping]);

  if (loading) {
    return /*#__PURE__*/React__default.createElement(Spinner$1, null);
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: TABLE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(Table, {
    condensed: true,
    striped: true
  }, /*#__PURE__*/React__default.createElement(OrdersHeader$1, {
    columns: columns
  }), /*#__PURE__*/React__default.createElement("tbody", null, orders.map(function (order) {
    return /*#__PURE__*/React__default.createElement(OrderRow$1, {
      key: _get(order, keyForId),
      columns: columns,
      rowMapping: rowMapping,
      data: order,
      cancelOrder: cancelOrder
    });
  }))), orders.length === 0 && /*#__PURE__*/React__default.createElement("div", {
    className: "empty"
  }, /*#__PURE__*/React__default.createElement("small", null, t('no_orders')))));
};

Orders.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  className: PropTypes.string,
  cancelOrder: PropTypes.func.isRequired,

  /**
   * If true, show the Orders in a condensed mobile layout. By default
   * the mobile layout will be enabled when the screen size is below the mobile
   * breakpoint (BREAKPOINTS.SM).
   */
  isMobileLayout: PropTypes.bool
};
var defaultProps$7 = {
  orders: [],
  loading: false,
  rowMapping: {},
  className: null,
  isMobileLayout: undefined
};
Orders.defaultProps = defaultProps$7;
var Orders$1 = compose(withI18nProvider, ResponsiveWrapper, MobileLayoutWrapper(), memo)(Orders);

var Amount = function Amount(props) {
  var data = props.data,
      prec = props.prec;
  var value = Math.abs(+data); // decimals based on precision
  // - P0: 4 decimals
  // - P1: 3 decimals
  // - P2: 2 decimals
  // - P3: 1 decimal
  // - P4: 0 decimals

  var decimals = Math.max(4 - prec, 0);
  return /*#__PURE__*/React__default.createElement(PrettyValue, {
    value: value,
    decimals: decimals
  });
};

Amount.propTypes = {
  data: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  prec: PropTypes.number
};
Amount.defaultProps = {
  prec: 0
};
var Amount$1 = /*#__PURE__*/memo(Amount);

var Price = function Price(props) {
  var data = props.data,
      decimals = props.decimals;
  return /*#__PURE__*/React__default.createElement(PrettyValue, {
    value: +data,
    decimals: decimals
  });
};

Price.propTypes = {
  data: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  decimals: PropTypes.number.isRequired
};
var Price$1 = /*#__PURE__*/memo(Price);
var BAR_LINE_HEIGHT = 17;
var DISPLAYED_ROWS = 24;
var DEFAULT_ZOOM = 100;
var CANCEL_TIMEOUT_MS$1 = 1500;
var KEYS$6 = {
  ORDER_COUNT: 'order_count',
  COUNT: 'count',
  AMOUNT: 'amount',
  TOTAL: 'total',
  PRICE: 'price'
};
var BOOK_VIZ_TYPES = {
  CUMULATIVE: 'cumulative',
  AMOUNT: 'amount'
};

var OrdersContent = function OrdersContent(props) {
  var orders = props.orders,
      handleCancel = props.handleCancel;

  var _useTranslation = useTranslation('book'),
      t = _useTranslation.t;

  if (!orders.length) {
    return null;
  }

  return orders.map(function (order) {
    var amount = order.amount,
        type = order.type,
        price = order.price,
        id = order.id;

    var onCancelClick = function onCancelClick(e) {
      e.stopPropagation();
      handleCancel(order);
    };

    return /*#__PURE__*/React__default.createElement("div", {
      key: id,
      className: "order-tooltip"
    }, /*#__PURE__*/React__default.createElement("span", null, "".concat(type, " ").concat(amount, " at ").concat(price)), /*#__PURE__*/React__default.createElement(CooldownButton$1, {
      title: t('cancel_order'),
      minimal: true,
      onClick: onCancelClick,
      timeoutMs: CANCEL_TIMEOUT_MS$1
    }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faTimes
    })));
  });
};

var Order = function Order(props) {
  var marks = props.marks,
      price = props.price,
      bid = props.isBid,
      cancelOrder = props.cancelOrder;

  var filtered = _get(marks, price, []);

  var count = filtered.length;

  var handleCancel = function handleCancel() {
    var order = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = order.id;
    cancelOrder(id, order);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "order"
  }, !!count && /*#__PURE__*/React__default.createElement(Tooltip, {
    persistent: true,
    content: /*#__PURE__*/React__default.createElement(OrdersContent, {
      handleCancel: handleCancel,
      orders: filtered
    })
  }, /*#__PURE__*/React__default.createElement("span", {
    className: cx({
      bid: bid
    })
  }, count)));
};

Order.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  marks: PropTypes.object,
  price: PropTypes.number.isRequired,
  isBid: PropTypes.bool,
  cancelOrder: PropTypes.func
};
Order.defaultProps = {
  marks: {},
  isBid: false,
  cancelOrder: function cancelOrder() {}
};
var Order$1 = /*#__PURE__*/memo(Order);
var bar = {
  svg: function svg(size, barDirection) {
    return {
      width: '100%',
      height: "".concat(size, "px"),
      transform: "scale(".concat(barDirection, ")"),
      zIndex: 0,
      pointerEvents: 'none'
    };
  }
};
var size = {
  XS: {
    width: 15,
    minWidth: 15,
    maxWidth: 15,
    textAlign: 'center',
    padding: 0
  },
  S: {
    width: 40,
    minWidth: 40,
    maxWidth: 40,
    textAlign: 'center'
  },
  M: {
    width: 65,
    minWidth: 65,
    maxWidth: 65
  },
  L: {
    minWidth: '25%'
  }
}; // label: column header
// renderer: for content to be renderered inside td

var getColumns$5 = function getColumns() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = args.t;
  return [{
    key: KEYS$6.ORDER_COUNT,
    label: '',
    cellStyle: size.XS,
    renderer: function renderer(_ref) {
      var marks = _ref.marks,
          price = _ref.price,
          isBid = _ref.isBid,
          cancelOrder = _ref.cancelOrder;
      return /*#__PURE__*/React__default.createElement(Order$1, {
        marks: marks,
        price: price,
        isBid: isBid,
        cancelOrder: cancelOrder
      });
    }
  }, {
    key: KEYS$6.COUNT,
    label: t('book:count'),
    cellStyle: size.S
  }, {
    key: KEYS$6.AMOUNT,
    label: t('book:amount'),
    cellStyle: size.L,
    renderer: function renderer(_ref2) {
      var value = _ref2.value;
      return /*#__PURE__*/React__default.createElement(Amount$1, {
        data: value
      });
    }
  }, {
    key: KEYS$6.TOTAL,
    label: t('book:total'),
    cellStyle: size.L,
    renderer: function renderer(_ref3) {
      var total = _ref3.total;
      return /*#__PURE__*/React__default.createElement(Amount$1, {
        data: total
      });
    }
  }, {
    key: KEYS$6.PRICE,
    label: t('book:price'),
    cellStyle: size.L,
    renderer: function renderer(_ref4) {
      var value = _ref4.value,
          decimals = _ref4.decimals;
      return /*#__PURE__*/React__default.createElement(Price$1, {
        data: value,
        decimals: decimals
      });
    }
  }];
};

var getDecimal = function getDecimal(num) {
  var asString = "".concat(num);
  return _includes(asString, 'e') ? parseInt(asString.split('e-')[1], 10) : _size(asString.split('.')[1] || '');
};
/**
 * returns the number of decimal units required
 * to correctly display the smaller number in a list
 * @param {Array} list an array of decimals
 * @returns {Int} number of decimal units
 */


var getDecimals = function getDecimals(list) {
  return _map(list, function (row) {
    return row.price;
  }).map(function (n) {
    return getDecimal(n);
  }).reduce(function (res, d) {
    return Math.max(res, d);
  }, 0);
};

var calculateBarData = function calculateBarData() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var value = args.value,
      index = args.index,
      totals = args.totals,
      totalMax = args.totalMax,
      amountMax = args.amountMax,
      zoom = args.zoom,
      bookViz = args.bookViz,
      isBid = args.isBid;
  var color = isBid ? SUCCESS_TEXT : ERROR_TEXT;

  var row = _get(totals, value);

  var _ref = row || {},
      _ref$total = _ref.total,
      total = _ref$total === void 0 ? 0 : _ref$total,
      _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 0 : _ref$amount;

  var zoomRatio = zoom / 100;
  var dividend = Math.abs(bookViz === BOOK_VIZ_TYPES.CUMULATIVE ? total : amount);
  var divisor = bookViz === BOOK_VIZ_TYPES.CUMULATIVE ? totalMax : amountMax;
  var size = Math.max(dividend / divisor * zoomRatio, 0);
  return {
    index: index,
    color: color,
    size: size
  };
};

var getMaxAmount = function getMaxAmount(data, priceArr) {
  return _max(_map(priceArr, function (price) {
    return Math.abs(_get(data, [price, 'amount']));
  }));
};

var getBookAmountMax = memoizeOne(function (asks, bids, pAsks, pBids) {
  return Math.max(getMaxAmount(asks, pAsks), getMaxAmount(bids, pBids));
});
var getBooktMax = memoizeOne(function (pAsks, pBids, tAsks, tBids) {
  return Math.max(Math.abs(_get(tAsks, [_last(pAsks), 'total'], 1)), Math.abs(_get(tBids, [_last(pBids), 'total'], 1)));
});
var PROP_BOOK = {
  count: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired
};
var PROP_BOOK_TRADE = {
  total: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired
};
var PROP_ORDER = {
  amount: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

var Bar = function Bar(props) {
  var index = props.index,
      size = props.size,
      color = props.color,
      height = props.height,
      xOffset = props.xOffset;
  return /*#__PURE__*/React__default.createElement("rect", {
    key: "bar-market-".concat(index),
    x: xOffset,
    y: index * height,
    width: "100%",
    transform: "scale(".concat(size, " 1)"),
    height: height,
    fillOpacity: "0.2",
    className: color
  });
};

Bar.propTypes = {
  index: PropTypes.number.isRequired,
  size: PropTypes.number,
  color: PropTypes.string.isRequired,
  height: PropTypes.number,
  xOffset: PropTypes.number
};
Bar.defaultProps = {
  size: 0,
  height: BAR_LINE_HEIGHT,
  xOffset: 1
};
var Bar$1 = /*#__PURE__*/memo(Bar);

var BookBars = function BookBars(props) {
  var psnap = props.psnap,
      totals = props.totals,
      totalMax = props.totalMax,
      amountMax = props.amountMax,
      isBid = props.isBid,
      zoom = props.zoom,
      bookViz = props.bookViz,
      isVertical = props.isVertical;
  var barDirection = isBid ? '-1, 1' : isVertical ? '-1, -1' : '1, 1';
  var bars = psnap.map(function (value, index) {
    return calculateBarData({
      value: value,
      index: index,
      totals: totals,
      totalMax: totalMax,
      amountMax: amountMax,
      zoom: zoom,
      bookViz: bookViz,
      isBid: isBid
    });
  });
  return /*#__PURE__*/React__default.createElement("svg", {
    style: bar.svg(BAR_LINE_HEIGHT * psnap.length, barDirection)
  }, bars.map(function (bar) {
    return [/*#__PURE__*/React__default.createElement(Bar$1, {
      key: "market-".concat(bar.index),
      index: bar.index,
      size: bar.size,
      color: bar.color
    })];
  }));
};

BookBars.propTypes = {
  psnap: PropTypes.arrayOf(PropTypes.number),
  totals: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])),
  totalMax: PropTypes.number,
  amountMax: PropTypes.number,
  isBid: PropTypes.bool,
  zoom: PropTypes.number.isRequired,
  bookViz: PropTypes.oneOf(Object.values(BOOK_VIZ_TYPES)).isRequired,
  isVertical: PropTypes.bool
};
BookBars.defaultProps = {
  psnap: [],
  totals: {},
  totalMax: null,
  amountMax: null,
  isBid: false,
  isVertical: false
};
var Bars = /*#__PURE__*/memo(BookBars);

var BookRow = function BookRow(props) {
  var total = props.total,
      isBid = props.isBid,
      decimals = props.decimals,
      marks = props.marks,
      cancelOrder = props.cancelOrder,
      onRowClick = props.onRowClick,
      isVertical = props.isVertical,
      data = props.data,
      customMapping = props.rowMapping,
      columns = props.columns;
  var getDisplayValue = getValue({
    customMapping: customMapping,
    data: data
  });
  var price = getDisplayValue(KEYS$6.PRICE);

  var handleRowClick = function handleRowClick(e) {
    e.stopPropagation();
    onRowClick(price);
  };

  var className = cx('row', {
    'row--reversed': !isBid && !isVertical
  });
  return /*#__PURE__*/React__default.createElement("div", {
    key: "".concat(price),
    className: className,
    tabIndex: "0",
    role: "button",
    onClick: handleRowClick,
    onKeyPress: handleKeyboardEvent(['Enter'], handleRowClick)
  }, columns.map(function (_ref) {
    var key = _ref.key,
        cellClassName = _ref.cellClassName,
        cellStyle = _ref.cellStyle,
        defRenderer = _ref.renderer;
    var formattedValue = getDisplayValue(key);
    var value = getDisplayValue(key, false);

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      className: cellClassName,
      style: cellStyle
    }, renderer ? renderer({
      value: value,
      formattedValue: formattedValue,
      decimals: decimals,
      total: total,
      marks: marks,
      price: price,
      isBid: isBid,
      cancelOrder: cancelOrder
    }) : formattedValue);
  }));
};

BookRow.propTypes = {
  total: PropTypes.number.isRequired,
  isBid: PropTypes.bool.isRequired,
  decimals: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  marks: PropTypes.object,
  cancelOrder: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  isVertical: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
BookRow.defaultProps = {
  marks: {},
  isVertical: false,
  data: {},
  rowMapping: {}
};
var Row$4 = /*#__PURE__*/memo(BookRow);

var SideHeader = function SideHeader(props) {
  var isBid = props.isBid,
      isVertical = props.isVertical,
      columns = props.columns;
  var s = {
    flexDirection: isBid || isVertical ? 'row' : 'row-reverse',
    justifyContent: 'space-between'
  };

  if (isVertical && isBid) {
    return null;
  }

  return /*#__PURE__*/React__default.createElement("div", {
    style: s,
    className: "header"
  }, columns.map(function (_ref) {
    var key = _ref.key,
        label = _ref.label,
        headerCellClassName = _ref.headerCellClassName,
        cellStyle = _ref.cellStyle;
    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      style: cellStyle,
      className: headerCellClassName
    }, label);
  }));
};

SideHeader.propTypes = {
  isBid: PropTypes.bool,
  isVertical: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
SideHeader.defaultProps = {
  isBid: false,
  isVertical: false
};
var SideHeader$1 = /*#__PURE__*/memo(SideHeader);

var BookSide = function BookSide(props) {
  var data = props.data,
      psnap = props.psnap,
      totals = props.totals,
      orders = props.orders,
      totalMax = props.totalMax,
      amountMax = props.amountMax,
      decimals = props.decimals,
      isBid = props.isBid,
      cancelOrder = props.cancelOrder,
      onRowClick = props.onRowClick,
      isVertical = props.isVertical,
      zoom = props.zoom,
      bookViz = props.bookViz,
      columns = props.columns,
      rowMapping = props.rowMapping;

  var _useTranslation = useTranslation('book'),
      trans = _useTranslation.t;

  var marks = useMemo(function () {
    return groupPrices({
      psnap: psnap,
      isBid: isBid,
      list: orders,
      prop: 'price'
    });
  }, [psnap, orders, isBid]);
  var id = isBid ? 'bids' : 'asks';
  var s = {
    flexDirection: isVertical && !isBid ? 'column-reverse' : 'column'
  };
  var content = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "bars"
  }, /*#__PURE__*/React__default.createElement(Bars, {
    psnap: psnap,
    totals: totals,
    totalMax: totalMax,
    amountMax: amountMax,
    isBid: isBid,
    zoom: zoom,
    bookViz: bookViz,
    isVertical: isVertical
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "rows",
    style: s
  }, psnap.map(function (value) {
    var r = data[value] || {};
    var t = totals[value] || {};
    return /*#__PURE__*/React__default.createElement(Row$4, {
      key: "".concat(id, "-").concat(value),
      total: t.total,
      isBid: isBid,
      decimals: decimals,
      marks: marks,
      cancelOrder: cancelOrder,
      onRowClick: onRowClick,
      isVertical: isVertical,
      data: r,
      rowMapping: rowMapping,
      columns: columns
    });
  })));
  return /*#__PURE__*/React__default.createElement("div", {
    key: id,
    className: "side"
  }, /*#__PURE__*/React__default.createElement(SideHeader$1, {
    isBid: isBid,
    isVertical: isVertical,
    columns: columns
  }), psnap.length ? content : /*#__PURE__*/React__default.createElement("div", {
    className: "side-message"
  }, trans('common:no_data_available')));
};

BookSide.propTypes = {
  data: PropTypes.objectOf(PropTypes.shape(PROP_BOOK)),
  psnap: PropTypes.arrayOf(PropTypes.number),
  totals: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])),
  orders: PropTypes.arrayOf(PropTypes.shape(PROP_ORDER)),
  totalMax: PropTypes.number,
  amountMax: PropTypes.number,
  decimals: PropTypes.number.isRequired,
  isBid: PropTypes.bool,
  cancelOrder: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  isVertical: PropTypes.bool,
  zoom: PropTypes.number.isRequired,
  bookViz: PropTypes.oneOf(Object.values(BOOK_VIZ_TYPES)).isRequired,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
BookSide.defaultProps = {
  data: {},
  psnap: [],
  totals: {},
  orders: [],
  totalMax: null,
  amountMax: null,
  isBid: false,
  isVertical: false
};
var BookSide$1 = /*#__PURE__*/memo(BookSide);

var getMaxTotal = function getMaxTotal(totalArr, priceArr) {
  return Math.abs(_get(totalArr, [_last(priceArr), 'total'], 0));
};

var Spread = function Spread(props) {
  var tBids = props.tBids,
      tAsks = props.tAsks,
      pBids = props.pBids,
      pAsks = props.pAsks,
      decimals = props.decimals,
      columns = props.columns,
      customMapping = props.rowMapping;
  var askTotal = getMaxTotal(tAsks, pAsks);
  var bidTotal = getMaxTotal(tBids, pBids);
  var total = new Big(askTotal).plus(bidTotal).toString();

  var minAsk = _get(pAsks, '0', 0);

  var maxBid = _get(pBids, '0', 0);

  var spread = new Big(minAsk).minus(maxBid).toString();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "spread"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, columns.map(function (_ref) {
    var key = _ref.key,
        cellClassName = _ref.cellClassName,
        cellStyle = _ref.cellStyle,
        defRenderer = _ref.renderer;

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    return /*#__PURE__*/React__default.createElement("div", {
      key: key,
      className: cellClassName,
      style: cellStyle
    }, renderer && (key === KEYS$6.TOTAL || key === KEYS$6.PRICE) ? renderer({
      value: key === KEYS$6.TOTAL ? total : spread,
      decimals: decimals,
      total: total
    }) : '');
  })));
};

Spread.propTypes = {
  tAsks: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])),
  tBids: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])),
  pAsks: PropTypes.arrayOf(PropTypes.number),
  pBids: PropTypes.arrayOf(PropTypes.number),
  decimals: PropTypes.number.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)).isRequired
};
Spread.defaultProps = {
  tAsks: {},
  tBids: {},
  pAsks: [],
  pBids: []
};
var Spread$1 = /*#__PURE__*/memo(Spread);

function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$7(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$7(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Book = function Book(props) {
  var online = props.online,
      loading = props.loading,
      asks = props.asks,
      bids = props.bids,
      tAsks = props.tAsks,
      tBids = props.tBids,
      _pAsks = props.pAsks,
      _pBids = props.pBids,
      orders = props.orders,
      cancelOrder = props.cancelOrder,
      onRowClick = props.onRowClick,
      className = props.className,
      zoom = props.zoom,
      bookViz = props.bookViz,
      rowMapping = props.rowMapping,
      isStackedView = props.isStackedView,
      isMobileLayout = props.isMobileLayout,
      numberOfRows = props.numberOfRows;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var isVertical = _isBoolean(isStackedView) ? isStackedView : isMobileLayout;

  var _partition2 = _partition(orders, function (o) {
    return o.amount > 0;
  }),
      _partition3 = _slicedToArray(_partition2, 2),
      oBids = _partition3[0],
      oAsks = _partition3[1];

  var decimals = useMemo(function () {
    return getDecimals(_objectSpread$7(_objectSpread$7({}, bids), asks));
  }, [bids, asks]);
  var columns = useMemo(function () {
    return getVisibleColumns(getColumns$5({
      t: t
    }), rowMapping);
  }, [rowMapping, t]);
  var classes$1 = cx(BOOK, className);

  if (!online || loading) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(BOOK, "__error")
    }, loading ? /*#__PURE__*/React__default.createElement(Spinner$1, null) : /*#__PURE__*/React__default.createElement("small", null, t('common:websocket_offiline')));
  }

  var getPsnap = memoizeOne(function (psnap) {
    return _take(psnap, numberOfRows);
  });
  var pAsks = getPsnap(_pAsks);
  var pBids = getPsnap(_pBids);
  var amountMax = getBookAmountMax(asks, bids, pAsks, pBids);
  var totalMax = getBooktMax(pAsks, pBids, tAsks, tBids);
  var commonProps = {
    decimals: decimals,
    totalMax: totalMax,
    amountMax: amountMax,
    cancelOrder: cancelOrder,
    onRowClick: onRowClick,
    isVertical: isVertical,
    zoom: zoom,
    bookViz: bookViz,
    columns: columns,
    rowMapping: rowMapping,
    numberOfRows: numberOfRows
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cx('main', {
      vertical: isVertical
    })
  }, /*#__PURE__*/React__default.createElement(BookSide$1, _extends$d({
    data: bids,
    psnap: pBids,
    totals: tBids,
    orders: oBids,
    isBid: true // eslint-disable-next-line react/jsx-props-no-spreading

  }, commonProps)), isVertical && /*#__PURE__*/React__default.createElement(Spread$1, {
    tBids: tBids,
    tAsks: tAsks,
    pBids: pBids,
    pAsks: pAsks,
    decimals: decimals,
    columns: columns,
    rowMapping: rowMapping
  }), /*#__PURE__*/React__default.createElement(BookSide$1, _extends$d({
    data: asks,
    psnap: pAsks,
    totals: tAsks,
    orders: oAsks // eslint-disable-next-line react/jsx-props-no-spreading

  }, commonProps))));
};

Book.propTypes = {
  /**
   * If false, show the offline message.
   */
  online: PropTypes.bool,

  /**
   * If true, show the loading message.
   */
  loading: PropTypes.bool,

  /**
   * The data to show on asks side.
   */
  asks: PropTypes.objectOf(PropTypes.shape(PROP_BOOK)),

  /**
   * The data to show on bids side.
   */
  bids: PropTypes.objectOf(PropTypes.shape(PROP_BOOK)),

  /**
   * The asks data with 'total' field that is cumulative sum of amount.
   */
  tAsks: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])),

  /**
   * The bids data with 'total' field that is cumulative sum of amount.
   */
  tBids: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])),

  /**
   * The sorted price list to show on asks side.
   */
  pAsks: PropTypes.arrayOf(PropTypes.number),

  /**
   * The sorted price list to show on bids side.
   */
  pBids: PropTypes.arrayOf(PropTypes.number),

  /**
   * The list of open orders.
   */
  orders: PropTypes.arrayOf(PropTypes.shape(PROP_ORDER)),

  /**
   * The function called when an open order is closed.
   */
  cancelOrder: PropTypes.func,

  /**
   * The function called when a book row is clicked.
   */
  onRowClick: PropTypes.func,

  /**
   * The className of the Book’s outer element.
   */
  className: PropTypes.string,

  /**
   * The zoom level for bar graph.
   */
  zoom: PropTypes.number,

  /**
   * The visualisation type for bar graph: <br/>
   * 'cumulative': bar graph for 'total' field<br/>
   * 'amount': bar graph for 'amount' field
   */
  bookViz: PropTypes.oneOf(Object.values(BOOK_VIZ_TYPES)),

  /**
   * The custom field/column mapping for the data.
   */
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),

  /**
   * If true, show the Book in a vertically stacked layout for bids and asks side.
   */
  isStackedView: PropTypes.bool,

  /**
   * The number of book rows to display.
   */
  numberOfRows: PropTypes.number,
  isMobileLayout: PropTypes.bool
};
var defaultProps$8 = {
  online: false,
  loading: false,
  asks: {},
  bids: {},
  tAsks: {},
  tBids: {},
  pAsks: [],
  pBids: [],
  orders: [],
  cancelOrder: function cancelOrder() {},
  onRowClick: function onRowClick() {},
  className: null,
  zoom: DEFAULT_ZOOM,
  bookViz: BOOK_VIZ_TYPES.CUMULATIVE,
  rowMapping: {},
  // keep default as undefined so by default, layout will auto switch between stacked/non-stacked views
  isStackedView: undefined,
  numberOfRows: DISPLAYED_ROWS,
  isMobileLayout: undefined
};
Book.defaultProps = defaultProps$8;
var Book$1 = compose(withI18nProvider, ResponsiveWrapper, MobileLayoutWrapper(), memo)(Book);

var BookToolbar = function BookToolbar(props) {
  var prec = props.prec,
      updatePrec = props.updatePrec,
      zoom = props.zoom,
      updateZoom = props.updateZoom,
      config = props.config;
  var classes$1 = cx("".concat(BOOK, "__toolbar"), RIGHT_TO_LEFT);

  var _useTranslation = useTranslation('book'),
      t = _useTranslation.t;

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement(DefaultComp, {
    title: t('decrease_zoom'),
    onClick: function onClick() {
      return updateZoom(-20);
    },
    minimal: true,
    disabled: zoom === config.MIN_ZOOM
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faSearchMinus
  })), /*#__PURE__*/React__default.createElement(DefaultComp, {
    title: t('increase_zoom'),
    onClick: function onClick() {
      return updateZoom(20);
    },
    minimal: true,
    disabled: zoom === config.MAX_ZOOM
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faSearchPlus
  })), /*#__PURE__*/React__default.createElement(CooldownButton$1, {
    title: t('decrease_precision'),
    onClick: function onClick() {
      return updatePrec(prec + 1);
    },
    timeoutMs: config.UPDATE_COOLDOWN_MS,
    minimal: true,
    disabled: prec === config.MAX_PRECISION
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faMinus
  })), /*#__PURE__*/React__default.createElement(CooldownButton$1, {
    title: t('increase_precision'),
    onClick: function onClick() {
      return updatePrec(prec - 1);
    },
    timeoutMs: config.UPDATE_COOLDOWN_MS,
    minimal: true,
    disabled: prec === 0
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faPlus
  })));
};

BookToolbar.propTypes = {
  prec: PropTypes.number.isRequired,
  updatePrec: PropTypes.func.isRequired,
  zoom: PropTypes.number.isRequired,
  updateZoom: PropTypes.func.isRequired,
  config: PropTypes.shape({
    UPDATE_COOLDOWN_MS: PropTypes.number.isRequired,
    MAX_PRECISION: PropTypes.number.isRequired
  })
};
BookToolbar.defaultProps = {
  config: book$1
};
var Book_Toolbar = withI18nProvider( /*#__PURE__*/memo(BookToolbar));
/* eslint-disable import/prefer-default-export */

var DEFAULT_ACTION_TIMEOUT = 500;
var INITIAL_STATE = {
  orderType: ORDER_TYPES.EXCHANGE_LIMIT,
  price: '',
  amount: '',
  postOnly: false,
  isBuy: true,
  tif: false,
  tifDate: null,
  errors: {
    amount: '',
    price: '',
    tifDate: ''
  }
};

var supportedTypes = function supportedTypes(t) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, ORDER_TYPES.EXCHANGE_LIMIT, t('orderform:limit_order')), _defineProperty(_ref, ORDER_TYPES.EXCHANGE_MARKET, t('orderform:market_order')), _ref;
};

var formSchema$1 = function formSchema(schemaProps) {
  var minDays = schemaProps.minDays,
      maxDays = schemaProps.maxDays,
      amountMaxDecimals = schemaProps.amountMaxDecimals,
      priceMaxDecimals = schemaProps.priceMaxDecimals,
      t = schemaProps.t;
  return object({
    amount: validateLength(t, t('amount')).concat(validateDecimals(amountMaxDecimals, t, t('amount'))).concat(requiredPositiveNumber(t, t('amount'))),
    price: mixed().when('orderType', {
      is: function is(orderType) {
        return orderType !== ORDER_TYPES.EXCHANGE_MARKET;
      },
      then: validateLength(t, t('price')).concat(validateDecimals(priceMaxDecimals, t, t('price'))).concat(requiredPositiveNumber(t, t('price')))
    }),
    postOnly: bool(),
    tifDate: mixed().when('tif', {
      is: true,
      then: requiredDate(t, t('date')).concat(validateExpiryDate(t, minDays, maxDays))
    })
  });
};

var OrderFormBidAsk = function OrderFormBidAsk(props) {
  var topAsk = props.topAsk,
      topBid = props.topBid,
      limitOrder = props.limitOrder;

  var _useFormikContext = useFormikContext(),
      setFieldValue = _useFormikContext.setFieldValue;

  var _useTranslation = useTranslation('orderform'),
      t = _useTranslation.t;

  var disabled = !limitOrder || !topAsk && !topBid;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "ask-bid-wrapper"
  }, /*#__PURE__*/React__default.createElement(DefaultComp, {
    className: "ask-bid bid",
    minimal: true,
    onClick: function onClick() {
      return setFieldValue('price', topBid);
    },
    disabled: disabled,
    title: t('set_price_bid')
  }, ' '), /*#__PURE__*/React__default.createElement(DefaultComp, {
    className: "ask-bid",
    minimal: true,
    onClick: function onClick() {
      return setFieldValue('price', topAsk);
    },
    disabled: disabled,
    title: t('set_price_ask')
  }, ' '));
};

OrderFormBidAsk.propTypes = {
  topAsk: PropTypes.number,
  topBid: PropTypes.number,
  limitOrder: PropTypes.bool
};
OrderFormBidAsk.defaultProps = {
  topAsk: 0,
  topBid: 0,
  limitOrder: true
};
var OrderFormBidAsk$1 = /*#__PURE__*/memo(OrderFormBidAsk);

var OrderFormTotalValue = function OrderFormTotalValue(props) {
  var quoteCcy = props.quoteCcy,
      marketOrder = props.marketOrder;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      errors = _useFormikContext.errors,
      touched = _useFormikContext.touched;

  var amount = values.amount,
      price = values.price;

  var _useTranslation = useTranslation('orderform'),
      t = _useTranslation.t;

  var value = new Big(amount).multipliedBy(price);
  var total = value.toString();
  var decimals = value.dp();
  var hasError = errors.amount && touched.amount || errors.price && touched.price; // adds 'visibility: hidden' for total row, to fix buy/sell buttons position

  var hidden = marketOrder || !amount || !price;
  return /*#__PURE__*/React__default.createElement("div", {
    className: cx('order-total__wrapper', {
      hidden: hidden
    })
  }, !hasError && /*#__PURE__*/React__default.createElement(Tooltip, {
    content: t('order_total_desc', {
      quoteCcy: quoteCcy
    })
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "order-total"
  }, "".concat(t('total'), ": \u2248 "), /*#__PURE__*/React__default.createElement(PrettyValue, {
    value: total,
    decimals: Math.min(decimals, PLATFORM_SETTINGS.AMOUNT_DECIMALS)
  }), " ".concat(quoteCcy))));
};

OrderFormTotalValue.propTypes = {
  quoteCcy: PropTypes.string,
  marketOrder: PropTypes.bool
};
OrderFormTotalValue.defaultProps = {
  quoteCcy: '',
  marketOrder: false
};
var OrderFormTotalValue$1 = /*#__PURE__*/memo(OrderFormTotalValue);
var OrderFormFormik = /*#__PURE__*/forwardRef(function (props, ref) {
  var topBid = props.topBid,
      topAsk = props.topAsk,
      baseCcy = props.baseCcy,
      quoteCcy = props.quoteCcy,
      lastPriceReq = props.lastPriceReq,
      className = props.className,
      disabled = props.disabled,
      orderTypes = props.orderTypes,
      minDays = props.minDays,
      maxDays = props.maxDays,
      tifTooltip = props.tifTooltip;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values,
      setFieldValue = _useFormikContext.setFieldValue,
      submitForm = _useFormikContext.submitForm,
      setFieldTouched = _useFormikContext.setFieldTouched;

  var orderType = values.orderType,
      tif = values.tif;

  var _useTranslation = useTranslation('orderform'),
      t = _useTranslation.t;

  var limitOrder = orderType === ORDER_TYPES.EXCHANGE_LIMIT;
  var marketOrder = orderType === ORDER_TYPES.EXCHANGE_MARKET;
  useEffect(function () {
    if (_isNumber(lastPriceReq) && !marketOrder) {
      setFieldValue('price', lastPriceReq);
    }
  }, [setFieldValue, lastPriceReq, marketOrder]);
  useEffect(function () {
    if (marketOrder) {
      setFieldValue('price', t('best_market_price'));
    } else {
      setFieldValue('price', '');
    }
  }, [setFieldValue, marketOrder, t]); // If current pair is switched or order type changed, reset form input

  useEffect(function () {
    setFieldValue('price', '');
    setFieldTouched('price', false);
    setFieldValue('tif', false);
    setFieldValue('tifDate', null);
    setFieldValue('amount', '');
    setFieldValue('postOnly', false);
    setFieldTouched('amount', false);
  }, [setFieldValue, setFieldTouched, baseCcy, quoteCcy, orderType]);
  useEffect(function () {
    // reset tifDate if tif checkbox is unchecked
    if (!tif) {
      setFieldValue('tifDate', null);
    }
  }, [tif, setFieldValue]);

  var handleSubmit = function handleSubmit(isBuy) {
    setFieldValue('isBuy', isBuy);
    submitForm();
  };

  var classes$1 = cx(ORDER_FORM, className);
  var isTifInputDisabled = !limitOrder ? true : !tif;
  return /*#__PURE__*/React__default.createElement(Form, {
    className: classes$1,
    ref: ref
  }, /*#__PURE__*/React__default.createElement(Field, {
    component: Dropdown$2,
    small: true,
    name: "orderType",
    options: orderTypes
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Field, {
    component: Checkbox$2,
    small: true,
    disabled: !limitOrder,
    label: /*#__PURE__*/React__default.createElement(Tooltip, {
      placement: "top",
      className: "".concat(ORDER_FORM, "__tooltip"),
      content: t('postonly_desc')
    }, t('postonly')),
    name: "postOnly",
    className: "postonly"
  }), /*#__PURE__*/React__default.createElement(Field, {
    component: Checkbox$2,
    small: true,
    disabled: !limitOrder,
    label: /*#__PURE__*/React__default.createElement(Tooltip, {
      placement: "top",
      className: "".concat(ORDER_FORM, "__tooltip"),
      content: tifTooltip || t('tif_desc'),
      persistent: true
    }, t('tif')),
    name: "tif",
    className: "tif"
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "label-wrapper"
  }, /*#__PURE__*/React__default.createElement(Label, {
    small: true,
    label: "".concat(t('price'), " ").concat(quoteCcy)
  }), /*#__PURE__*/React__default.createElement(OrderFormBidAsk$1, {
    limitOrder: !marketOrder,
    topAsk: topAsk,
    topBid: topBid
  })), /*#__PURE__*/React__default.createElement(Field, {
    component: Input$2,
    type: "number",
    small: true,
    alignText: marketOrder ? TEXT_ALIGNMENT.CENTER : TEXT_ALIGNMENT.LEFT,
    disabled: marketOrder,
    name: "price",
    fieldLabel: t('price'),
    className: "price-input"
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Label, {
    small: true,
    tag: "div",
    label: "".concat(t('amount'), " ").concat(baseCcy)
  }), /*#__PURE__*/React__default.createElement(Field, {
    component: Input$2,
    type: "number",
    small: true,
    alignText: TEXT_ALIGNMENT.LEFT,
    name: "amount",
    fieldLabel: t('amount'),
    className: "amount-input"
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Label, {
    small: true,
    tag: "div",
    label: t('tif_date')
  }), /*#__PURE__*/React__default.createElement(Field, {
    component: DateTimePicker$2,
    type: "date",
    small: true,
    alignText: TEXT_ALIGNMENT.LEFT,
    name: "tifDate",
    fieldLabel: t('tif_date'),
    className: "tif-input",
    disabled: isTifInputDisabled,
    minDays: minDays,
    maxDays: maxDays
  })), /*#__PURE__*/React__default.createElement(OrderFormTotalValue$1, {
    quoteCcy: quoteCcy,
    marketOrder: marketOrder
  }), /*#__PURE__*/React__default.createElement(CooldownButton$1, {
    small: true,
    intent: Intent.PRIMARY,
    disabled: disabled,
    onClick: function onClick() {
      return handleSubmit(true);
    },
    timeoutMs: DEFAULT_ACTION_TIMEOUT,
    className: "buy-button"
  }, t('buy_ccy', {
    ccy: baseCcy
  })), /*#__PURE__*/React__default.createElement(CooldownButton$1, {
    small: true,
    intent: Intent.ERROR,
    disabled: disabled,
    onClick: function onClick() {
      return handleSubmit(false);
    },
    timeoutMs: DEFAULT_ACTION_TIMEOUT,
    className: "sell-button"
  }, t('sell_ccy', {
    ccy: baseCcy
  })));
});
OrderFormFormik.propTypes = {
  topAsk: PropTypes.number,
  topBid: PropTypes.number,
  baseCcy: PropTypes.string,
  quoteCcy: PropTypes.string,
  disabled: PropTypes.bool,
  lastPriceReq: PropTypes.number,
  className: PropTypes.string,
  orderTypes: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  minDays: PropTypes.number,
  maxDays: PropTypes.number,
  tifTooltip: PropTypes.node
};
OrderFormFormik.defaultProps = {
  topAsk: 0,
  topBid: 0,
  baseCcy: '',
  quoteCcy: '',
  lastPriceReq: 0,
  className: null,
  disabled: false,
  orderTypes: null,
  minDays: null,
  maxDays: null,
  tifTooltip: null
};
OrderFormFormik.displayName = 'OrderFormFormik';
var FormikForm = /*#__PURE__*/memo(OrderFormFormik);
var AMOUNT_DECIMALS$3 = PLATFORM_SETTINGS.AMOUNT_DECIMALS;
var OrderForm = /*#__PURE__*/forwardRef(function (props, ref) {
  var asks = props.asks,
      topAsk = props.topAsk,
      topBid = props.topBid,
      baseCcy = props.baseCcy,
      quoteCcy = props.quoteCcy,
      submitOrder = props.submitOrder,
      lastPriceReq = props.lastPriceReq,
      className = props.className,
      disabled = props.disabled,
      orderTypes = props.orderTypes,
      amountMaxDecimals = props.amountMaxDecimals,
      priceMaxDecimals = props.priceMaxDecimals,
      minDays = props.minDays,
      maxDays = props.maxDays,
      tifTooltip = props.tifTooltip,
      slippageTooltip = props.slippageTooltip;

  var _useTranslation = useTranslation('orderform'),
      t = _useTranslation.t;

  var defaultOrderTypes = useMemo(function () {
    return supportedTypes(t);
  }, [t]);
  var schemaProps = {
    minDays: minDays,
    maxDays: maxDays,
    amountMaxDecimals: amountMaxDecimals,
    priceMaxDecimals: priceMaxDecimals,
    t: t
  };
  return /*#__PURE__*/React__default.createElement(Formik, {
    initialValues: INITIAL_STATE,
    validationSchema: formSchema$1(schemaProps),
    onSubmit: function onSubmit(values) {
      return submitOrder(values);
    }
  }, /*#__PURE__*/React__default.createElement(FormikForm, {
    ref: ref,
    baseCcy: baseCcy,
    quoteCcy: quoteCcy,
    topAsk: topAsk,
    topBid: topBid,
    disabled: disabled,
    lastPriceReq: lastPriceReq,
    className: className,
    orderTypes: orderTypes || defaultOrderTypes,
    minDays: minDays,
    maxDays: maxDays,
    asks: asks,
    tifTooltip: tifTooltip,
    slippageTooltip: slippageTooltip
  }));
});
OrderForm.propTypes = {
  topAsk: PropTypes.number,
  topBid: PropTypes.number,
  baseCcy: PropTypes.string,
  quoteCcy: PropTypes.string,
  submitOrder: PropTypes.func,
  lastPriceReq: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  orderTypes: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  amountMaxDecimals: PropTypes.number,
  priceMaxDecimals: PropTypes.number,
  minDays: PropTypes.number,
  maxDays: PropTypes.number,
  tifTooltip: PropTypes.node,
  slippageTooltip: PropTypes.node
};
var defaultProps$9 = {
  topAsk: 0,
  topBid: 0,
  baseCcy: '',
  quoteCcy: '',
  submitOrder: function submitOrder() {},
  lastPriceReq: 0,
  className: null,
  disabled: false,
  orderTypes: null,
  amountMaxDecimals: AMOUNT_DECIMALS$3,
  priceMaxDecimals: null,
  minDays: null,
  maxDays: null,
  slippageTooltip: null,
  tifTooltip: null
};
OrderForm.defaultProps = defaultProps$9;
OrderForm.displayName = 'OrderForm';
var OrderForm$1 = withI18nProvider( /*#__PURE__*/memo(OrderForm));
var AMOUNT_DECIMALS$4 = PLATFORM_SETTINGS.AMOUNT_DECIMALS;

var getTitle = function getTitle(amount) {
  if (_isNaN(amount) || amount === 0) {
    return 0;
  }

  var opts = {
    number: amount,
    decimals: Number(AMOUNT_DECIMALS$4),
    significantFigures: null,
    useGrouping: true
  };
  return formatNumber(opts);
};

var BalancesTooltip = function BalancesTooltip(props) {
  var children = props.children,
      total = props.total,
      available = props.available;

  var _useTranslation = useTranslation('balances'),
      t = _useTranslation.t;

  return /*#__PURE__*/React__default.createElement(Tooltip, {
    content: /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(BALANCES, "__amount-tooltip")
    }, /*#__PURE__*/React__default.createElement("div", null, t('total'), " : "), /*#__PURE__*/React__default.createElement("div", null, getTitle(total), " "), /*#__PURE__*/React__default.createElement("div", null, t('available'), " : "), /*#__PURE__*/React__default.createElement("div", null, getTitle(available), " ")),
    persistent: true
  }, children);
};

BalancesTooltip.propTypes = {
  total: PropTypes.number.isRequired,
  available: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired
};
var Tooltip$1 = /*#__PURE__*/memo(BalancesTooltip);
var DECIMALS = 2;

var BalancesAmount = function BalancesAmount(props) {
  var total = props.total,
      available = props.available;
  return /*#__PURE__*/React__default.createElement(Tooltip$1, {
    total: total,
    available: available
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "balance"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "total"
  }, /*#__PURE__*/React__default.createElement(PrettyValue, {
    value: precision(total, DECIMALS),
    decimals: !_isNaN(total) && total !== 0 ? DECIMALS : 0,
    fadeTrailingZeros: true
  })), /*#__PURE__*/React__default.createElement(PrettyValue, {
    value: precision(available, DECIMALS),
    decimals: !_isNaN(available) && available !== 0 ? DECIMALS : 0,
    fadeTrailingZeros: true
  })));
};

BalancesAmount.propTypes = {
  total: PropTypes.number.isRequired,
  available: PropTypes.number.isRequired
};
var BalancesAmount$1 = /*#__PURE__*/memo(BalancesAmount);
/* eslint-disable import/prefer-default-export */

var TOTAL_SORT = 'total_usd';
var EXCHANGE_KEY = 'exchange';
var KEYS$7 = {
  NAME: 'name',
  AVAILABLE: 'available',
  TOTAL: 'total',
  TOTAL_SORT: TOTAL_SORT,
  EXCHANGE_KEY: EXCHANGE_KEY,
  EXCHANGE: "".concat(EXCHANGE_KEY, ".").concat(TOTAL_SORT)
};

var AmountRenderer = function AmountRenderer(_ref) {
  var data = _ref.data,
      walletKey = _ref.walletKey;

  var total = _get(data, [walletKey, KEYS$7.TOTAL], 0);

  var available = _get(data, [walletKey, KEYS$7.AVAILABLE], 0);

  return /*#__PURE__*/React__default.createElement(BalancesAmount$1, {
    total: total,
    available: available
  });
};

var getColumns$6 = function getColumns(showTransfer) {
  return [{
    getLabel: function getLabel() {
      return i18n.t('balances:name');
    },
    key: KEYS$7.NAME,
    isSortable: true,
    defaultSortAsc: true
  }, {
    getLabel: function getLabel() {
      return getNiceWalletName('exchange');
    },
    key: KEYS$7.EXCHANGE,
    isSortable: true,
    defaultSortAsc: false,
    headerClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT,
    renderer: function renderer(_ref2) {
      var data = _ref2.data;
      return /*#__PURE__*/React__default.createElement(AmountRenderer, {
        data: data,
        walletKey: KEYS$7.EXCHANGE_KEY
      });
    }
  }].concat(_toConsumableArray(!showTransfer ? [] : [{
    getLabel: function getLabel() {
      return '';
    },
    key: '',
    isSortable: false,
    headerClassName: RIGHT_TO_LEFT,
    cellClassName: RIGHT_TO_LEFT,
    renderer: function renderer(_ref3) {
      var data = _ref3.data,
          handleDepositClick = _ref3.handleDepositClick,
          handleWithdrawClick = _ref3.handleWithdrawClick;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React__default.createElement(Tooltip, {
        content: i18n.t('balances:deposit')
      }, /*#__PURE__*/React__default.createElement(DefaultComp, {
        minimal: true,
        small: true,
        onClick: function onClick() {
          return handleDepositClick(data);
        }
      }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        icon: faArrowDown
      }))), /*#__PURE__*/React__default.createElement(Tooltip, {
        content: i18n.t('balances:withdraw')
      }, /*#__PURE__*/React__default.createElement(DefaultComp, {
        minimal: true,
        small: true,
        onClick: function onClick() {
          return handleWithdrawClick(data);
        }
      }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
        icon: faArrowUp
      }))));
    }
  }]));
};

var BalancesHeader = function BalancesHeader(props) {
  var sortConfig = props.sortConfig,
      requestSort = props.requestSort,
      columns = props.columns;

  var sortBy = _get(sortConfig, 'key');

  var sortAscending = _get(sortConfig, 'sortAscending');

  return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map(function (column) {
    var _ref = column || {},
        key = _ref.key,
        sortKey = _ref.sortKey,
        isSortable = _ref.isSortable,
        getLabel = _ref.getLabel,
        headerClassName = _ref.headerClassName,
        defaultSortAsc = _ref.defaultSortAsc,
        cellStyle = _ref.cellStyle;

    return /*#__PURE__*/React__default.createElement("th", {
      key: key,
      className: headerClassName,
      style: cellStyle
    }, !isSortable ? getLabel() : /*#__PURE__*/React__default.createElement(SortableButton, {
      content: getLabel(),
      onSortClick: requestSort,
      sortBy: sortBy,
      sortAscending: sortAscending,
      defaultSortAscending: defaultSortAsc,
      field: sortKey || key
    }));
  })));
};

BalancesHeader.propTypes = {
  sortConfig: PropTypes.PropTypes.shape(SORT_CONFIG_PROPS).isRequired,
  requestSort: PropTypes.func.isRequired,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};
var BalancesHeader$1 = /*#__PURE__*/memo(BalancesHeader);

function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$8(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var sortData$1 = function sortData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : KEYS$7.NAME;
  var ascending = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return _orderBy(data, [sortKey], [ascending ? 'asc' : 'desc']);
};

var balancesAdapter = function balancesAdapter(data) {
  var keys = _keys(data);

  return _map(keys, function (key) {
    return _objectSpread$8({
      name: key
    }, data[key]);
  });
};

var BalancesRow = function BalancesRow(props) {
  var data = props.data,
      customMapping = props.dataMapping,
      columns = props.columns,
      handleDepositClick = props.handleDepositClick,
      handleWithdrawClick = props.handleWithdrawClick;
  var getDisplayValue = getValue({
    customMapping: customMapping,
    data: data
  });
  return /*#__PURE__*/React__default.createElement("tr", null, columns.map(function (column) {
    var _ref = column || {},
        key = _ref.key,
        defRenderer = _ref.renderer,
        cellClassName = _ref.cellClassName,
        cellStyle = _ref.cellStyle;

    var value = getDisplayValue(key, false);
    var formattedValue = getDisplayValue(key);

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    return /*#__PURE__*/React__default.createElement("td", {
      key: key,
      className: cellClassName,
      style: cellStyle
    }, renderer ? renderer({
      value: value,
      formattedValue: formattedValue,
      data: data,
      handleDepositClick: handleDepositClick,
      handleWithdrawClick: handleWithdrawClick
    }) : formattedValue);
  }));
};

BalancesRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  dataMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleDepositClick: PropTypes.func,
  handleWithdrawClick: PropTypes.func
};
BalancesRow.defaultProps = {
  data: {},
  dataMapping: {},
  handleDepositClick: function handleDepositClick() {},
  handleWithdrawClick: function handleWithdrawClick() {}
};
var BalancesRow$1 = /*#__PURE__*/memo(BalancesRow);

var BalancesToolbar = function BalancesToolbar(props) {
  var searchTerm = props.searchTerm,
      setSearchTerm = props.setSearchTerm,
      hideSmallBalances = props.hideSmallBalances,
      setHideSmallBalances = props.setHideSmallBalances,
      smallBalanceThreshold = props.smallBalanceThreshold;

  var _useTranslation = useTranslation('balances'),
      t = _useTranslation.t;

  var handleClick = function handleClick() {
    return setHideSmallBalances(!hideSmallBalances);
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: "toolbar"
  }, /*#__PURE__*/React__default.createElement(Input, {
    placeholder: "".concat(t('common:filter'), ".."),
    small: true,
    rightElement: /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
      icon: faSearch,
      className: "search-icon"
    }),
    value: searchTerm,
    onChange: setSearchTerm
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "hide-small-balance-wrapper"
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    small: true,
    label: /*#__PURE__*/React__default.createElement(Tooltip, {
      content: t('hide_small_balance_tooltip', {
        threshold: smallBalanceThreshold
      })
    }, t('hide_small_balance')),
    className: "hide-small-balance",
    checked: hideSmallBalances,
    onChange: handleClick
  })));
};

BalancesToolbar.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  hideSmallBalances: PropTypes.bool.isRequired,
  setHideSmallBalances: PropTypes.func.isRequired,
  smallBalanceThreshold: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
var BalancesToolbar$1 = /*#__PURE__*/memo(BalancesToolbar);

var Balances = function Balances(props) {
  var balances = props.balances,
      hideSmallBalances = props.hideSmallBalances,
      setHideSmallBalances = props.setHideSmallBalances,
      rowMapping = props.rowMapping,
      smallBalanceThreshold = props.smallBalanceThreshold,
      className = props.className,
      showTransfer = props.showTransfer,
      handleDepositClick = props.handleDepositClick,
      handleWithdrawClick = props.handleWithdrawClick;

  var _useTranslation = useTranslation('balances'),
      t = _useTranslation.t;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchTerm = _useState2[0],
      setSearchTerm = _useState2[1];

  var columns = useMemo(function () {
    return getColumns$6(showTransfer);
  }, [showTransfer]);
  var keyForName = getMappedKey(KEYS$7.NAME, rowMapping);
  var keyForExchange = getMappedKey(KEYS$7.EXCHANGE, rowMapping);

  var _useSortableData = useSortableData(balancesAdapter(balances), {
    key: keyForExchange
  }, sortData$1),
      _useSortableData$data = _useSortableData.data,
      data = _useSortableData$data === void 0 ? [] : _useSortableData$data,
      requestSort = _useSortableData.requestSort,
      sortConfig = _useSortableData.sortConfig;

  var filtered = _filter(data, function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        name = _ref.name;

    return _includes(_toLower(name), _toLower(searchTerm));
  });

  var renderBalancesTable = function renderBalancesTable() {
    if (filtered.length === 0) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: "empty"
      }, /*#__PURE__*/React__default.createElement("small", null, t('common:no_results_found')));
    }

    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Table, {
      condensed: true
    }, /*#__PURE__*/React__default.createElement(BalancesHeader$1, {
      sortConfig: sortConfig,
      requestSort: requestSort,
      columns: columns
    })), /*#__PURE__*/React__default.createElement("div", {
      className: TABLE_WRAPPER
    }, /*#__PURE__*/React__default.createElement(Table, {
      condensed: true,
      striped: true
    }, /*#__PURE__*/React__default.createElement("tbody", null, _map(filtered, function (row) {
      return /*#__PURE__*/React__default.createElement(BalancesRow$1, {
        key: _get(row, keyForName),
        data: row,
        dataMapping: rowMapping,
        columns: columns,
        handleDepositClick: handleDepositClick,
        handleWithdrawClick: handleWithdrawClick
      });
    })))));
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: cx(BALANCES, className)
  }, /*#__PURE__*/React__default.createElement(BalancesToolbar$1, {
    searchTerm: searchTerm,
    setSearchTerm: setSearchTerm,
    hideSmallBalances: hideSmallBalances,
    setHideSmallBalances: setHideSmallBalances,
    smallBalanceThreshold: smallBalanceThreshold
  }), renderBalancesTable());
};

Balances.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  balances: PropTypes.object,
  hideSmallBalances: PropTypes.bool,
  setHideSmallBalances: PropTypes.func,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  smallBalanceThreshold: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  showTransfer: PropTypes.bool,
  handleDepositClick: PropTypes.func,
  handleWithdrawClick: PropTypes.func
};
var defaultProps$a = {
  balances: {},
  hideSmallBalances: false,
  setHideSmallBalances: function setHideSmallBalances() {},
  rowMapping: {},
  smallBalanceThreshold: 0,
  className: null,
  showTransfer: false,
  handleDepositClick: function handleDepositClick() {},
  handleWithdrawClick: function handleWithdrawClick() {}
};
Balances.defaultProps = defaultProps$a;
var Balances$1 = ResponsiveWrapper(withI18nProvider( /*#__PURE__*/memo(Balances)));

var _THEME_MAP;

function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$9(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$9(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var THEMES = {
  LIGHT_THEME: 'light-theme',
  COLOURBLIND_THEME: 'colourblind-theme',
  BLACK_THEME: 'black-theme',
  EOSFINEX_THEME: 'eosfinex-dark-theme',
  DARK_THEME: 'dark-theme'
};
var COLORS = {
  light: {
    bg: '#FBFBFB',
    greenDark: '#16B157',
    greenLight: '#8BD8AB',
    redDark: '#F05359',
    redLight: '#F7A9AC',
    blueDark: '#87a5b8',
    blueLight: '#76a7c6'
  },
  colourblind: {
    bg: '#FBFBFB',
    greenDark: '#1E70B2',
    greenLight: '#ACD0F1',
    redDark: '#EFBA4B',
    redLight: '#FEDD94',
    blueDark: '#87a5b8',
    blueLight: '#76a7c6'
  },
  dark: {
    bg: '#1b262d',
    greenDark: '#16B157',
    greenLight: '#1B4937',
    redDark: '#F05359',
    redLight: '#523137',
    blueDark: '#5e7d90',
    blueLight: '#82BAF6'
  },
  black: {
    bg: '#121212',
    greenDark: '#16B157',
    greenLight: 'red',
    redDark: '#F05359',
    redLight: '#523137',
    blueDark: '#ccc',
    blueLight: '#ccc'
  }
};
var EOSFINEX_COLORS = {
  dark: {
    bg: '#182A39',
    greenDark: '#3DCC91',
    greenLight: '#51D19C',
    redDark: '#D22A42',
    redLight: '#D83E54',
    blueDark: '#87a5b8',
    blueLight: '#76a7c6'
  }
};
var GREY = {
  grayscale1: '#FBFCFE',
  grayscale2: '#F5F6F7',
  grayscale3: '#E6EAEB',
  grayscale4: '#DBDFE3',
  grayscale5: '#BFC3C6',
  grayscale6: '#A4A9AC',
  grayscale7: '#7E8486',
  grayscale8: '#646B6E',
  grayscale9: '#485054',
  grayscale10: '#253135',
  grayscale11: '#212D31',
  grayscale12: '#1B272B',
  grayscale13: '#152023',
  grayscale14: '#111B1E',
  grayscale15: '#0C171A'
}; // @TODO replace GREY with GRAY

var GRAY = {
  darkGray1: '#172a39',
  darkGray2: '#202b33',
  darkGray3: '#293742',
  darkGray4: '#30404d',
  darkGray5: '#394b59',
  gray1: '#5c7080',
  gray2: '#738694',
  gray3: '#8a9ba8',
  gray4: '#a7b6c2',
  gray5: '#bfccd6',
  gray6: '#bfccd6',
  lightGray1: '#c6b9b9',
  lightGray2: '#d4d4d4',
  lightGray3: '#e1e8ed',
  lightGray4: '#ebf1f5',
  lightGray5: '#f5f8fa',
  lightGray6: '#f9f9fe'
}; // helper for lines

var orderLine = function orderLine(color) {
  return {
    lineColor: color.line,
    bodyTextColor: color.text,
    quantityTextColor: color.text,
    cancelButtonIconColor: color.text,
    bodyBorderColor: color.borderColor,
    quantityBorderColor: color.borderColor,
    cancelButtonBorderColor: color.borderColor,
    bodyBackgroundColor: color.backgroundColor,
    quantityBackgroundColor: color.backgroundColor,
    cancelButtonBackgroundColor: color.backgroundColor
  };
}; // generates theme for light backgrounds


var generateLightTheme = function generateLightTheme(colors) {
  var color = {
    bg: colors.bg,
    textColor: '#999',
    ask: {
      line: colors.redDark,
      text: colors.redDark,
      borderColor: colors.redDark,
      backgroundColor: GREY.grayscale2
    },
    bid: {
      line: colors.greenDark,
      text: colors.greenDark,
      borderColor: colors.greenDark,
      backgroundColor: GREY.grayscale2
    },
    position: {
      line: GREY.grayscale7,
      text: GREY.grayscale7,
      borderColor: GREY.grayscale6,
      backgroundColor: GREY.grayscale2
    },
    alert: {
      line: colors.blueDark,
      text: colors.blueDark,
      borderColor: colors.blueLight,
      backgroundColor: colors.bg
    }
  };
  var chartStyles = {
    bg: colors.bg,
    category: 'light',
    "short": colors.redDark,
    "long": colors.greenDark,
    altDark: colors.blueDark,
    altLight: colors.blueLight,
    crosshair: '#888888',
    cta: colors.bg,
    ctaHighlight: '#F5F5F5',
    alert: '#FFD506',
    grid: '#E6E6E6',
    lineColor: '#555',
    textColor: '#999',
    transparency: 60,
    liqTooltipDot: '#333'
  };
  var orderAskLine = orderLine(color.ask);
  var orderBidLine = orderLine(color.bid);
  var positionLine = orderLine(color.position);
  var alertLine = orderLine(color.alert);
  var depthChartStyles = {
    bidsColor: colors.greenDark,
    asksColor: colors.redDark,
    bgColor: '#fff',
    axisColor: GRAY.gray3,
    fontColor: GRAY.darkGray1,
    highlightColor: GRAY.darkGray1
  };
  return _objectSpread$9(_objectSpread$9({}, chartStyles), {}, {
    orders: {
      ask: orderAskLine,
      bid: orderBidLine
    },
    position: positionLine,
    alerts: alertLine,
    depthChart: depthChartStyles
  });
}; // generates theme for dark backgrounds


var generateDarkTheme = function generateDarkTheme(colors) {
  var color = {
    bg: colors.bg,
    textColor: '#999',
    ask: {
      line: colors.redDark,
      text: colors.redDark,
      borderColor: colors.redLight,
      backgroundColor: colors.bg
    },
    bid: {
      line: colors.greenDark,
      text: colors.greenDark,
      borderColor: colors.greenLight,
      backgroundColor: colors.bg
    },
    position: {
      line: GREY.grayscale6,
      text: GREY.grayscale7,
      borderColor: GREY.grayscale8,
      backgroundColor: GREY.grayscale11
    },
    alert: {
      line: colors.blueDark,
      text: colors.blueDark,
      borderColor: colors.blueLight,
      backgroundColor: colors.bg
    }
  };
  var orderAskLine = orderLine(color.ask);
  var orderBidLine = orderLine(color.bid);
  var positionLine = orderLine(color.position);
  var alertLine = orderLine(color.alert);
  var chartStyles = {
    bg: colors.bg,
    category: 'dark',
    "short": colors.redDark,
    shortLight: colors.redLight,
    "long": colors.greenDark,
    longLight: colors.greenLight,
    altDark: colors.blueDark,
    altLight: colors.blueLight,
    crosshair: '#888888',
    cta: '#363D52',
    ctaHighlight: '#414A67',
    alert: '#FFD506',
    grid: '#28343C',
    lineColor: '#555',
    textColor: '#999',
    transparency: 65,
    liqTooltipDot: '#fff'
  };
  var depthChartStyles = {
    bidsColor: colors.greenDark,
    asksColor: colors.redDark,
    bgColor: colors.bg,
    axisColor: GRAY.gray3,
    fontColor: GRAY.gray4,
    highlightColor: '#fff'
  };
  return _objectSpread$9(_objectSpread$9({}, chartStyles), {}, {
    orders: {
      ask: orderAskLine,
      bid: orderBidLine
    },
    position: positionLine,
    alerts: alertLine,
    depthChart: depthChartStyles
  });
};

var THEME_MAP = (_THEME_MAP = {}, _defineProperty(_THEME_MAP, THEMES.LIGHT_THEME, generateLightTheme(COLORS.light)), _defineProperty(_THEME_MAP, THEMES.COLOURBLIND_THEME, generateLightTheme(COLORS.colourblind)), _defineProperty(_THEME_MAP, THEMES.DARK_THEME, generateDarkTheme(COLORS.dark)), _defineProperty(_THEME_MAP, THEMES.BLACK_THEME, generateDarkTheme(COLORS.black)), _defineProperty(_THEME_MAP, THEMES.EOSFINEX_THEME, generateDarkTheme(EOSFINEX_COLORS.dark)), _THEME_MAP);

function getCurrentStyle(theme) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!theme) {
    throw new Error('Unable to get style, theme not set');
  }

  if (type) {
    return _get(THEME_MAP, "".concat(theme, ".").concat(type));
  }

  return _get(THEME_MAP, theme);
} // left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36


var keys = {
  37: 1,
  38: 1,
  39: 1,
  40: 1
};

function preventDefault(e) {
  e.preventDefault();
} // eslint-disable-next-line consistent-return


function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
} // modern Chrome requires { passive: false } when adding event


var supportsPassive = false;

try {
  window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
    // eslint-disable-next-line getter-return
    get: function get() {
      supportsPassive = true;
    }
  })); // eslint-disable-next-line no-empty
} catch (e) {}

var wheelOpt = supportsPassive ? {
  passive: false
} : false;

var getWheelEvent = function getWheelEvent() {
  return 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
}; // call this to Disable


function disableScroll() {
  window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF

  window.addEventListener(getWheelEvent(), preventDefault, wheelOpt); // modern desktop

  window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile

  window.addEventListener('keydown', preventDefaultForScrollKeys, false);
} // call this to Enable


function enableScroll() {
  window.removeEventListener('DOMMouseScroll', preventDefault, false);
  window.removeEventListener(getWheelEvent(), preventDefault, wheelOpt);
  window.removeEventListener('touchmove', preventDefault, wheelOpt);
  window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

function dpi(value) {
  return value * (typeof window !== 'undefined' ? window.devicePixelRatio : 1);
}

function ownKeys$a(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$a(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$a(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var DepthChartCanvas = /*#__PURE__*/function () {
  // canvas settings
  // this margin is necessary to make the texts that are positioned in the top
  // of the chart fit within the canvas, as the total volume’s text extends
  // beyond the graph
  // offset to position the spread percentage text in the middle (vertically)
  // of the crosshair line
  // set on init
  // set in each render
  // set on mouse hover
  function DepthChartCanvas(_ref) {
    var _this = this;

    var ref = _ref.ref,
        bidsColor = _ref.bidsColor,
        asksColor = _ref.asksColor,
        fontColor = _ref.fontColor,
        axisColor = _ref.axisColor,
        bgColor = _ref.bgColor,
        highlightColor = _ref.highlightColor,
        _ref$ticksDisplayStyl = _ref.ticksDisplayStyle,
        ticksDisplayStyle = _ref$ticksDisplayStyl === void 0 ? document.body.clientWidth > BREAKPOINTS.MD ? DepthChartCanvas.ticksDisplayStyle.twoStaticTicks : DepthChartCanvas.ticksDisplayStyle.oneStaticTick : _ref$ticksDisplayStyl,
        onScroll = _ref.onScroll,
        initialZoom = _ref.initialZoom,
        fontFamily = _ref.fontFamily;

    _classCallCheck(this, DepthChartCanvas);

    _defineProperty(this, "devicePixelRatio", null);

    _defineProperty(this, "yAxisWidth", null);

    _defineProperty(this, "xAxisHeight", null);

    _defineProperty(this, "yAxisTickSize", null);

    _defineProperty(this, "xAxisTickSize", null);

    _defineProperty(this, "fontSize", null);

    _defineProperty(this, "chartMarginTop", null);

    _defineProperty(this, "crosshairIntersectionPointSize", null);

    _defineProperty(this, "spreadPercentageTextYOffset", null);

    _defineProperty(this, "textBackgroundPadding", null);

    _defineProperty(this, "canvas", null);

    _defineProperty(this, "context", null);

    _defineProperty(this, "midPrice", null);

    _defineProperty(this, "bids", null);

    _defineProperty(this, "asks", null);

    _defineProperty(this, "yTotal", null);

    _defineProperty(this, "bidsGradient", null);

    _defineProperty(this, "asksGradient", null);

    _defineProperty(this, "mouseX", null);

    _defineProperty(this, "mouseY", null);

    _defineProperty(this, "didMouseEnter", false);

    this.bidsColor = bidsColor;
    this.asksColor = asksColor;
    this.fontColor = fontColor;
    this.axisColor = axisColor;
    this.bgColor = bgColor;
    this.highlightColor = highlightColor;
    this.ticksDisplayStyle = ticksDisplayStyle;
    this.canvas = ref;
    this.zoom = initialZoom;
    this.fontFamily = fontFamily; // check for canvas, there’s an edge-case here when the connection drops, reconnects and drops again

    if (!this.canvas) return;
    this.context = this.canvas.getContext('2d');
    var canvasStyle = window.getComputedStyle(this.canvas);
    this.width = dpi(Math.floor(Number(canvasStyle.getPropertyValue('width').slice(0, -2))));
    this.height = dpi(Number(canvasStyle.getPropertyValue('height').slice(0, -2)));
    this.centerX = this.width / 2; // set the correct attributes for a crystal clear image!

    this.canvas.setAttribute('width', this.width);
    this.canvas.setAttribute('height', this.height);
    this.setPixels();
    this.chartHeight = this.height - this.chartMarginTop - this.xAxisHeight;
    this.bidsGradient = this.context.createLinearGradient(0, this.chartMarginTop, 0, this.chartHeight);
    this.bidsGradient.addColorStop(0, convertHexToRGBA(bidsColor, 0.1));
    this.bidsGradient.addColorStop(1, convertHexToRGBA(bidsColor, 0.02));
    this.asksGradient = this.context.createLinearGradient(0, this.chartMarginTop, 0, this.chartHeight);
    this.asksGradient.addColorStop(0, convertHexToRGBA(asksColor, 0.1));
    this.asksGradient.addColorStop(1, convertHexToRGBA(asksColor, 0.02));

    if (document.body.clientWidth > BREAKPOINTS.MD) {
      this.canvas.addEventListener('mouseenter', function () {
        disableScroll();
        _this.didMouseEnter = true;
      });
      this.canvas.addEventListener('mouseleave', function () {
        enableScroll();
        _this.didMouseEnter = false;
      });
      this.canvas.addEventListener('mousemove', function (event) {
        _this.mouseX = dpi(event.offsetX);
        _this.mouseY = dpi(event.offsetY);

        _this.drawChart();
      });
      this.canvas.addEventListener('wheel', onScroll);
    }
  } // #region get coordinates methods
  // returns the x coordinate by price


  _createClass(DepthChartCanvas, [{
    key: "getX",
    value: function getX(price) {
      var xRatio = (price - this.firstPrice) / (this.lastPrice - this.firstPrice);
      var x = this.leftYAxisX + this.chartWidth * xRatio; // the coordinate should stay within the chart axis, hence the 1px max/min

      var leftCappedX = Math.max(x, this.leftYAxisX + 1);
      return Math.min(leftCappedX, this.rightYAxisX - 1);
    } // returns the y coordinate by total
    // it’s dividing the bids’ or asks’ total (depending on which one is calling this function)
    // from the bids’ AND asks’ total and compensating for the top margin

  }, {
    key: "getY",
    value: function getY(total) {
      var yRatio = total / this.yTotal;
      var chartHeightMinusMarginTop = this.chartHeight - this.chartMarginTop;
      var y = Math.round(this.chartMarginTop + (chartHeightMinusMarginTop - yRatio * chartHeightMinusMarginTop));
      return Math.min(y, this.chartHeight - 1);
    }
  }, {
    key: "getYAxisWidth",
    value: function getYAxisWidth() {
      return Math.round(this.context.measureText(formatTotal(this.yTotal)).width + this.yAxisTickSize + dpi(7));
    }
  }, {
    key: "getPriceByX",
    value: function getPriceByX(x) {
      var xRatio = (x - this.leftYAxisX) / this.chartWidth;
      return this.firstPrice + (this.lastPrice - this.firstPrice) * xRatio;
    } // #endregion

  }, {
    key: "transformOrders",
    value: function transformOrders(orders) {
      /* eslint-disable prefer-destructuring */
      var zoomRatio = this.zoom / 100;
      var startingBidPrice = orders.pBidsTop[0] + (this.midPrice - orders.pBidsTop[0]) * (1 - zoomRatio); // the ask prices should not be more than double the mid price to
      // ensure the bids filler price will not go below 0

      var endingAskPrice = this.midPrice + (Math.min(_last(orders.pAsksTop), this.midPrice * 2) - this.midPrice) * zoomRatio; // minimum amount of orders

      var minOrders = 3;
      var pBids = orders.pBidsTop.filter(function (price, index) {
        return index >= orders.pBidsTop.length - minOrders || price >= startingBidPrice;
      });
      var pAsks = orders.pAsksTop.filter(function (price, index) {
        return index < minOrders || price <= endingAskPrice;
      });
      var bidsPriceRange = this.midPrice - pBids[0];
      var asksPriceRange = _last(pAsks) - this.midPrice;

      var bids = _objectSpread$a(_objectSpread$a({}, orders.bids), orders.bidsTop);

      var tBids = _objectSpread$a(_objectSpread$a({}, orders.tBids), orders.tBidsTop);

      var asks = _objectSpread$a(_objectSpread$a({}, orders.asks), orders.asksTop);

      var tAsks = _objectSpread$a(_objectSpread$a({}, orders.tAsks), orders.tAsksTop); // add order with a filler price to get the price range to match the other side


      if (bidsPriceRange < asksPriceRange) {
        var fillerPrice = this.midPrice - asksPriceRange;
        var pBidsTopTillFillerPrice = orders.pBidsTop.filter(function (price) {
          return price >= fillerPrice;
        });
        var pBidsFromFillerPriceTillFirstBidTop = orders.pBids.filter(function (price) {
          return price >= fillerPrice && price < pBidsTopTillFillerPrice[0];
        }).sort(function (a, b) {
          return a - b;
        });
        bids = _objectSpread$a(_objectSpread$a({}, bids), {}, _defineProperty({}, fillerPrice, bids[pBidsFromFillerPriceTillFirstBidTop[0] || pBidsTopTillFillerPrice[0]]));
        tBids = _objectSpread$a(_objectSpread$a({}, tBids), {}, _defineProperty({}, fillerPrice, tBids[pBidsFromFillerPriceTillFirstBidTop[0] || pBidsTopTillFillerPrice[0]]));
        pBids = [fillerPrice].concat(_toConsumableArray(pBidsFromFillerPriceTillFirstBidTop), _toConsumableArray(pBidsTopTillFillerPrice));
      }

      if (bidsPriceRange > asksPriceRange) {
        var _fillerPrice = this.midPrice + bidsPriceRange;

        var pAsksTopTillFillerPrice = orders.pAsksTop.filter(function (price) {
          return price <= _fillerPrice;
        });
        var pAsksFromFillerPriceTillFirstAskTop = orders.pAsksTop.filter(function (price) {
          return price <= _fillerPrice && price > _last(pAsksTopTillFillerPrice);
        });
        asks = _objectSpread$a(_objectSpread$a({}, asks), {}, _defineProperty({}, _fillerPrice, asks[_last(pAsksFromFillerPriceTillFirstAskTop) || _last(pAsksTopTillFillerPrice)]));
        tAsks = _objectSpread$a(_objectSpread$a({}, tAsks), {}, _defineProperty({}, _fillerPrice, tAsks[_last(pAsksFromFillerPriceTillFirstAskTop) || _last(pAsksTopTillFillerPrice)]));
        pAsks = [].concat(_toConsumableArray(pAsksTopTillFillerPrice), _toConsumableArray(pAsksFromFillerPriceTillFirstAskTop), [_fillerPrice]);
      }

      return {
        bids: bids,
        tBids: tBids,
        pBids: pBids,
        asks: asks,
        tAsks: tAsks,
        pAsks: pAsks
      };
    }
  }, {
    key: "getChartData",
    value: function getChartData(orders, pOrders, tOrders, isBids) {
      var chartData = [];
      var coordinates = [];

      for (var index = 0; index < pOrders.length; index += 1) {
        var price = pOrders[index];
        var order = orders[price];
        var total = Math.abs(tOrders[price].total);
        var neighboringPrice = pOrders[index + (isBids ? -1 : 1)];
        var neighboringTotal = neighboringPrice ? Math.abs(tOrders[neighboringPrice].total) : null;
        var x0 = isBids && neighboringPrice ? this.getX(neighboringPrice) : this.getX(price);
        var x1 = !isBids && neighboringPrice ? this.getX(neighboringPrice) : this.getX(price);
        var y = this.getY(total);
        chartData.push({
          price: price,
          amount: order.amount,
          total: total,
          // the difference is used to display the biggest ticks in volume
          // the total is compared with the next (asks) or previous (bids) entry
          difference: total - neighboringTotal,
          // coordinates (x0, x1, y)
          x0: x0,
          x1: x1,
          y: y
        });
        coordinates.push([x0, y], [x1, y]);
      }

      return [chartData, coordinates];
    } // #region draw methods

  }, {
    key: "drawLine",
    value: function drawLine(coordinates, color) {
      var _this2 = this;

      var lineDash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      this.context.beginPath();
      this.context.setLineDash(lineDash);
      this.context.lineWidth = dpi(1);
      this.context.strokeStyle = color;
      coordinates.forEach(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            x = _ref3[0],
            y = _ref3[1]; // https://stackoverflow.com/questions/8696631/canvas-drawings-like-lines-are-blurry
        // the 0.5 is necessary to avoid blurry lines


        _this2.context.lineTo(x + 0.5, y + 0.5);
      });
      this.context.stroke();
      this.context.restore();
    }
  }, {
    key: "drawDashedLine",
    value: function drawDashedLine(coordinates, color) {
      this.drawLine(coordinates, color, [3, 4]);
    }
  }, {
    key: "drawFilledPath",
    value: function drawFilledPath(coordinates, fillStyle) {
      var _this3 = this;

      this.context.beginPath();
      this.context.fillStyle = fillStyle;
      coordinates.forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            x = _ref5[0],
            y = _ref5[1]; // https://stackoverflow.com/questions/8696631/canvas-drawings-like-lines-are-blurry
        // the 0.5 is necessary to avoid blurry lines


        _this3.context.lineTo(x + 0.5, y + 0.5);
      });
      this.context.fill();
      this.context.closePath();
      this.context.restore();
    }
  }, {
    key: "drawText",
    value: function drawText(text, x, y, color) {
      this.context.font = "".concat(this.fontSize, "px ").concat(this.fontFamily);
      this.context.textBaseline = 'top';
      var textWidth = this.context.measureText(text).width;
      var textPadding = this.textBackgroundPadding; // draw background rect for text

      this.context.fillStyle = this.bgColor;
      this.context.fillRect(x - textPadding, y - textPadding, textWidth + textPadding * 2, this.fontSize + textPadding); // draw text on top of background

      this.context.fillStyle = color;
      this.context.fillText(text, x, y);
      this.context.restore();
    } // #endregion
    // #region draw canvas components

  }, {
    key: "drawBidsLine",
    value: function drawBidsLine() {
      this.drawLine([].concat(_toConsumableArray(this.bidsCoordinates), [[_last(this.bids).x1, this.chartHeight]]), this.bidsColor);
    }
  }, {
    key: "drawBidsGradient",
    value: function drawBidsGradient() {
      this.drawFilledPath([].concat(_toConsumableArray(this.bidsCoordinates), [[_last(this.bids).x1, this.chartHeight], [this.bids[0].x0, this.chartHeight], [this.bids[0].x0, 0]]), this.bidsGradient);
    }
  }, {
    key: "drawAsksLine",
    value: function drawAsksLine() {
      this.drawLine([[this.asks[0].x0, this.chartHeight]].concat(_toConsumableArray(this.asksCoordinates)), this.asksColor);
    }
  }, {
    key: "drawAsksGradient",
    value: function drawAsksGradient() {
      this.drawFilledPath([].concat(_toConsumableArray(this.asksCoordinates), [[_last(this.asks).x1, this.chartHeight], [this.asks[0].x0, this.chartHeight], [this.asks[0].x0, this.asks[0].y]]), this.asksGradient);
    }
  }, {
    key: "drawYAxis",
    value: function drawYAxis() {
      // left
      this.drawLine([[this.leftYAxisX, this.chartMarginTop], [this.leftYAxisX, this.chartHeight]], this.axisColor); // center

      this.drawLine([[this.centerX, this.chartMarginTop], [this.centerX, this.chartHeight]], convertHexToRGBA(this.axisColor, 0.2)); // right

      this.drawLine([[this.rightYAxisX, this.chartMarginTop], [this.rightYAxisX, this.chartHeight]], this.axisColor);
    }
  }, {
    key: "drawXAxis",
    value: function drawXAxis() {
      this.drawLine([[this.leftYAxisX, this.chartHeight], [this.rightYAxisX, this.chartHeight]], this.axisColor);
    }
  }, {
    key: "drawYTick",
    value: function drawYTick(order) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var axisColor = opts.color || this.axisColor;
      var fontColor = opts.color || this.fontColor;
      var avoidClash = opts.avoidClash || false;
      var isBids = order.amount > 0;
      var tickY = order.y;
      var textY = tickY - this.chartMarginTop / 2;
      var isClashing = false;

      if (avoidClash) {
        var lastY = _last(this.ticks.y[isBids ? 'bids' : 'asks']);

        isClashing = textY + this.fontSize > lastY;

        if (!lastY || !isClashing) {
          this.ticks.y[isBids ? 'bids' : 'asks'].push(textY);
        }
      }

      if (isClashing) return; // distance between right axis and text

      var rightAxisOffset = dpi(15);
      var textX = isBids ? 0 : this.rightYAxisX + rightAxisOffset;
      var tickX0 = isBids ? this.leftYAxisX : this.rightYAxisX;
      var tickX1 = isBids ? this.leftYAxisX - this.yAxisTickSize : this.rightYAxisX + this.yAxisTickSize;
      this.drawText(formatTotal(order.total), textX, textY, fontColor);
      this.drawLine([[tickX0, tickY], [tickX1, tickY]], axisColor);
    }
  }, {
    key: "drawXTick",
    value: function drawXTick(order) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var axisColor = opts.color || this.axisColor;
      var fontColor = opts.color || this.fontColor;
      var avoidClash = opts.avoidClash || opts.spreadTick || false;
      var xOffset = opts.xOffset || 0;
      var isBids = order.amount > 0;
      var x = isBids ? 'x0' : 'x1';

      if (opts.spreadTick) {
        x = isBids ? 'x1' : 'x0';
      }

      var text = formatPrice(order.price);
      var textWidth = this.context.measureText(text).width; // distance between x axis and text

      var textOffsetY = dpi(16);
      var textX = order[x] - textWidth / 2;
      var isClashing = false;

      if (isBids) {
        var leftMax = this.centerX - this.textBackgroundPadding - textWidth;
        textX = Math.min(order[x] - textWidth / 2, leftMax);

        if (avoidClash) {
          var lastX = _last(this.ticks.x.bids);

          isClashing = textX + textWidth > lastX;

          if (!lastX || !isClashing) {
            this.ticks.x.bids.push(textX);
          }
        }
      }

      if (!isBids) {
        var rightMin = this.centerX + this.textBackgroundPadding;
        textX = Math.max(order[x] - textWidth / 2, rightMin);

        if (avoidClash) {
          var _lastX = _last(this.ticks.x.asks);

          isClashing = textX - textWidth < _lastX;

          if (!_lastX || !isClashing) {
            this.ticks.x.asks.push(textX);
          }
        }
      }

      if (!isClashing) {
        this.drawText(text, textX, this.chartHeight + textOffsetY, fontColor);
        this.drawLine([[order[x] + xOffset, this.chartHeight], [order[x] + xOffset, this.chartHeight + this.xAxisTickSize]], axisColor);
      }
    }
  }, {
    key: "drawYAxisTicks",
    value: function drawYAxisTicks() {
      this.drawYTick(this.bids[0]);
      this.drawYTick(_last(this.asks));
    }
  }, {
    key: "drawXAxisTicks",
    value: function drawXAxisTicks() {
      this.drawXTick(_last(this.bids), {
        spreadTick: true
      });
      this.drawXTick(this.asks[0], {
        spreadTick: true
      });
    } // draw the biggest ticks in volume

  }, {
    key: "drawVolumeTicks",
    value: function drawVolumeTicks() {
      var _this4 = this;

      var bids = _sortBy(_sortBy(this.bids, 'difference').slice(0, 3), 'price').reverse();

      bids.forEach(function (bid) {
        _this4.drawXTick(bid, {
          avoidClash: true
        });

        _this4.drawYTick(bid, {
          avoidClash: true
        });

        _this4.drawDashedLine([[_this4.leftYAxisX, bid.y], [bid.x0, bid.y], [bid.x0, _this4.chartHeight]], convertHexToRGBA(_this4.bidsColor, 0.4));
      });

      var asks = _sortBy(_sortBy(this.asks.filter(function (a) {
        return a.difference;
      }), 'difference').slice(0, 3), 'price');

      asks.forEach(function (ask) {
        _this4.drawXTick(ask, {
          avoidClash: true
        });

        _this4.drawYTick(ask, {
          avoidClash: true
        });

        _this4.drawDashedLine([[ask.x1, _this4.chartHeight], [ask.x1, ask.y], [_this4.rightYAxisX, ask.y]], convertHexToRGBA(_this4.asksColor, 0.7));
      });
    }
  }, {
    key: "drawStaticTicks",
    value: function drawStaticTicks() {
      var _this5 = this;

      var oneStaticTick = this.ticksDisplayStyle === DepthChartCanvas.ticksDisplayStyle.oneStaticTick;
      var chartHalf = this.chartWidth / 2;
      var bids = [];
      var asks = [];

      if (oneStaticTick) {
        var bidX = this.leftYAxisX + chartHalf / 2;
        var askX = this.centerX + chartHalf / 2;
        var bid = this.bids.find(function (b) {
          return bidX >= b.x0 && bidX <= b.x1;
        });
        var ask = this.asks.find(function (a) {
          return askX >= a.x0 && askX <= a.x1;
        });

        if (bid) {
          bids.push(_objectSpread$a(_objectSpread$a({}, bid), {}, {
            price: this.getPriceByX(bidX),
            x0: bidX
          }));
        }

        if (ask) {
          asks.push(_objectSpread$a(_objectSpread$a({}, ask), {}, {
            price: this.getPriceByX(askX),
            x1: askX
          }));
        }
      } else {
        var bidX1 = this.leftYAxisX + chartHalf / 3 * 2;
        var askX1 = this.centerX + chartHalf / 3;
        var bidX2 = this.leftYAxisX + chartHalf / 3;
        var askX2 = this.centerX + chartHalf / 3 * 2;
        var bid1 = this.bids.find(function (b) {
          return bidX1 >= b.x0 && bidX1 <= b.x1;
        });
        var bid2 = this.bids.find(function (b) {
          return bidX2 >= b.x0 && bidX2 <= b.x1;
        });
        var ask1 = this.asks.find(function (a) {
          return askX1 >= a.x0 && askX1 <= a.x1;
        });
        var ask2 = this.asks.find(function (a) {
          return askX2 >= a.x0 && askX2 <= a.x1;
        });

        if (bid1) {
          bids.push(_objectSpread$a(_objectSpread$a({}, bid1), {}, {
            price: this.getPriceByX(bidX1),
            x0: bidX1
          }));
        }

        if (bid2) {
          bids.push(_objectSpread$a(_objectSpread$a({}, bid2), {}, {
            price: this.getPriceByX(bidX2),
            x0: bidX2
          }));
        }

        if (ask1) {
          asks.push(_objectSpread$a(_objectSpread$a({}, ask1), {}, {
            price: this.getPriceByX(askX1),
            x1: askX1
          }));
        }

        if (ask2) {
          asks.push(_objectSpread$a(_objectSpread$a({}, ask2), {}, {
            price: this.getPriceByX(askX2),
            x1: askX2
          }));
        }
      }

      this.drawXTick(this.bids[0], {
        xOffset: -1
      });
      bids.forEach(function (bid) {
        _this5.drawXTick(bid, {
          avoidClash: true
        });

        _this5.drawYTick(bid, {
          avoidClash: true
        });

        _this5.drawDashedLine([[_this5.leftYAxisX, bid.y], [bid.x0, bid.y], [bid.x0, _this5.chartHeight]], convertHexToRGBA(_this5.bidsColor, 0.4));
      });
      this.drawXTick(_last(this.asks), {
        xOffset: 1
      });
      asks.forEach(function (ask) {
        _this5.drawXTick(ask, {
          avoidClash: true
        });

        _this5.drawYTick(ask, {
          avoidClash: true
        });

        _this5.drawDashedLine([[ask.x1, _this5.chartHeight], [ask.x1, ask.y], [_this5.rightYAxisX, ask.y]], convertHexToRGBA(_this5.asksColor, 0.7));
      });
    } // #endregion
    // #region draw crosshair methods

  }, {
    key: "drawBidCrosshair",
    value: function drawBidCrosshair(bidX) {
      var bid = this.bids.find(function (b) {
        return bidX >= b.x0 && bidX <= b.x1;
      }) // if we didn’t find a bid in the mouse position then we are hovering in the spread gap
      || _objectSpread$a(_objectSpread$a({}, _last(this.bids)), {}, {
        y: this.chartHeight
      });

      var price = this.getPriceByX(bidX);
      var bidSpreadPercentage = "".concat(((1 - price / this.midPrice) * 100).toFixed(2), "%");
      this.drawXTick(_objectSpread$a(_objectSpread$a({}, bid), {}, {
        price: price,
        x0: bidX
      }), {
        color: this.bidsColor
      });
      this.drawYTick(bid, {
        color: this.bidsColor
      }); // cover non relevant bids data with background to make "selection" more visibly focused

      this.drawFilledPath([[this.leftYAxisX, this.chartMarginTop - 1], [bidX, this.chartMarginTop - 1], [bidX, this.chartHeight], [this.leftYAxisX, this.chartHeight]], convertHexToRGBA(this.bgColor, 0.6)); // draw line inside

      this.drawDashedLine([[this.leftYAxisX, bid.y], [bidX, bid.y], [bidX, this.chartHeight + this.chartMarginTop]], this.bidsColor); // draw line outside

      this.drawDashedLine([[bidX, this.chartMarginTop], [bidX, bid.y], [this.centerX, bid.y]], convertHexToRGBA(this.bidsColor, 0.4)); // draw intersection point

      var pointSize = this.crosshairIntersectionPointSize;
      this.drawFilledPath([[bidX, bid.y - pointSize], [bidX + pointSize, bid.y], [bidX, bid.y + pointSize], [bidX - pointSize, bid.y]], this.highlightColor); // draw spread percentage text

      var bidSpreadPercentageTextWidth = this.context.measureText(bidSpreadPercentage).width;
      var bidSpreadPercentageTextX = bidX + (this.centerX - bidX) / 2 - bidSpreadPercentageTextWidth / 2;
      var bidSpreadPercentageTextY = Math.min(bid.y + this.spreadPercentageTextYOffset, this.chartHeight - dpi(13));
      this.drawText(bidSpreadPercentage, bidSpreadPercentageTextX, bidSpreadPercentageTextY, this.bidsColor);
    }
  }, {
    key: "drawAskCrosshair",
    value: function drawAskCrosshair(askX) {
      var ask = this.asks.find(function (a) {
        return askX >= a.x0 && askX <= a.x1;
      }) // if we didn’t find an ask in the mouse position then we are hovering in the spread gap
      || _objectSpread$a(_objectSpread$a({}, this.asks[0]), {}, {
        y: this.chartHeight
      });

      var price = this.getPriceByX(askX);
      var askSpreadPercentage = "".concat(((price / this.midPrice - 1) * 100).toFixed(2), "%");
      this.drawXTick(_objectSpread$a(_objectSpread$a({}, ask), {}, {
        price: price,
        x1: askX
      }), {
        color: this.asksColor
      });
      this.drawYTick(ask, {
        color: this.asksColor
      }); // cover non relevant asks data with background to make "selection" more visibly focused

      this.drawFilledPath([[this.rightYAxisX, this.chartMarginTop - 1], [askX, this.chartMarginTop - 1], [askX, this.chartHeight], [this.rightYAxisX, this.chartHeight]], convertHexToRGBA(this.bgColor, 0.6)); // draw line inside

      this.drawDashedLine([[askX, this.chartHeight], [askX, ask.y], [this.rightYAxisX, ask.y]], this.asksColor); // draw line outside

      this.drawDashedLine([[askX, this.chartMarginTop], [askX, ask.y], [this.centerX, ask.y]], convertHexToRGBA(this.asksColor, 0.7)); // draw intersection point

      var pointSize = this.crosshairIntersectionPointSize;
      this.drawFilledPath([[askX, ask.y - pointSize], [askX + pointSize, ask.y], [askX, ask.y + pointSize], [askX - pointSize, ask.y]], this.highlightColor);
      var askSpreadPercentageTextWidth = this.context.measureText(askSpreadPercentage).width;
      var askSpreadPercentageTextX = askX + (this.centerX - askX) / 2 - askSpreadPercentageTextWidth / 2;
      var bidSpreadPercentageTextY = Math.min(ask.y + this.spreadPercentageTextYOffset, this.chartHeight - dpi(13));
      this.drawText(askSpreadPercentage, askSpreadPercentageTextX, bidSpreadPercentageTextY, this.asksColor);
    }
  }, {
    key: "drawMouseHover",
    value: function drawMouseHover() {
      if (!this.didMouseEnter) return;
      var isInXRange = this.mouseX > this.leftYAxisX && this.mouseX < this.rightYAxisX;
      var isInYRange = this.mouseY > this.chartMarginTop && this.mouseY < this.chartMarginTop + this.chartHeight; // only render if the mouse is in the actual chart

      if (!isInXRange || !isInYRange) return; // take the opposite x position within the chart for the other side

      var oppositeX = this.width - this.mouseX; // var to determine whether the user is hovering over bids

      var isHoveringBids = this.mouseX >= this.leftYAxisX && this.mouseX <= this.centerX; // incase the spread percentage texts from both sides overlap (when they’re
      // close together), we want to draw the hovered side last so that it draws
      // on top of the other side

      if (isHoveringBids) {
        this.drawAskCrosshair(oppositeX);
        this.drawBidCrosshair(this.mouseX);
      } else {
        this.drawBidCrosshair(oppositeX);
        this.drawAskCrosshair(this.mouseX);
      }
    }
  }, {
    key: "drawMidPrice",
    value: function drawMidPrice() {
      var midPriceText = formatPrice(this.midPrice, {
        minDecimals: 1
      });
      var midPriceTextWidth = this.context.measureText(midPriceText).width;
      var midPriceTextX = this.centerX - midPriceTextWidth / 2;
      this.drawText(midPriceText, midPriceTextX, 0, this.fontColor);
      var spreadText = " ".concat(((this.midPrice - _last(this.bids).price) / this.midPrice * 100).toFixed(3), "%");
      var spreadTextWidth = this.context.measureText(spreadText).width;
      var spreadTextX = this.centerX - spreadTextWidth / 2;
      this.drawText(spreadText, spreadTextX, dpi(13), convertHexToRGBA(this.fontColor, 0.7));
    } // #endregion

  }, {
    key: "drawChart",
    value: function drawChart() {
      // check for context, there’s an edge-case here when the connection drops, reconnects and drops again
      if (!this.context || !this.bids || !this.bids.length) return; // clear previous drawing

      this.drawFilledPath([[0, 0], [this.width, 0], [this.width, this.height], [0, this.height]], this.bgColor); // init store for ticks locations to avoid clashing

      this.ticks = {
        y: {
          bids: [],
          asks: []
        },
        x: {
          bids: [],
          asks: []
        }
      };
      this.drawBidsLine();
      this.drawBidsGradient();
      this.drawAsksLine();
      this.drawAsksGradient();
      this.drawYAxis();
      this.drawXAxis();
      this.drawXAxisTicks();

      if (this.ticksDisplayStyle === DepthChartCanvas.ticksDisplayStyle.dynamic) {
        this.drawVolumeTicks();
      } else {
        this.drawStaticTicks();
      } // draw y total ticks after volume ticks


      this.drawYAxisTicks();
      this.drawMouseHover();
      this.drawMidPrice();
    } // when a user drags the window from a retina to a normal display
    // the dpi changes and we have to re-initalize these vars

  }, {
    key: "setPixels",
    value: function setPixels() {
      if (this.devicePixelRatio === window.devicePixelRatio) return;
      this.devicePixelRatio = window.devicePixelRatio;
      this.yAxisWidth = dpi(50);
      this.xAxisHeight = dpi(20);
      this.yAxisTickSize = dpi(8);
      this.xAxisTickSize = dpi(8);
      this.fontSize = dpi(11);
      this.chartMarginTop = dpi(7);
      this.crosshairIntersectionPointSize = dpi(2);
      this.spreadPercentageTextYOffset = dpi(-4);
      this.textBackgroundPadding = dpi(2);
    }
  }, {
    key: "render",
    value: function render(_ref6) {
      var bids = _ref6.bids,
          tBids = _ref6.tBids,
          pBids = _ref6.pBids,
          asks = _ref6.asks,
          tAsks = _ref6.tAsks,
          pAsks = _ref6.pAsks,
          bidsTop = _ref6.bidsTop,
          tBidsTop = _ref6.tBidsTop,
          pBidsTop = _ref6.pBidsTop,
          asksTop = _ref6.asksTop,
          tAsksTop = _ref6.tAsksTop,
          pAsksTop = _ref6.pAsksTop,
          zoom = _ref6.zoom;
      /* eslint-disable no-param-reassign */

      this.zoom = zoom || this.zoom;
      this.midPrice = (pAsksTop[0] - _last(pBidsTop)) / 2 + _last(pBidsTop);
      this.setPixels();

      var _this$transformOrders = this.transformOrders({
        bids: bids,
        tBids: tBids,
        pBids: pBids,
        asks: asks,
        tAsks: tAsks,
        pAsks: pAsks,
        bidsTop: bidsTop,
        tBidsTop: tBidsTop,
        pBidsTop: pBidsTop,
        asksTop: asksTop,
        tAsksTop: tAsksTop,
        pAsksTop: pAsksTop
      }),
          nextBids = _this$transformOrders.bids,
          nextTBids = _this$transformOrders.tBids,
          nextPBids = _this$transformOrders.pBids,
          nextAsks = _this$transformOrders.asks,
          nextTAsks = _this$transformOrders.tAsks,
          nextPAsks = _this$transformOrders.pAsks;

      this.yTotal = Math.max(Math.abs(nextTBids[nextPBids[0]].total), Math.abs(nextTAsks[_last(nextPAsks)].total));
      this.yAxisWidth = this.getYAxisWidth();
      this.chartWidth = this.width - this.yAxisWidth * 2;
      this.leftYAxisX = this.yAxisWidth;
      this.rightYAxisX = this.width - this.yAxisWidth;
      this.firstPrice = nextPBids[0];
      this.lastPrice = _last(nextPAsks); // get the data for chart drawing

      var _this$getChartData = this.getChartData(nextBids, nextPBids, nextTBids, true),
          _this$getChartData2 = _slicedToArray(_this$getChartData, 2),
          bidsChartData = _this$getChartData2[0],
          bidsCoordinates = _this$getChartData2[1];

      this.bids = bidsChartData;
      this.bidsCoordinates = bidsCoordinates;

      var _this$getChartData3 = this.getChartData(nextAsks, nextPAsks, nextTAsks, false),
          _this$getChartData4 = _slicedToArray(_this$getChartData3, 2),
          asksChartData = _this$getChartData4[0],
          asksCoordinates = _this$getChartData4[1];

      this.asks = asksChartData;
      this.asksCoordinates = asksCoordinates;
      this.drawChart();
      return this;
    }
  }]);

  return DepthChartCanvas;
}();

_defineProperty(DepthChartCanvas, "ticksDisplayStyle", {
  oneStaticTick: 'oneStaticTick',
  twoStaticTicks: 'twoStaticTicks',
  dynamic: 'dynamic'
});

var DepthChart = function DepthChart(_ref) {
  var asks = _ref.asks,
      bids = _ref.bids,
      tAsks = _ref.tAsks,
      tBids = _ref.tBids,
      pAsks = _ref.pAsks,
      pBids = _ref.pBids,
      asksTop = _ref.asksTop,
      bidsTop = _ref.bidsTop,
      tAsksTop = _ref.tAsksTop,
      tBidsTop = _ref.tBidsTop,
      pAsksTop = _ref.pAsksTop,
      pBidsTop = _ref.pBidsTop,
      className = _ref.className,
      loading = _ref.loading,
      theme = _ref.theme,
      width = _ref.width,
      height = _ref.height,
      zoom = _ref.zoom,
      prec = _ref.prec,
      updateZoom = _ref.updateZoom,
      fontFamily = _ref.fontFamily,
      currentPair = _ref.currentPair;
  var canvasRef = useRef(null);
  var chartRef = useRef(null);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var classes$1 = cx(DEPTH_CHART, className);

  var _getCurrentStyle = getCurrentStyle(theme),
      depthChartStyle = _getCurrentStyle.depthChart;

  useEffect(function () {
    // when the width/height changes (due to resizing) unset charts so that
    // they will be re-instantiated with the new width/height in the other
    // useEffect block. Do the same when disconnected/loading
    chartRef.current = null;
  }, [width, height, currentPair, prec]);
  useEffect(function () {
    if (!canvasRef.current || !pBidsTop.length || !pAsksTop.length) return;

    if (!chartRef.current) {
      chartRef.current = new DepthChartCanvas({
        ref: canvasRef.current,
        bidsColor: depthChartStyle.bidsColor,
        asksColor: depthChartStyle.asksColor,
        bgColor: depthChartStyle.bgColor,
        axisColor: depthChartStyle.axisColor,
        fontColor: depthChartStyle.fontColor,
        highlightColor: depthChartStyle.highlightColor,
        initialZoom: zoom,
        fontFamily: fontFamily,
        onScroll: function onScroll(event) {
          updateZoom(event.deltaY * 0.02);
        }
      });
    }

    chartRef.current.render({
      bids: bids,
      tBids: tBids,
      pBids: pBids,
      asks: asks,
      tAsks: tAsks,
      pAsks: pAsks,
      bidsTop: bidsTop,
      tBidsTop: tBidsTop,
      pBidsTop: pBidsTop,
      asksTop: asksTop,
      tAsksTop: tAsksTop,
      pAsksTop: pAsksTop,
      zoom: zoom
    });
  }, [bids, tBids, pBids, asks, tAsks, pAsks, bidsTop, tBidsTop, pBidsTop, asksTop, tAsksTop, pAsksTop, depthChartStyle, zoom, updateZoom, fontFamily]);

  if (loading) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(DEPTH_CHART, "__error")
    }, loading && /*#__PURE__*/React__default.createElement(Spinner$1, null));
  }

  if (!(pBidsTop.length > 2 && pAsksTop.length > 2)) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "side-message"
    }, t('common:no_data_available'));
  }

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement("canvas", {
    ref: canvasRef,
    className: "canvas",
    width: width || undefined,
    height: height || undefined
  }));
};

DepthChart.propTypes = {
  loading: PropTypes.bool,
  asks: PropTypes.objectOf(PropTypes.shape(PROP_BOOK)).isRequired,
  bids: PropTypes.objectOf(PropTypes.shape(PROP_BOOK)).isRequired,
  tAsks: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])).isRequired,
  tBids: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])).isRequired,
  pAsks: PropTypes.arrayOf(PropTypes.number).isRequired,
  pBids: PropTypes.arrayOf(PropTypes.number).isRequired,
  asksTop: PropTypes.objectOf(PropTypes.shape(PROP_BOOK)).isRequired,
  bidsTop: PropTypes.objectOf(PropTypes.shape(PROP_BOOK)).isRequired,
  tAsksTop: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])).isRequired,
  tBidsTop: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.shape(PROP_BOOK_TRADE), PropTypes.number])).isRequired,
  pAsksTop: PropTypes.arrayOf(PropTypes.number).isRequired,
  pBidsTop: PropTypes.arrayOf(PropTypes.number).isRequired,
  className: PropTypes.string,
  theme: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  zoom: PropTypes.number,
  prec: PropTypes.number,
  updateZoom: PropTypes.func.isRequired,
  fontFamily: PropTypes.string,
  currentPair: PropTypes.string.isRequired
};
var defaultProps$b = {
  loading: false,
  className: null,
  theme: 'eosfinex-dark-theme',
  width: 600,
  height: 220,
  zoom: 50,
  prec: 1,
  fontFamily: '"Helvetica Neue"'
};
DepthChart.defaultProps = defaultProps$b;
var DepthChart$1 = withI18nProvider( /*#__PURE__*/memo(DepthChart));

var DepthChartToolbar = function DepthChartToolbar(_ref) {
  var zoom = _ref.zoom,
      updateZoom = _ref.updateZoom,
      config = _ref.config;
  var classes$1 = cx("".concat(DEPTH_CHART, "__toolbar"), RIGHT_TO_LEFT);

  var _useTranslation = useTranslation('depthchart'),
      t = _useTranslation.t;

  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement(DefaultComp, {
    title: t('decrease_zoom'),
    onClick: function onClick() {
      return updateZoom(10);
    },
    minimal: true,
    disabled: zoom === config.MAX_ZOOM
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faSearchMinus
  })), /*#__PURE__*/React__default.createElement(DefaultComp, {
    title: t('increase_zoom'),
    onClick: function onClick() {
      return updateZoom(-10);
    },
    minimal: true,
    disabled: zoom === config.MIN_ZOOM
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faSearchPlus
  })));
};

var DepthChart_Toolbar = withI18nProvider( /*#__PURE__*/memo(DepthChartToolbar));

var AmountInput$2 = function AmountInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      symbol = _ref.symbol,
      props = _objectWithoutProperties(_ref, ["value", "onChange", "symbol"]);

  return /*#__PURE__*/React__default.createElement("div", {
    className: "amount-input"
  }, /*#__PURE__*/React__default.createElement(Input, _extends$d({
    type: "number",
    autoComplete: "off",
    name: "amount",
    value: value,
    onChange: onChange,
    rightElement: /*#__PURE__*/React__default.createElement("div", {
      className: "ccy"
    }, symbol) // eslint-disable-next-line react/jsx-props-no-spreading

  }, props)));
};

AmountInput$2.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  symbol: PropTypes.string.isRequired
};
var AmountInput$3 = /*#__PURE__*/memo(AmountInput$2);
var FIAT_CCY = 'USD';

var HelpMessage = function HelpMessage(props) {
  var currency = props.currency,
      symbol = props.symbol,
      handleCcyAmountChange = props.handleCcyAmountChange,
      convertCcy = props.convertCcy,
      showUsdEquivalent = props.showUsdEquivalent,
      minAmount = props.minAmount,
      error = props.error;

  var _useTranslation = useTranslation('movements'),
      t = _useTranslation.t;

  var minUsdEquiv = useMemo(function () {
    return convertCcy({
      volume: Number(minAmount),
      fromCcy: currency,
      toCcy: FIAT_CCY
    });
  }, [convertCcy, currency, minAmount]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, minAmount > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Trans, {
    i18nKey: "movements:min_amount"
  }, /*#__PURE__*/React__default.createElement(DefaultComp, {
    small: true,
    minimal: true,
    className: "min-amount",
    onClick: function onClick() {
      return handleCcyAmountChange(minAmount.toString());
    }
  }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, {
    minAmount: minAmount
  }, {
    symbol: symbol
  }))), showUsdEquivalent && t('min_amount_usd_equiv', {
    value: minUsdEquiv.toFixed(2)
  })), _size(error) > 0 && /*#__PURE__*/React__default.createElement("div", {
    className: ERROR_TEXT
  }, error));
};

HelpMessage.propTypes = {
  currency: PropTypes.string.isRequired,
  symbol: PropTypes.string.isRequired,
  handleCcyAmountChange: PropTypes.func.isRequired,
  convertCcy: PropTypes.func.isRequired,
  showUsdEquivalent: PropTypes.bool,
  minAmount: PropTypes.number,
  error: PropTypes.string
};
HelpMessage.defaultProps = {
  showUsdEquivalent: false,
  minAmount: null,
  error: null
};
var HelpMessage$1 = /*#__PURE__*/memo(HelpMessage);
var FIAT_CCY$1 = 'USD';

var CcyUSDAmountInput = function CcyUSDAmountInput(_ref) {
  var currency = _ref.currency,
      symbol = _ref.symbol,
      value = _ref.value,
      onChange = _ref.onChange,
      minAmount = _ref.minAmount,
      showUsdEquivalent = _ref.showUsdEquivalent,
      error = _ref.error,
      convertCcy = _ref.convertCcy;

  var _useTranslation = useTranslation('movements'),
      t = _useTranslation.t;

  var _useState = useState('0'),
      _useState2 = _slicedToArray(_useState, 2),
      usdEquiv = _useState2[0],
      setUsdEquiv = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEditingUsdEquiv = _useState4[0],
      setIsEditingUsdEquiv = _useState4[1];

  var handleCcyAmountChange = function handleCcyAmountChange(newValue) {
    onChange(newValue);
    var newUsdEquiv = convertCcy({
      volume: Number(newValue),
      fromCcy: currency,
      toCcy: FIAT_CCY$1
    });
    setUsdEquiv(newUsdEquiv.toFixed(2));
  };

  var handleUsdEquivChange = function handleUsdEquivChange(usdVal) {
    setUsdEquiv(usdVal);
    var newCcyVal = convertCcy({
      volume: Number(usdVal),
      fromCcy: FIAT_CCY$1,
      toCcy: currency
    });
    onChange(_toString(newCcyVal));
  }; // updates equiv amount when AvailableBalance box is clicked or ticker/conversion changes


  useEffect(function () {
    if (isEditingUsdEquiv) {
      // prevents loop of changing values when editing usdEquiv
      return;
    }

    setUsdEquiv(convertCcy({
      volume: Number(value),
      fromCcy: currency,
      toCcy: FIAT_CCY$1
    }).toFixed(2));
  }, [convertCcy, currency, isEditingUsdEquiv, value]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "ccy-usd"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "label"
  }, t('amount')), /*#__PURE__*/React__default.createElement(AmountInput$3, {
    value: value,
    onChange: handleCcyAmountChange,
    symbol: symbol
  }), showUsdEquivalent && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "equiv"
  }, "\u2248"), /*#__PURE__*/React__default.createElement(AmountInput$3, {
    value: usdEquiv,
    onChange: handleUsdEquivChange,
    onFocus: function onFocus() {
      return setIsEditingUsdEquiv(true);
    },
    onBlur: function onBlur() {
      return setIsEditingUsdEquiv(false);
    },
    symbol: FIAT_CCY$1
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "help"
  }, /*#__PURE__*/React__default.createElement(HelpMessage$1, {
    currency: currency,
    symbol: symbol,
    handleCcyAmountChange: handleCcyAmountChange,
    convertCcy: convertCcy,
    showUsdEquivalent: showUsdEquivalent,
    minAmount: minAmount,
    error: error
  })));
};

CcyUSDAmountInput.propTypes = {
  currency: PropTypes.string.isRequired,
  symbol: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  minAmount: PropTypes.number,
  showUsdEquivalent: PropTypes.bool,
  error: PropTypes.string,
  convertCcy: PropTypes.func.isRequired
};
var defaultProps$c = {
  showUsdEquivalent: false,
  minAmount: null,
  error: null
};
CcyUSDAmountInput.defaultProps = defaultProps$c;
var CcyUSDAmountInput$1 = withI18nProvider( /*#__PURE__*/memo(CcyUSDAmountInput));
var NOT_ENABLED = /not enabled/;
var NONE_GENERATED = 'none generated';

var DepositRow = function DepositRow(_ref) {
  var currency = _ref.currency,
      wallet = _ref.wallet,
      walletNames = _ref.walletNames,
      requestWalletAddress = _ref.requestWalletAddress,
      errorMessage = _ref.errorMessage;
  var _wallet$address = wallet.address,
      addr = _wallet$address === void 0 ? null : _wallet$address,
      name = wallet.name;

  var _useTranslation = useTranslation('deposits'),
      t = _useTranslation.t;

  var _useState = useState(addr),
      _useState2 = _slicedToArray(_useState, 2),
      address = _useState2[0],
      setAddress = _useState2[1];

  var notEnabled = address && NOT_ENABLED.test(address);
  var noAddress = !address || address === NONE_GENERATED;
  useEffect(function () {
    setAddress(addr);
  }, [addr]);

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isModalOpen = _useState4[0],
      setIsModalOpen = _useState4[1];

  var updateWalletAddress = function updateWalletAddress() {
    if (notEnabled) {
      return;
    }

    requestWalletAddress({
      name: name,
      address: address,
      notEnabled: notEnabled,
      setAddress: setAddress
    });
  };

  var copy = function copy() {
    if (notEnabled || noAddress) {
      return;
    }

    copyToClipboard(address);
  };

  var showQrCode = function showQrCode() {
    if (notEnabled || noAddress) {
      return;
    }

    setIsModalOpen(true);
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !address && errorMessage && /*#__PURE__*/React__default.createElement("div", null, errorMessage), address && /*#__PURE__*/React__default.createElement("div", {
    className: "deposit-row"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Heading, {
    tag: "h6"
  }, _capitalize(walletNames[name])), /*#__PURE__*/React__default.createElement("div", {
    className: "deposit-address"
  }, noAddress ? /*#__PURE__*/React__default.createElement(DefaultComp, {
    minimal: true,
    small: true,
    onClick: updateWalletAddress
  }, t('generate_address')) : /*#__PURE__*/React__default.createElement(Input, {
    small: true,
    disabled: notEnabled,
    readOnly: true,
    value: address
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React__default.createElement(DefaultComp, {
    small: true,
    onClick: copy,
    disabled: notEnabled || noAddress
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: t('common:copy_to_clipboard'),
    placement: "top"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faCopy
  }))), /*#__PURE__*/React__default.createElement(DefaultComp, {
    small: true,
    type: "button",
    onClick: updateWalletAddress,
    disabled: notEnabled || noAddress
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: t('change_address'),
    placement: "top"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faSync
  }))), /*#__PURE__*/React__default.createElement(DefaultComp, {
    small: true,
    type: "button",
    onClick: showQrCode,
    disabled: notEnabled || noAddress
  }, /*#__PURE__*/React__default.createElement(Tooltip, {
    content: t('scan_qr_code'),
    placement: "top"
  }, /*#__PURE__*/React__default.createElement(FontAwesomeIcon, {
    icon: faQrcode
  }))))), /*#__PURE__*/React__default.createElement(Dialog, {
    title: _startCase("".concat(name, " ").concat(t('wallet'), " (").concat(currency, ")")),
    isOpen: isModalOpen,
    onClose: function onClose() {
      return setIsModalOpen(false);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "qr-code-modal"
  }, /*#__PURE__*/React__default.createElement(QRCode$1, {
    value: address,
    className: "qr-code"
  }), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "address"
  }, address))));
};

DepositRow.propTypes = {
  currency: PropTypes.string.isRequired,
  wallet: PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string
  }).isRequired,
  requestWalletAddress: PropTypes.func.isRequired,
  walletNames: PropTypes.objectOf(PropTypes.string).isRequired,
  errorMessage: PropTypes.string
};
DepositRow.defaultProps = {
  errorMessage: null
};
var DepositRow$1 = /*#__PURE__*/memo(DepositRow);

var DepositWallets = function DepositWallets(_ref) {
  var currency = _ref.currency,
      wallets = _ref.wallets,
      walletNames = _ref.walletNames,
      requestWalletAddress = _ref.requestWalletAddress,
      errorMessage = _ref.errorMessage;
  return /*#__PURE__*/React__default.createElement("div", {
    className: DEPOSIT_WALLETS
  }, wallets.map(function (wallet, index) {
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: wallet.name
    }, /*#__PURE__*/React__default.createElement(DepositRow$1, {
      currency: currency,
      wallet: wallet,
      walletNames: walletNames,
      requestWalletAddress: requestWalletAddress,
      errorMessage: errorMessage
    }), index !== wallets.length - 1 && /*#__PURE__*/React__default.createElement("div", {
      className: DIVIDER
    }));
  }));
};

DepositWallets.propTypes = {
  currency: PropTypes.string.isRequired,
  wallets: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    address: PropTypes.string
  })).isRequired,
  walletNames: PropTypes.objectOf(PropTypes.string).isRequired,
  requestWalletAddress: PropTypes.func.isRequired,
  errorMessage: PropTypes.string
};
var defaultProps$d = {
  errorMessage: null
};
DepositWallets.defaultProps = defaultProps$d;
var DepositWallets$1 = withI18nProvider(ResponsiveWrapper( /*#__PURE__*/memo(DepositWallets)));
/* eslint-disable import/prefer-default-export */

var KEYS$8 = {
  ID: 'id',
  DATE: 'date',
  STATUS: 'status',
  AMOUNT: 'amount',
  TYPE: 'type'
};
var COLUMNS = [{
  key: KEYS$8.ID,
  getLabel: function getLabel() {
    return i18n.t('movements:id');
  }
}, {
  key: KEYS$8.DATE,
  getLabel: function getLabel() {
    return i18n.t('movements:date');
  },
  renderer: function renderer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        mts = _ref.value;

    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PrettyDate, {
      mts: mts,
      abbreviate: true,
      monthDayOnly: true
    }), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
      className: TEXT_MUTED
    }, /*#__PURE__*/React__default.createElement(FullDate, {
      ts: mts
    })));
  }
}, {
  key: KEYS$8.STATUS,
  getLabel: function getLabel() {
    return i18n.t('movements:status');
  }
}, {
  key: KEYS$8.AMOUNT,
  getLabel: function getLabel() {
    return i18n.t('movements:amount');
  },
  renderer: function renderer(_ref2) {
    var value = _ref2.value,
        data = _ref2.data;
    var currency = data.currency;
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PrettyValue, {
      value: Math.abs(value),
      decimals: getDecimalsForSymbol(currency)
    }), ' ', /*#__PURE__*/React__default.createElement("span", {
      className: TEXT_MUTED
    }, currency));
  }
}, {
  key: KEYS$8.TYPE,
  getLabel: function getLabel() {
    return i18n.t('movements:type');
  }
}];

var MovementListHeader = function MovementListHeader() {
  return /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, COLUMNS.map(function (_ref) {
    var key = _ref.key,
        getLabel = _ref.getLabel;
    return /*#__PURE__*/React__default.createElement("th", {
      key: key
    }, getLabel());
  })));
};

var MovementListHeader$1 = /*#__PURE__*/memo(MovementListHeader);

var MovementListRow = function MovementListRow(props) {
  var data = props.data,
      customMapping = props.rowMapping;
  var getDisplayValue = getValue({
    customMapping: customMapping,
    data: data
  });
  return /*#__PURE__*/React__default.createElement("tr", null, COLUMNS.map(function (_ref) {
    var key = _ref.key,
        defRenderer = _ref.renderer;
    var formattedValue = getDisplayValue(key);
    var value = getDisplayValue(key, false);

    var renderer = _get(customMapping, [key, 'renderer'], defRenderer);

    return /*#__PURE__*/React__default.createElement("td", {
      key: key
    }, renderer ? renderer({
      value: value,
      formattedValue: formattedValue,
      data: data
    }) : formattedValue);
  }));
};

MovementListRow.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object,
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING))
};
MovementListRow.defaultProps = {
  data: {},
  rowMapping: {}
};
var MovementListRow$1 = /*#__PURE__*/memo(MovementListRow);

var MovementList = function MovementList(props) {
  var movements = props.movements,
      rowMapping = props.rowMapping,
      className = props.className;
  var classes$1 = cx(MOVEMENT_LIST, className);
  var keyForId = getMappedKey(KEYS$8.ID, rowMapping);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes$1
  }, /*#__PURE__*/React__default.createElement("div", {
    className: TABLE_WRAPPER
  }, /*#__PURE__*/React__default.createElement(Table, {
    condensed: true,
    striped: true
  }, /*#__PURE__*/React__default.createElement(MovementListHeader$1, null), /*#__PURE__*/React__default.createElement("tbody", null, _map(movements, function (movement) {
    return /*#__PURE__*/React__default.createElement(MovementListRow$1, {
      key: _get(movement, keyForId),
      data: movement,
      rowMapping: rowMapping
    });
  })))));
};

MovementList.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  movements: PropTypes.arrayOf(PropTypes.object),
  rowMapping: PropTypes.objectOf(PropTypes.shape(DATA_MAPPING)),
  className: PropTypes.string
};
var defaultProps$e = {
  movements: {},
  rowMapping: {},
  className: null
};
MovementList.defaultProps = defaultProps$e;
var MovementList$1 = withI18nProvider( /*#__PURE__*/memo(MovementList));

var EditLayoutButton = function EditLayoutButton(props) {
  var layoutIsEditable = props.layoutIsEditable,
      enableEditLayout = props.enableEditLayout,
      closeEditLayout = props.closeEditLayout;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var label = layoutIsEditable ? 'close_edit' : 'edit_layout';

  var handleClick = function handleClick() {
    if (layoutIsEditable) {
      return closeEditLayout();
    }

    return enableEditLayout();
  };

  return /*#__PURE__*/React__default.createElement(DefaultComp, {
    small: true,
    minimal: true,
    onClick: handleClick,
    className: "edit-button"
  }, t("grid:".concat(label)));
};

EditLayoutButton.propTypes = {
  enableEditLayout: PropTypes.func,
  layoutIsEditable: PropTypes.bool,
  closeEditLayout: PropTypes.func
};
EditLayoutButton.defaultProps = {
  enableEditLayout: function enableEditLayout() {},
  layoutIsEditable: false,
  closeEditLayout: function closeEditLayout() {}
};
var EditLayoutButton$1 = withI18nProvider(EditLayoutButton);
export { KEYS$7 as BALANCES_KEYS, KEYS$6 as BOOK_KEYS, BOOK_VIZ_TYPES, Balances$1 as Balances, Book$1 as Book, Book_Toolbar as BookToolbar, DefaultComp as Button, Button_TradesToggle as ButtonTradesToggle, CcyUSDAmountInput$1 as CcyUSDAmountInput, Checkbox, classes as Classes, Column, CooldownButton$1 as CooldownButton, DATA_MAPPING, DateComponent as Date, UIDateTimePicker as DateTimePicker, DepositWallets$1 as DepositWallets, DepthChart$1 as DepthChart, DepthChart_Toolbar as DepthChartToolbar, Dialog, Dropdown, EditLayoutButton$1 as EditLayoutButton, ExternalLink$1 as ExternalLink, FadeTrailingZeros, FullDate, GRID_PADDING_X, GRID_PADDING_Y, Heading, Input, Intent, Label, KEYS as MARKETLIST_KEYS, KEYS$8 as MOVEMENTLIST_KEYS, MarketList$1 as MarketList, Menu, MenuDivider, MenuItem, MovementList$1 as MovementList, NOTICE_TYPES, Notice, Notifications$1 as Notifications, KEYS$5 as ORDERS_KEYS, KEYS$4 as ORDER_HISTORY_KEYS, ORDER_TYPES, OrderForm$1 as OrderForm, OrderHistory$1 as OrderHistory, Orders$1 as Orders, PROP_DEFAULT_CCYS, PROP_GRID_CONFIG, PROP_GRID_ITEM, PROP_LAYOUT_CONFIG, PrettyDate, PrettyValue, QRCode$1 as QRCode, QuickSwap$1 as QuickSwap, ResponsiveContext, ResponsiveState, Row, SortableButton as SortButton, Spinner$1 as Spinner, StoreProvider, TEXT_ALIGNMENT, KEYS$2 as TICKERLIST_KEYS, KEYS$1 as TICKER_KEYS, KEYS$3 as TRADES_KEYS, TRADE_PAGE_SIZE, TRADE_TYPES, TRADE_TYPES_ARR, Table, Tabs, Ticker$1 as Ticker, TickerList$1 as TickerList, Time, Tooltip, Trades$1 as Trades, VirtualTable$1 as VirtualTable, changeLanguage, getNiceWalletName, handleKeyboardEvent, i18n, initialiseI18n, useDebounce, useInterval, usePrevious, useSortableData, withHeightUpdate, withI18nProvider, ResponsiveWrapper as withResponsive };